/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: unspecified
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface ActivityAuditTrailDto {
    'activityId'?: string;
    'activityName'?: string;
    'assignee'?: string;
    'completedAt'?: string;
    'id'?: number;
    'processBusinessKey'?: string;
}
export interface AddNewVersionRequest {
    'scoringModelContent'?: string;
}
export interface AddNewVersionResponse {
    'id'?: number;
    'versionId'?: number;
}
export interface Address {
    'apartment'?: string;
    'city'?: string;
    'countryCode'?: string;
    'createdAt'?: string;
    'createdBy'?: string;
    'formattedAddress'?: string;
    'id'?: number;
    'postalCode'?: string;
    'rawAddress'?: { [key: string]: any; };
    'state'?: string;
    'streetAddress'?: string;
    'updatedAt'?: string;
    'updatedBy'?: string;
}
export interface AddressDto {
    'apartment'?: string;
    'city'?: string;
    'countryCode'?: string;
    'formattedAddress'?: string;
    'id'?: number;
    'postalCode'?: string;
    'rawAddress'?: { [key: string]: any; };
    'state'?: string;
    'streetAddress'?: string;
}
export interface AddressInbound {
    'apartment'?: string;
    'city': string;
    /**
     * ISO 3166-1 Alpha-2 code
     */
    'countryCode': string;
    'postalCode'?: string;
    'state'?: string;
    'streetAddress': string;
}
export interface Agent {
    'address'?: Address;
    'bankAccount'?: BankAccount;
    'contactDetails'?: { [key: string]: any; };
    'email': string;
    'extensions'?: { [key: string]: any; };
    'id'?: number;
    'legalName': string;
    'logo'?: Array<any>;
    'phone': string;
    'taxNumber': string;
    'website'?: string;
}
export interface AgentDto {
    'address'?: AddressDto;
    'bankAccount'?: BankAccountDto;
    'contactDetails'?: { [key: string]: any; };
    'email'?: string;
    'extensions'?: { [key: string]: any; };
    'id'?: number;
    'legalName'?: string;
    'logo'?: Array<any>;
    'phone'?: string;
    'taxNumber'?: string;
    'website'?: string;
}
export interface AgentSummaryDto {
    'email'?: string;
    'id'?: number;
    'legalName'?: string;
    'phone'?: string;
}
export interface AmortisationSchedulePeriod {
    'endDate'?: string;
    'id'?: number;
    'number'?: number;
    'paymentPeriod'?: boolean;
}
export interface AmortisationSchedulePeriodInstallmentDto {
    'daysInPeriod'?: number;
    'discountRateCoefficient'?: number;
    'endDate'?: string;
    'id'?: number;
    'interestAllocation'?: number;
    'multiplier'?: number;
    'number'?: number;
    'paymentAmount'?: number;
    'paymentPeriod'?: boolean;
    'principalAllocation'?: number;
    'principalDebtClosingBalance'?: number;
    'principalDebtOpeningBalance'?: number;
    'totalPaidInterest'?: number;
}
export interface AmortisationSchedulePeriodPdlDto {
    'endDate'?: string;
    'id'?: number;
    'interestBalance'?: number;
    'number'?: number;
    'operationAmount'?: number;
    'operationType'?: string;
    'outstandingBalance'?: number;
    'paymentPeriod'?: boolean;
    'principalBalance'?: number;
}
export interface AmortisationScheduleSnapshotDtoBrief {
    'amortisationSchedulePeriods'?: Array<AmortisationScheduleSnapshotDtoBriefAmortisationSchedulePeriodsInner>;
    'date'?: string;
    'eventId'?: number;
    'id'?: number;
    'loanId'?: number;
}
/**
 * @type AmortisationScheduleSnapshotDtoBriefAmortisationSchedulePeriodsInner
 */
export type AmortisationScheduleSnapshotDtoBriefAmortisationSchedulePeriodsInner = AmortisationSchedulePeriodInstallmentDto | AmortisationSchedulePeriodPdlDto;

export interface ApplicationForm {
    'collateralForm'?: Array<any>;
    'furtherInformationForm'?: Array<any>;
    'hasBalanceSheet'?: boolean;
    'hasBankStatement'?: boolean;
    'hasCollateral'?: boolean;
    'hasFinancialStatement'?: boolean;
    'hasFurtherInformation'?: boolean;
    'hasPnlStatement'?: boolean;
    'hasPurpose'?: boolean;
    'hasSupportingDocuments'?: boolean;
    'hasUtilityBill'?: boolean;
}
export interface BankAccount {
    'accountHolderName'?: string;
    'accountNumber'?: string;
    'bankTitle'?: string;
    'branch'?: string;
    'createdAt'?: string;
    'createdBy'?: string;
    'iban'?: string;
    'id'?: number;
    'maskedAccountNumber'?: string;
    'routingNumber'?: string;
    'sortCode'?: string;
    'type'?: string;
    'updatedAt'?: string;
    'updatedBy'?: string;
}
export interface BankAccountDto {
    'accountHolderName'?: string;
    'accountNumber'?: string;
    'bankTitle'?: string;
    'branch'?: string;
    'iban'?: string;
    'id'?: number;
    'maskedAccountNumber'?: string;
    'routingNumber'?: string;
    'sortCode'?: string;
    'type'?: string;
}
export interface BankAccountInbound {
    'accountNumber': string;
    'bankTitle'?: string;
}
export interface BillingCycleDtoBrief {
    'closingDate'?: string;
    'interestBalance'?: number;
    'paymentDate'?: string;
    'principalBalance'?: number;
    'startDate'?: string;
}
export interface Borrower {
    'address'?: Address;
    'bankAccount'?: BankAccount;
    'blacklisted': boolean;
    'borrowerSettings'?: BorrowerSettings;
    'createdAt'?: string;
    'createdBy'?: string;
    'email'?: string;
    'extensions'?: { [key: string]: any; };
    'fullName'?: string;
    'id'?: number;
    'phone'?: string;
    'taxNumber'?: string;
    'type'?: string;
    'updatedAt'?: string;
    'updatedBy'?: string;
}
export interface BorrowerDto {
    'type': string;
}
export interface BorrowerDtoBorrowerAllowed {
    'type': string;
}
export interface BorrowerDtoBrief {
    'type': string;
}
export interface BorrowerLoanManagement {
    'address': AddressInbound;
    'bankAccount': BankAccountInbound;
    'email': string;
    'phone': string;
    'taxNumber'?: string;
    'type'?: string;
}
export interface BorrowerRevisionDto {
    'borrower'?: BorrowerDtoBrief;
    'revisionDate'?: string;
    'revisionNumber'?: number;
    'revisionType'?: BorrowerRevisionDtoRevisionTypeEnum;
}

export const BorrowerRevisionDtoRevisionTypeEnum = {
    Unknown: 'UNKNOWN',
    Insert: 'INSERT',
    Update: 'UPDATE',
    Delete: 'DELETE'
} as const;

export type BorrowerRevisionDtoRevisionTypeEnum = typeof BorrowerRevisionDtoRevisionTypeEnum[keyof typeof BorrowerRevisionDtoRevisionTypeEnum];

export interface BorrowerSettings {
    'id'?: number;
    'language'?: string;
}
export interface BorrowerSettingsDto {
    'language'?: string;
}
export interface BorrowerSettingsResponse {
    'borrowerSettings'?: BorrowerSettingsDto;
}
export interface BulkRetryIncidentsResponse {
    'attemptToRetryQty'?: number;
}
export interface CallResultDto {
    'amount'?: number;
    'author'?: string;
    'calledAt'?: string;
    'comment'?: string;
    'createdAt'?: string;
    'id'?: number;
    'nextReminderDate'?: string;
    'promiseToPayDate'?: string;
    'result'?: string;
}
export interface Campaign {
    'active'?: boolean;
    'agents'?: Array<Agent>;
    'agreementTemplate'?: DocumentTemplate;
    'applicationForm'?: ApplicationForm;
    'calculationType'?: string;
    'collectionStrategy': string;
    'configurableFirstPaymentDate'?: boolean;
    'contractTemplate'?: DocumentTemplate;
    'createdAt'?: string;
    'createdBy'?: string;
    'creditBureauProvider'?: string;
    'daysOverdue'?: number;
    'disbursementOption': string;
    'drawdownFreeze'?: number;
    'giniMachineScoringModel'?: string;
    'id'?: number;
    'interestRateType': CampaignInterestRateTypeEnum;
    'loanType'?: CampaignLoanTypeEnum;
    'name'?: string;
    'parameters'?: CampaignParameters;
    'paymentFrequency'?: Array<any>;
    'rangeOfDaysForFirstPaymentDate'?: number;
    'scoringModel'?: string;
    'scoringProviders'?: Array<string>;
    'signingOption'?: string;
    /**
     * A date-based amount of time in the ISO-8601 calendar system.
     */
    'termPeriodType'?: string;
    'underwritingDecisionMaking': string;
    'updatedAt'?: string;
    'updatedBy'?: string;
    'verificationDecisionMaking': string;
}

export const CampaignInterestRateTypeEnum = {
    Fixed: 'FIXED',
    Floating: 'FLOATING'
} as const;

export type CampaignInterestRateTypeEnum = typeof CampaignInterestRateTypeEnum[keyof typeof CampaignInterestRateTypeEnum];
export const CampaignLoanTypeEnum = {
    FixedTerm: 'FIXED_TERM',
    CreditLine: 'CREDIT_LINE'
} as const;

export type CampaignLoanTypeEnum = typeof CampaignLoanTypeEnum[keyof typeof CampaignLoanTypeEnum];

export interface CampaignDto {
    'active'?: boolean;
    'agents'?: Array<AgentSummaryDto>;
    'agreementTemplate'?: DocumentTemplateDto;
    'applicationForm'?: ApplicationForm;
    'calculationType'?: string;
    'collectionStrategy'?: string;
    'configurableFirstPaymentDate'?: boolean;
    'contractTemplate'?: DocumentTemplateDto;
    'creditBureauProvider'?: string;
    'daysOverdue'?: number;
    'disbursementOption'?: string;
    'drawdownFreeze'?: number;
    'giniMachineScoringModel'?: string;
    'id'?: number;
    'interestRateType'?: CampaignDtoInterestRateTypeEnum;
    'loanType'?: string;
    'name'?: string;
    'parameters'?: CampaignParameters;
    'paymentFrequency'?: Array<string>;
    'rangeOfDaysForFirstPaymentDate'?: number;
    'scoringModel'?: string;
    'scoringProviders'?: Array<string>;
    'signingOption'?: string;
    'termPeriodType'?: string;
    'underwritingDecisionMaking'?: string;
    'verificationDecisionMaking'?: string;
}

export const CampaignDtoInterestRateTypeEnum = {
    Fixed: 'FIXED',
    Floating: 'FLOATING'
} as const;

export type CampaignDtoInterestRateTypeEnum = typeof CampaignDtoInterestRateTypeEnum[keyof typeof CampaignDtoInterestRateTypeEnum];

export interface CampaignDtoBrief {
    'active'?: boolean;
    'agents'?: Array<AgentSummaryDto>;
    'calculationType'?: string;
    'collectionStrategy'?: string;
    'configurableFirstPaymentDate'?: boolean;
    'creditBureauProvider'?: string;
    'daysOverdue'?: number;
    'disbursementOption'?: string;
    'drawdownFreeze'?: number;
    'giniMachineScoringModel'?: string;
    'id'?: number;
    'loanType'?: string;
    'name'?: string;
    'parameters'?: CampaignParameters;
    'paymentFrequency'?: Array<string>;
    'rangeOfDaysForFirstPaymentDate'?: number;
    'scoringModel'?: string;
    'scoringProviders'?: Array<string>;
    'signingOption'?: string;
    'termPeriodType'?: string;
    'underwritingDecisionMaking'?: string;
    'verificationDecisionMaking'?: string;
}
export interface CampaignParameters {
    'amountSelectionStep': number;
    /**
     * A date-based amount of time in the ISO-8601 calendar system.
     */
    'defaultPaymentFrequency'?: string;
    'interestRatePct': number;
    'marginPct'?: number;
    'maxAmount': number;
    'maxTerm': number;
    'minAmount': number;
    'minTerm': number;
    'termOptions'?: Array<TermOption>;
    'termSelectionMode': CampaignParametersTermSelectionModeEnum;
}

export const CampaignParametersTermSelectionModeEnum = {
    FixedStep: 'FIXED_STEP',
    PredefinedOptions: 'PREDEFINED_OPTIONS'
} as const;

export type CampaignParametersTermSelectionModeEnum = typeof CampaignParametersTermSelectionModeEnum[keyof typeof CampaignParametersTermSelectionModeEnum];

export interface Collateral {
    'createdAt'?: string;
    'createdBy'?: string;
    'description'?: string;
    'id'?: number;
    'item'?: { [key: string]: any; };
    'latestValuationDate'?: string;
    'nextValuationDate'?: string;
    'registrationDate'?: string;
    'registrationNumber'?: string;
    'supportingDocuments'?: Array<any>;
    'type'?: CollateralTypeEnum;
    'updatedAt'?: string;
    'updatedBy'?: string;
    'valuationDate'?: Collateral;
    'valuationPeriod'?: number;
    'value'?: number;
}

export const CollateralTypeEnum = {
    RealEstate: 'REAL_ESTATE',
    Vehicles: 'VEHICLES',
    EquipmentAndMachinery: 'EQUIPMENT_AND_MACHINERY',
    Securities: 'SECURITIES',
    Other: 'OTHER'
} as const;

export type CollateralTypeEnum = typeof CollateralTypeEnum[keyof typeof CollateralTypeEnum];

export interface CollateralDto {
    'collateralForm'?: Array<any>;
    'description'?: string;
    'id'?: number;
    'isLoanActive'?: boolean;
    'item'?: { [key: string]: any; };
    'latestValuationDate'?: string;
    'loanApplicationId'?: number;
    'loanId'?: number;
    'loanNumber'?: string;
    'nextValuationDate'?: string;
    'registrationDate'?: string;
    'registrationNumber'?: string;
    'supportingDocuments'?: Array<FileDto>;
    'type'?: CollateralDtoTypeEnum;
    'valuationPeriod'?: number;
    'value'?: number;
}

export const CollateralDtoTypeEnum = {
    RealEstate: 'REAL_ESTATE',
    Vehicles: 'VEHICLES',
    EquipmentAndMachinery: 'EQUIPMENT_AND_MACHINERY',
    Securities: 'SECURITIES',
    Other: 'OTHER'
} as const;

export type CollateralDtoTypeEnum = typeof CollateralDtoTypeEnum[keyof typeof CollateralDtoTypeEnum];

export interface CollectionDto {
    'callResults'?: Array<CallResultDto>;
    'id'?: number;
    'loan'?: GetAgentLoan200Response;
    'number'?: string;
    'promiseToPayDate'?: string;
    'startedAt'?: string;
    'status'?: string;
}
export interface CollectionItemDtoBrief {
    'borrowerFullName'?: string;
    'id'?: number;
    'number'?: string;
    'outstandingBalance'?: number;
    'startedAt'?: string;
    'status'?: string;
}
export interface CreateAgentRequest {
    'address'?: AddressDto;
    'bankAccount'?: BankAccountDto;
    'contactDetails'?: { [key: string]: any; };
    'email': string;
    'extensions'?: { [key: string]: any; };
    'legalName': string;
    'logo'?: Array<any>;
    'phone': string;
    'taxNumber': string;
    'website'?: string;
}
export interface CreateCampaignRequest {
    'active'?: boolean;
    'agents'?: Array<Agent>;
    'agreementTemplate'?: DocumentTemplateDto;
    'applicationForm'?: ApplicationForm;
    'calculationType'?: string;
    'collectionStrategy': string;
    'configurableFirstPaymentDate'?: boolean;
    'contractTemplate'?: DocumentTemplateDto;
    'creditBureauProvider'?: string;
    'daysOverdue'?: number;
    'disbursementOption': string;
    'drawdownFreeze'?: number;
    'giniMachineScoringModel'?: string;
    'interestRateType': CreateCampaignRequestInterestRateTypeEnum;
    'loanType'?: string;
    'name'?: string;
    'parameters'?: CampaignParameters;
    'paymentFrequency'?: Array<string>;
    'rangeOfDaysForFirstPaymentDate'?: number;
    'scoringModel'?: string;
    'scoringProviders'?: Array<string>;
    'signingOption'?: string;
    'termPeriodType'?: string;
    'underwritingDecisionMaking': string;
    'verificationDecisionMaking': string;
}

export const CreateCampaignRequestInterestRateTypeEnum = {
    Fixed: 'FIXED',
    Floating: 'FLOATING'
} as const;

export type CreateCampaignRequestInterestRateTypeEnum = typeof CreateCampaignRequestInterestRateTypeEnum[keyof typeof CreateCampaignRequestInterestRateTypeEnum];

export interface CreateLeadRequest {
    'agentId'?: number;
    'email': string;
    'firstName': string;
    'lastName': string;
    'phone': string;
}
export interface CreateLoanProductRequest {
    'active': boolean;
    'campaign': CampaignDto;
    'code': string;
    'defaultInterestRatePct': number;
    'description'?: string;
    'earlyRepaymentFeeRatePct': number;
    'establishmentFee'?: number;
    'graceInterestRatePct': number;
    'gracePeriodDays'?: number;
    'maxAmount': number;
    'maxInterestRatePct': number;
    'maxMarginPct'?: number;
    'maxTerm'?: number;
    'minAmount': number;
    'minInterestRatePct': number;
    'minMarginPct'?: number;
    'minTerm'?: number;
    'overduePenalty': number;
    'paymentFrequency'?: string;
    'serviceFeeRatePct'?: number;
}
export interface CreditBureauReport {
    'data'?: { [key: string]: any; };
    'score'?: { [key: string]: string; };
}
export interface CreditBureauReportDto {
    'data'?: { [key: string]: any; };
    'score'?: { [key: string]: string; };
}
export interface CreditLineDtoBrief {
    'active'?: boolean;
    'actualSnapshot'?: LoanSnapshotDtoBrief;
    'borrower'?: BorrowerDto;
    'debitedBankAccount'?: any;
    'endDate'?: string;
    'id'?: number;
    'interestRatePct'?: number;
    'issueDate'?: string;
    'loanApplication'?: LoanApplicationDtoBrief;
    'loanProduct'?: LoanProductDto;
    'maturityDate'?: string;
    'number'?: string;
    'status'?: string;
    'term'?: number;
    'type'?: string;
    'usedPrimeRatePct'?: number;
    'writeOffReason'?: string;
    'calculationType'?: string;
    'interestRateType'?: string;
    'marginRatePct'?: number;
    'nextPaymentDate'?: string;
    'billingCycles'?: Array<BillingCycleDtoBrief>;
    'creditLimit'?: number;
    'drawdownFreezeDate'?: string;
}
export interface Dashboard {
    'id'?: number;
    'name'?: string;
}
export interface DashboardsResponse {
    'dashboards'?: Array<Dashboard>;
}
export interface DeploymentRepresentation {
    'deploymentTime': string;
    'id': string;
    'name': string;
    'source': string;
    'tenantId'?: string;
}
export interface DocumentTemplate {
    'createdAt'?: string;
    'createdBy'?: string;
    'file'?: any;
    'id'?: number;
    'name': string;
    'type': string;
    'updatedAt'?: string;
    'updatedBy'?: string;
}
export interface DocumentTemplateDto {
    'campaignNames'?: Array<string>;
    'file'?: FileDto;
    'id'?: number;
    'name'?: string;
    'type'?: string;
    'updatedAt'?: string;
}
export interface EmbedDashboardResponse {
    'url'?: string;
}
export interface FileDto {
    'id'?: number;
    'originalName'?: string;
    'storage'?: string;
    'type'?: string;
    'url'?: string;
    'uuid'?: string;
}
export interface FileUploadResponse {
    'file'?: FileDto;
}
export interface FinancialFigures {
    'ebitda': number;
    'grossProfit': number;
    'id'?: number;
    'netDebt': number;
    'netIncome': number;
    'operatingProfit': number;
    'profitabilityRatios'?: ProfitabilityRatios;
    'revenue': number;
    'totalAssets': number;
    'totalLiabilities': number;
    'totalSales': number;
}
export interface FinancialFiguresDto {
    'ebitda'?: number;
    'grossProfit'?: number;
    'id'?: number;
    'netDebt'?: number;
    'netIncome'?: number;
    'operatingProfit'?: number;
    'profitabilityRatios'?: ProfitabilityRatiosDto;
    'revenue'?: number;
    'totalAssets'?: number;
    'totalLiabilities'?: number;
    'totalSales'?: number;
}
export interface FixedTermLoanDtoBrief {
    'active'?: boolean;
    'actualSnapshot'?: LoanSnapshotDtoBrief;
    'borrower'?: BorrowerDto;
    'debitedBankAccount'?: any;
    'endDate'?: string;
    'id'?: number;
    'interestRatePct'?: number;
    'issueDate'?: string;
    'loanApplication'?: LoanApplicationDtoBrief;
    'loanProduct'?: LoanProductDto;
    'maturityDate'?: string;
    'number'?: string;
    'status'?: string;
    'term'?: number;
    'type'?: string;
    'usedPrimeRatePct'?: number;
    'writeOffReason'?: string;
    'calculationType'?: string;
    'interestRateType'?: string;
    'marginRatePct'?: number;
    'nextPaymentDate'?: string;
    'actualAmortisationScheduleSnapshot'?: AmortisationScheduleSnapshotDtoBrief;
}
/**
 * @type GetAgentLoan200Response
 */
export type GetAgentLoan200Response = CreditLineDtoBrief | FixedTermLoanDtoBrief;

export interface GiniMachineScoringModel {
    'id'?: string;
    'name'?: string;
}
export interface IdDocument {
    'attachments'?: Array<any>;
    'expirationDate': string;
    'id'?: number;
    'issueDate'?: string;
    'number'?: string;
    'type'?: string;
}
export interface IdDocumentDto {
    'attachments'?: Array<any>;
    'expirationDate': string;
    'issueDate'?: string;
    'number'?: string;
    'type'?: string;
}
export interface IdDocumentLoanManagement {
    'expirationDate': string;
    'issueDate': string;
    'number': string;
    'type': IdDocumentLoanManagementTypeEnum;
}

export const IdDocumentLoanManagementTypeEnum = {
    Passport: 'PASSPORT',
    IdCard: 'ID_CARD',
    DriverLicense: 'DRIVER_LICENSE'
} as const;

export type IdDocumentLoanManagementTypeEnum = typeof IdDocumentLoanManagementTypeEnum[keyof typeof IdDocumentLoanManagementTypeEnum];

export interface IdDocumentLoanOrigination {
    'expirationDate': string;
    'issueDate': string;
    'number': string;
    'type': IdDocumentLoanOriginationTypeEnum;
}

export const IdDocumentLoanOriginationTypeEnum = {
    Passport: 'PASSPORT',
    IdCard: 'ID_CARD',
    DriverLicense: 'DRIVER_LICENSE'
} as const;

export type IdDocumentLoanOriginationTypeEnum = typeof IdDocumentLoanOriginationTypeEnum[keyof typeof IdDocumentLoanOriginationTypeEnum];

export interface InterestRateSettingsDto {
    'primeRateEffectiveDate'?: string;
    'primeRatePct'?: number;
}
export interface InterestRateSettingsResponse {
    'interestRateSettings'?: InterestRateSettingsDto;
}
export interface InternalScoringModelDto {
    'borrowerType'?: string;
    'id'?: number;
    'key'?: string;
}
export interface KycResults {
    'createdAt'?: string;
    'details'?: { [key: string]: any; };
    'id'?: number;
    'providerName'?: string;
}
export interface KycResultsDto {
    'createdAt'?: string;
    'details'?: { [key: string]: any; };
    'providerName'?: string;
}
export interface LandingCalculatorSettingsResponse {
    'amountSelectionStep'?: number;
    'maxAmount'?: number;
    'maxTerm'?: number;
    'minAmount'?: number;
    'minTerm'?: number;
    'periodType'?: string;
}
export interface LandingPageSettingsDto {
    'amountSelectionStep'?: number;
    'calculationType'?: string;
    'interestRatePct'?: number;
    'maxAmount'?: number;
    'maxTerm'?: number;
    'minAmount'?: number;
    'minTerm'?: number;
    'paymentFrequency'?: string;
    'periodType'?: string;
}
export interface LandingPageSettingsRequest {
    'landingPageSettings'?: LandingPageSettingsDto;
}
export interface LandingPageSettingsResponse {
    'landingPageSettings'?: LandingPageSettingsDto;
}
export interface LeadDto {
    'agentId'?: number;
    'email'?: string;
    'firstName'?: string;
    'fullName'?: string;
    'id'?: number;
    'lastName'?: string;
    'phone'?: string;
}
export interface LeadDtoBrief {
    'agentId'?: number;
    'email'?: string;
    'firstName'?: string;
    'fullName'?: string;
    'id'?: number;
    'lastName'?: string;
    'phone'?: string;
}
export interface LegalEntity extends Borrower {
    'corporateType'?: string;
    'financialInformation'?: { [key: string]: any; };
    'industry'?: string;
    'legalName'?: string;
    'monthsInOperation'?: number;
    'registrationDate'?: string;
    'registrationNumber'?: string;
    'representative'?: Representative;
    'website'?: string;
}
export interface LegalEntityLoanManagement {
    'address': AddressInbound;
    'bankAccount': BankAccountInbound;
    'email': string;
    'phone': string;
    'taxNumber'?: string;
    'type'?: string;
    /**
     * Marketing legal entity name
     */
    'fullName': string;
    'legalName': string;
    'registrationDate'?: string;
    'registrationNumber': string;
}
export interface LegalEntityLoanOrigination {
    'address': AddressInbound;
    'annualRevenue'?: number;
    'bankAccount': BankAccountInbound;
    /**
     * Available values: #{deploymentController.getLatestJsonResource(\'public/data/corporate-type.json\', \'$.[*].value\')}
     */
    'corporateType'?: string;
    'email': string;
    /**
     * Marketing legal entity name
     */
    'fullName': string;
    /**
     * Available values: #{deploymentController.getLatestJsonResource(\'public/data/industry.json\', \'$.[*].value\')}
     */
    'industry'?: string;
    'legalName': string;
    'monthsInOperation'?: number;
    'phone': string;
    'registrationDate': string;
    'registrationNumber': string;
    /**
     * A person representing the legal entity
     */
    'representative': RepresentativeLoanOrigination;
    'taxNumber'?: string;
}
export interface LicenseActivationRequest {
    'content': string;
}
export interface LicenseResponse {
    'activeLicenseInfo'?: { [key: string]: any; };
}
export interface Link {
    'href'?: string;
    'templated'?: boolean;
}
export interface LoanAdjustmentsRequestDtoBorrowerAllowed {
    'agreement'?: any;
    'attachments'?: Array<any>;
    'closedAt'?: string;
    'customDeclineReason'?: string;
    'decisionedBy'?: string;
    'declineCode'?: string;
    'description'?: string;
    'id'?: string;
    'number'?: number;
    'requestedAt'?: string;
    'restructuringOption'?: LoanAdjustmentsRequestDtoBorrowerAllowedRestructuringOptionEnum;
    'status'?: string;
}

export const LoanAdjustmentsRequestDtoBorrowerAllowedRestructuringOptionEnum = {
    ExtendMaturityDate: 'EXTEND_MATURITY_DATE',
    AmendInterestRate: 'AMEND_INTEREST_RATE',
    ApplyPaymentHoliday: 'APPLY_PAYMENT_HOLIDAY'
} as const;

export type LoanAdjustmentsRequestDtoBorrowerAllowedRestructuringOptionEnum = typeof LoanAdjustmentsRequestDtoBorrowerAllowedRestructuringOptionEnum[keyof typeof LoanAdjustmentsRequestDtoBorrowerAllowedRestructuringOptionEnum];

export interface LoanAgreementDto {
    'closedAt'?: string;
    'fileUuid'?: string;
    'name'?: string;
    'restructuringOption'?: string;
}
export interface LoanApplication {
    'active'?: boolean;
    'actualLoanProduct'?: LoanProduct;
    'agentId'?: number;
    'amortisationSchedule'?: Array<AmortisationSchedulePeriod>;
    'amountApproved'?: number;
    'amountRequested': number;
    'approvedBy'?: string;
    'attachments'?: { [key: string]: any; };
    'bankAccountVerification'?: { [key: string]: any; };
    'borrower'?: LoanApplicationBorrower;
    'calculationType'?: string;
    'campaign'?: Campaign;
    'cancelCode'?: string;
    'closedAt'?: string;
    'collateral'?: Collateral;
    'complianceInfo'?: { [key: string]: any; };
    'contract'?: any;
    'contractOtpCode'?: string;
    'contractSignedAt'?: string;
    'createdAt'?: string;
    'createdBy'?: string;
    'creditBureauReport'?: CreditBureauReport;
    'creditLimit'?: number;
    'declineCode'?: string;
    'declined'?: boolean;
    'declinedBy'?: string;
    'disbursementAmount'?: number;
    'extensions'?: { [key: string]: any; };
    'financialFigures'?: FinancialFigures;
    'firstPaymentDate'?: string;
    'furtherInformation'?: { [key: string]: any; };
    'id'?: number;
    'interestRateApproved'?: number;
    'interestRateApprovedPct'?: number;
    'loanProduct'?: LoanProduct;
    'ltvPct'?: number;
    'number'?: string;
    /**
     * A date-based amount of time in the ISO 8601 calendar system.
     */
    'paymentFrequency'?: string;
    'requestedAt': string;
    'scoring'?: Scoring;
    'serviceFee'?: number;
    'status'?: string;
    'stopFactors'?: Array<string>;
    'termApproved'?: number;
    /**
     * A date-based amount of time in the ISO 8601 calendar system.
     */
    'termPeriodType'?: string;
    'termRequested': number;
    'totalToPay'?: number;
    'updatedAt'?: string;
    'updatedBy'?: string;
    'usedPrimeRatePct'?: number;
    'validationResult'?: { [key: string]: any; };
}
/**
 * @type LoanApplicationBorrower
 */
export type LoanApplicationBorrower = LegalEntity | Person;

export interface LoanApplicationDto {
    'active'?: boolean;
    'actualBorrower'?: BorrowerDto;
    'actualLoanProduct'?: LoanProductDto;
    'agentId'?: number;
    'amortisationSchedule'?: Array<AmortisationScheduleSnapshotDtoBriefAmortisationSchedulePeriodsInner>;
    'amountApproved'?: number;
    'amountRequested'?: number;
    'approvedBy'?: string;
    'attachments'?: { [key: string]: any; };
    'bankAccountVerification'?: { [key: string]: any; };
    'borrower'?: BorrowerDto;
    'calculationType'?: string;
    'campaign'?: CampaignDto;
    'cancelCode'?: string;
    'closedAt'?: string;
    'collateral'?: CollateralDto;
    'complianceInfo'?: { [key: string]: any; };
    'contract'?: FileDto;
    'contractOtpCode'?: string;
    'contractSignedAt'?: string;
    'creditBureauReport'?: CreditBureauReportDto;
    'creditLimit'?: number;
    'declineCode'?: string;
    'declined'?: boolean;
    'declinedBy'?: string;
    'disbursementAmount'?: number;
    'extensions'?: { [key: string]: any; };
    'financialFigures'?: FinancialFiguresDto;
    'firstPaymentDate'?: string;
    'furtherInformation'?: { [key: string]: any; };
    'id'?: number;
    'interestRateApprovedPct'?: number;
    'loanProduct'?: LoanProductDto;
    'ltvPct'?: number;
    'number'?: string;
    'paymentFrequency'?: string;
    'requestedAt'?: string;
    'scoring'?: ScoringDto;
    'serviceFee'?: number;
    'status'?: string;
    'stopFactors'?: Array<string>;
    'termApproved'?: number;
    'termPeriodType'?: string;
    'termRequested'?: number;
    'totalToPay'?: number;
    'usedPrimeRatePct'?: number;
    'validationResult'?: { [key: string]: any; };
}
export interface LoanApplicationDtoBorrowerAllowed {
    'active'?: boolean;
    'actualLoanProduct'?: LoanProductDto;
    'agentId'?: number;
    'amortisationSchedule'?: Array<AmortisationScheduleSnapshotDtoBriefAmortisationSchedulePeriodsInner>;
    'amountApproved'?: number;
    'amountRequested'?: number;
    'approvedBy'?: string;
    'attachments'?: { [key: string]: any; };
    'bankAccountVerification'?: { [key: string]: any; };
    'calculationType'?: string;
    'campaign'?: CampaignDto;
    'cancelCode'?: string;
    'closedAt'?: string;
    'collateral'?: CollateralDto;
    'complianceInfo'?: { [key: string]: any; };
    'contract'?: FileDto;
    'contractOtpCode'?: string;
    'contractSignedAt'?: string;
    'creditBureauReport'?: CreditBureauReportDto;
    'creditLimit'?: number;
    'declineCode'?: string;
    'declined'?: boolean;
    'declinedBy'?: string;
    'disbursementAmount'?: number;
    'extensions'?: { [key: string]: any; };
    'financialFigures'?: FinancialFiguresDto;
    'firstPaymentDate'?: string;
    'furtherInformation'?: { [key: string]: any; };
    'id'?: number;
    'interestRateApprovedPct'?: number;
    'loanProduct'?: LoanProductDto;
    'ltvPct'?: number;
    'number'?: string;
    'paymentFrequency'?: string;
    'requestedAt'?: string;
    'scoring'?: ScoringDto;
    'serviceFee'?: number;
    'status'?: string;
    'stopFactors'?: Array<string>;
    'termApproved'?: number;
    'termPeriodType'?: string;
    'termRequested'?: number;
    'totalToPay'?: number;
    'usedPrimeRatePct'?: number;
    'validationResult'?: { [key: string]: any; };
}
export interface LoanApplicationDtoBrief {
    'active'?: boolean;
    'actualBorrower'?: BorrowerDto;
    'agentId'?: number;
    'amountApproved'?: number;
    'amountRequested'?: number;
    'approvedBy'?: string;
    'bankAccountVerification'?: { [key: string]: any; };
    'borrower'?: BorrowerDto;
    'calculationType'?: string;
    'campaign'?: CampaignDto;
    'cancelCode'?: string;
    'closedAt'?: string;
    'contractOtpCode'?: string;
    'contractSignedAt'?: string;
    'creditBureauReport'?: CreditBureauReportDto;
    'creditLimit'?: number;
    'declineCode'?: string;
    'declined'?: boolean;
    'declinedBy'?: string;
    'extensions'?: { [key: string]: any; };
    'financialFigures'?: FinancialFiguresDto;
    'id'?: number;
    'interestRateApprovedPct'?: number;
    'loanProduct'?: LoanProductDto;
    'ltvPct'?: number;
    'number'?: string;
    'requestedAt'?: string;
    'scoring'?: ScoringDto;
    'status'?: string;
    'stopFactors'?: Array<string>;
    'termApproved'?: number;
    'termPeriodType'?: string;
    'termRequested'?: number;
    'totalToPay'?: number;
    'validationResult'?: { [key: string]: any; };
}
export interface LoanDto {
    'active'?: boolean;
    'actualSnapshot'?: LoanSnapshotDtoBrief;
    'borrower'?: BorrowerDto;
    'calculationType'?: string;
    'debitedBankAccount'?: any;
    'endDate'?: string;
    'id'?: number;
    'interestRatePct'?: number;
    'interestRateType'?: string;
    'issueDate'?: string;
    'loanApplication'?: LoanApplicationDtoBrief;
    'loanProduct'?: LoanProductDto;
    'marginRatePct'?: number;
    'maturityDate'?: string;
    'nextPaymentDate'?: string;
    'number'?: string;
    'status'?: string;
    'term'?: number;
    'type'?: string;
    'usedPrimeRatePct'?: number;
    'writeOffReason'?: string;
}
export interface LoanDtoBorrowerAllowed {
    'active'?: boolean;
    'actualSnapshot'?: LoanSnapshotDtoBrief;
    'calculationType'?: string;
    'debitedBankAccount'?: any;
    'endDate'?: string;
    'id'?: number;
    'interestRatePct'?: number;
    'interestRateType'?: string;
    'issueDate'?: string;
    'loanApplication'?: LoanApplicationDtoBrief;
    'loanProduct'?: LoanProductDto;
    'marginRatePct'?: number;
    'maturityDate'?: string;
    'nextPaymentDate'?: string;
    'number'?: string;
    'status'?: string;
    'term'?: number;
    'type'?: string;
    'usedPrimeRatePct'?: number;
    'writeOffReason'?: string;
}
export interface LoanDtoBrief {
    'active'?: boolean;
    'actualSnapshot'?: LoanSnapshotDtoBrief;
    'borrower'?: BorrowerDto;
    'debitedBankAccount'?: any;
    'endDate'?: string;
    'id'?: number;
    'interestRatePct'?: number;
    'issueDate'?: string;
    'loanApplication'?: LoanApplicationDtoBrief;
    'loanProduct'?: LoanProductDto;
    'maturityDate'?: string;
    'number'?: string;
    'status'?: string;
    'term'?: number;
    'type'?: string;
    'usedPrimeRatePct'?: number;
    'writeOffReason'?: string;
}
export interface LoanOperationDto {
    'amount'?: number;
    'attachments'?: Array<any>;
    'createdAt'?: string;
    'date'?: string;
    'id'?: number;
    'loan'?: GetAgentLoan200Response;
    'snapshot'?: LoanSnapshotDto;
    'type'?: string;
}
export interface LoanPreconditionsDto {
    'firstPayment'?: number;
    'totalInterest'?: number;
    'totalToPay'?: number;
}
export interface LoanPreconditionsResponse {
    'preconditions'?: LoanPreconditionsDto;
}
export interface LoanProduct {
    'active': boolean;
    'campaign': Campaign;
    'code': string;
    'createdAt'?: string;
    'createdBy'?: string;
    'defaultInterestRate'?: number;
    'defaultInterestRatePct': number;
    'description'?: string;
    'earlyRepaymentFeeRate'?: number;
    'earlyRepaymentFeeRatePct': number;
    'establishmentFee'?: number;
    'graceInterestRate'?: number;
    'graceInterestRatePct': number;
    'gracePeriodDays': number;
    'id'?: number;
    'maxAmount': number;
    'maxInterestRatePct': number;
    'maxMarginPct'?: number;
    'maxTerm': number;
    'minAmount': number;
    'minInterestRatePct': number;
    'minMarginPct'?: number;
    'minTerm': number;
    'overduePenalty': number;
    /**
     * A date-based amount of time in the ISO-8601 calendar system.
     */
    'paymentFrequency'?: string;
    'serviceFeeRate'?: number;
    'serviceFeeRatePct'?: number;
    /**
     * A date-based amount of time in the ISO-8601 calendar system.
     */
    'termPeriodType': string;
    'updatedAt'?: string;
    'updatedBy'?: string;
}
export interface LoanProductDto {
    'active'?: boolean;
    'campaign'?: CampaignDto;
    'code'?: string;
    'defaultInterestRatePct'?: number;
    'description'?: string;
    'earlyRepaymentFeeRatePct'?: number;
    'establishmentFee'?: number;
    'graceInterestRatePct'?: number;
    'gracePeriodDays'?: number;
    'id'?: number;
    'maxAmount'?: number;
    'maxInterestRatePct'?: number;
    'maxMarginPct'?: number;
    'maxTerm'?: number;
    'minAmount'?: number;
    'minInterestRatePct'?: number;
    'minMarginPct'?: number;
    'minTerm'?: number;
    'overduePenalty'?: number;
    'paymentFrequency'?: string;
    'serviceFeeRate'?: number;
    'serviceFeeRatePct'?: number;
    'termPeriodType'?: string;
    'updatedBy'?: string;
}
export interface LoanProductLoanManagement {
    /**
     * Type of calculation on which the amortisation schedule will be calculated.
     */
    'calculationType': LoanProductLoanManagementCalculationTypeEnum;
    /**
     * Product name.
     */
    'code': string;
    /**
     * The name of collection strategy
     */
    'collectionStrategy': LoanProductLoanManagementCollectionStrategyEnum;
    /**
     * Days in overdue before collection starts. Not specified for \'None\' collection strategy
     */
    'daysOverdue'?: number;
    /**
     * Default interest rate measured as a percentage. Used when a loan is overdue
     */
    'defaultInterestRatePct': number;
    /**
     * Disbursement option on which the disbursement provider will be selected.
     */
    'disbursementOption': LoanProductLoanManagementDisbursementOptionEnum;
    /**
     * The fee that is charged if the payment is repaid before the scheduled payment date, measured as a percentage.
     */
    'earlyRepaymentFeeRatePct': number;
    /**
     * The establishment fee that will be charged before the loan is disbursed, measured as an absolute value
     */
    'establishmentFee': number;
    /**
     * Interest rate during the grace period, measured as a percentage.
     */
    'graceInterestRatePct': number;
    /**
     * Days in grace period.
     */
    'gracePeriodDays': number;
    /**
     * The penalty that is charged when a loan becomes overdue.
     */
    'overduePenalty': number;
    /**
     * Frequency with which the payment will be made. Value is allowed only for \'Annuity instalment\' and \'Linear principal repayment instalment\' calculation types
     */
    'paymentFrequency'?: LoanProductLoanManagementPaymentFrequencyEnum;
    /**
     * The service fee that will be charged before the loan is disbursed, measured as a percentage
     */
    'serviceFeeRatePct': number;
    /**
     * The unit of measure in which the loan term is set. \'DAYS\' value is allowed only for \'PDL\' calculation type
     */
    'termPeriodType': LoanProductLoanManagementTermPeriodTypeEnum;
}

export const LoanProductLoanManagementCalculationTypeEnum = {
    Pdl: 'PDL',
    AnnuityInstallment: 'ANNUITY_INSTALLMENT',
    LinearPrincipalRepayment: 'LINEAR_PRINCIPAL_REPAYMENT'
} as const;

export type LoanProductLoanManagementCalculationTypeEnum = typeof LoanProductLoanManagementCalculationTypeEnum[keyof typeof LoanProductLoanManagementCalculationTypeEnum];
export const LoanProductLoanManagementCollectionStrategyEnum = {
    None: 'NONE',
    Default: 'DEFAULT'
} as const;

export type LoanProductLoanManagementCollectionStrategyEnum = typeof LoanProductLoanManagementCollectionStrategyEnum[keyof typeof LoanProductLoanManagementCollectionStrategyEnum];
export const LoanProductLoanManagementDisbursementOptionEnum = {
    Manual: 'MANUAL',
    Automatic: 'AUTOMATIC'
} as const;

export type LoanProductLoanManagementDisbursementOptionEnum = typeof LoanProductLoanManagementDisbursementOptionEnum[keyof typeof LoanProductLoanManagementDisbursementOptionEnum];
export const LoanProductLoanManagementPaymentFrequencyEnum = {
    Weekly: 'WEEKLY',
    Fortnightly: 'FORTNIGHTLY',
    Monthly: 'MONTHLY',
    Quarterly: 'QUARTERLY'
} as const;

export type LoanProductLoanManagementPaymentFrequencyEnum = typeof LoanProductLoanManagementPaymentFrequencyEnum[keyof typeof LoanProductLoanManagementPaymentFrequencyEnum];
export const LoanProductLoanManagementTermPeriodTypeEnum = {
    Days: 'DAYS',
    Weeks: 'WEEKS',
    Months: 'MONTHS',
    Years: 'YEARS'
} as const;

export type LoanProductLoanManagementTermPeriodTypeEnum = typeof LoanProductLoanManagementTermPeriodTypeEnum[keyof typeof LoanProductLoanManagementTermPeriodTypeEnum];

export interface LoanProductRevisionDto {
    'entity'?: LoanProductDto;
    'revisionInstant'?: string;
    'revisionNumber'?: number;
    'revisionType'?: LoanProductRevisionDtoRevisionTypeEnum;
}

export const LoanProductRevisionDtoRevisionTypeEnum = {
    Unknown: 'UNKNOWN',
    Insert: 'INSERT',
    Update: 'UPDATE',
    Delete: 'DELETE'
} as const;

export type LoanProductRevisionDtoRevisionTypeEnum = typeof LoanProductRevisionDtoRevisionTypeEnum[keyof typeof LoanProductRevisionDtoRevisionTypeEnum];

export interface LoanSnapshotDto {
    'availableCreditLimit'?: number;
    'createdAt'?: string;
    'date'?: string;
    'daysInOverdue'?: number;
    'defaultInterestBalance'?: number;
    'earlyRepaymentFee'?: number;
    'fullRepaymentAmount'?: number;
    'id'?: number;
    'interestBalance'?: number;
    'interestOverdue'?: number;
    'nextPaymentAmount'?: number;
    'outstandingBalance'?: number;
    'outstandingLtvPct'?: number;
    'overdueAmount'?: number;
    'overdueDate'?: string;
    'penalties'?: number;
    'principalBalance'?: number;
    'principalOverdue'?: number;
    'technicalAccount'?: number;
}
export interface LoanSnapshotDtoBrief {
    'availableCreditLimit'?: number;
    'createdAt'?: string;
    'date'?: string;
    'daysInOverdue'?: number;
    'defaultInterestBalance'?: number;
    'earlyRepaymentFee'?: number;
    'fullRepaymentAmount'?: number;
    'id'?: number;
    'interestBalance'?: number;
    'interestOverdue'?: number;
    'nextPaymentAmount'?: number;
    'outstandingBalance'?: number;
    'outstandingLtvPct'?: number;
    'overdueAmount'?: number;
    'overdueDate'?: string;
    'penalties'?: number;
    'principalBalance'?: number;
    'principalOverdue'?: number;
    'technicalAccount'?: number;
}
export interface ModelFile {
    'attached'?: boolean;
    'id'?: number;
    'name'?: string;
    'originalName'?: string;
    'storage'?: string;
    'type'?: string;
    'url'?: string;
    'uuid'?: string;
}
export interface NotificationTemplateDto {
    'body'?: string;
    'channel'?: string;
    'createdAt'?: string;
    'event'?: string;
    'eventCode'?: string;
    'id'?: number;
    'localization'?: string;
    'signature'?: string;
    'subject'?: string;
    'updatedAt'?: string;
    'updatedBy'?: string;
}
export interface NotificationTemplateRequest {
    'body': string;
    'channel'?: string;
    'event'?: string;
    'eventCode'?: string;
    'localization'?: string;
    'signature': string;
    'subject'?: string;
}
export interface PageActivityAuditTrailDto {
    'content'?: Array<ActivityAuditTrailDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageAgentSummaryDto {
    'content'?: Array<AgentSummaryDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageBorrowerDtoBrief {
    'content'?: Array<BorrowerDtoBrief>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageBorrowerRevisionDto {
    'content'?: Array<BorrowerRevisionDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageCampaignDtoBrief {
    'content'?: Array<CampaignDtoBrief>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageCollateralDto {
    'content'?: Array<CollateralDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageCollectionItemDtoBrief {
    'content'?: Array<CollectionItemDtoBrief>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageDocumentTemplateDto {
    'content'?: Array<DocumentTemplateDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageLeadDtoBrief {
    'content'?: Array<LeadDtoBrief>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageLoanAdjustmentsRequestDtoBorrowerAllowed {
    'content'?: Array<LoanAdjustmentsRequestDtoBorrowerAllowed>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageLoanApplicationDtoBorrowerAllowed {
    'content'?: Array<LoanApplicationDtoBrief>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageLoanApplicationDtoBrief {
    'content'?: Array<LoanApplicationDtoBrief>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageLoanDtoBorrowerAllowed {
    'content'?: Array<GetAgentLoan200Response>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageLoanDtoBrief {
    'content'?: Array<GetAgentLoan200Response>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageLoanOperationDto {
    'content'?: Array<LoanOperationDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageLoanProductDto {
    'content'?: Array<LoanProductDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageLoanProductRevisionDto {
    'content'?: Array<LoanProductRevisionDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageNotificationTemplateDto {
    'content'?: Array<NotificationTemplateDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageScoringModelVersionSettingsDto {
    'content'?: Array<ScoringModelVersionSettingsDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageTaskRepresentation {
    'content'?: Array<TaskRepresentation>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageTransactionDtoBorrowerAllowed {
    'content'?: Array<TransactionDtoBrief>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageTransactionDtoBrief {
    'content'?: Array<TransactionDtoBrief>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageUser {
    'content'?: Array<User>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObjectBrief;
    'size'?: number;
    'sort'?: SortObjectBrief;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageableObjectBrief {
    'offset'?: number;
    'pageNumber'?: number;
    'pageSize'?: number;
    'paged'?: boolean;
    'sort'?: SortObjectBrief;
    'unpaged'?: boolean;
}
export interface Person extends Borrower {
    'birthDate'?: string;
    'citizenship'?: string;
    'currentAge'?: number;
    'details'?: { [key: string]: any; };
    'firstName'?: string;
    'gender'?: string;
    'idDocument'?: IdDocument;
    'kycResults'?: KycResults;
    'lastName'?: string;
    'middleName'?: string;
    'nationalId'?: string;
    'numberOfDependents'?: number;
    'title'?: string;
}
export interface PersonLoanManagement {
    'address': AddressInbound;
    'bankAccount': BankAccountInbound;
    'email': string;
    'phone': string;
    'taxNumber'?: string;
    'type'?: string;
    'birthDate': string;
    /**
     * ISO 3166-1 Alpha-3 code. Available values: #{deploymentController.getLatestJsonResource(\'public/data/country.json\', \'$.[*].value\')}
     */
    'citizenship'?: string;
    'firstName': string;
    'idDocument': IdDocumentLoanManagement;
    'lastName': string;
    'middleName'?: string;
}
export interface PersonLoanOrigination {
    'address': AddressInbound;
    'bankAccount': BankAccountInbound;
    'birthDate': string;
    /**
     * ISO 3166-1 Alpha-3 code. Available values: #{deploymentController.getLatestJsonResource(\'public/data/country.json\', \'$.[*].value\')}
     */
    'citizenship'?: string;
    /**
     * Available values: #{deploymentController.getLatestJsonResource(\'public/data/borrower-education.json\', \'$.[*].value\')}
     */
    'education'?: string;
    'email': string;
    'firstName': string;
    'idDocument': IdDocumentLoanOrigination;
    /**
     * Available values: #{deploymentController.getLatestJsonResource(\'public/data/industry.json\', \'$.[*].value\')}
     */
    'industry'?: string;
    'lastName': string;
    /**
     * Available values: #{deploymentController.getLatestJsonResource(\'public/data/borrower-length-of-employment.json\', \'$.[*].value\')}
     */
    'lengthOfEmployment'?: string;
    /**
     * Available values: #{deploymentController.getLatestJsonResource(\'public/data/borrower-marital-status.json\', \'$.[*].value\')}
     */
    'maritalStatus'?: string;
    'middleName'?: string;
    'monthlyIncome'?: number;
    'phone': string;
    /**
     * Borrower\'s current job position. Available values: #{deploymentController.getLatestJsonResource(\'public/data/position.json\', \'$.[*].value\')}
     */
    'position'?: string;
    /**
     * Flag indicating whether the borrower has a property
     */
    'property'?: boolean;
    'taxNumber'?: string;
    /**
     * Flag indicating whether the borrower has a vehicle
     */
    'vehicle'?: boolean;
}
export interface ProcessDefinitionRepresentation {
    'category'?: string;
    'deploymentId': string;
    'description'?: string;
    'diagram': string;
    'extensions'?: { [key: string]: any; };
    'historyTimeToLive'?: number;
    'id': string;
    'key': string;
    'name': string;
    'resource'?: string;
    'startFormKey'?: string;
    'startableInTasklist'?: boolean;
    'suspended': boolean;
    'tenantId'?: string;
    'version'?: number;
    'versionTag'?: string;
}
export interface ProfitabilityRatios {
    'ebitdaMargin': number;
    'grossProfitMargin': number;
    'id'?: number;
    'netDebtToEbitda': number;
    'netProfitMargin': number;
    'netWorthToTotalAssets': number;
    'operatingProfitMargin': number;
}
export interface ProfitabilityRatiosDto {
    'ebitdaMargin'?: number;
    'grossProfitMargin'?: number;
    'id'?: number;
    'netDebtToEbitda'?: number;
    'netProfitMargin'?: number;
    'netWorthToTotalAssets'?: number;
    'operatingProfitMargin'?: number;
}
export interface Representative {
    'id'?: number;
    'person': Person;
    'position': string;
}
export interface RepresentativeDto {
    'id'?: number;
    'person': UpdatePersonRequest;
    'position': string;
}
export interface RepresentativeLoanOrigination {
    'birthDate': string;
    'email': string;
    'firstName': string;
    'idDocument': IdDocumentLoanOrigination;
    'lastName': string;
    'middleName'?: string;
    /**
     * Representative\'s current job position
     */
    'position': string;
}
/**
 * The loan application is used to make a decision on originating a loan
 */
export interface RequestLegalEntityLoanOrigination {
    /**
     * The amount for which the loan is requested
     */
    'amountRequested': number;
    /**
     * Borrower details
     */
    'borrower': LegalEntityLoanOrigination;
    /**
     * Code of the campaign (product group) that exists in the system for which the loan application is applied
     */
    'campaignId': number;
    /**
     * Required for campaigns with collateral
     */
    'collateralValue'?: number;
    /**
     * Date when payment(s) has to be performed. Value is allowed only for \'Annuity instalment\' and \'Linear principal repayment instalment\' calculation types
     */
    'firstPaymentDate'?: string;
    /**
     * The desired repayment period for which the loan is requested
     */
    'paymentFrequency'?: RequestLegalEntityLoanOriginationPaymentFrequencyEnum;
    /**
     * Date and time when the application has been applied
     */
    'requestedAt': string;
    /**
     * The term for which the loan is requested
     */
    'termRequested': number;
}

export const RequestLegalEntityLoanOriginationPaymentFrequencyEnum = {
    Weekly: 'WEEKLY',
    Fortnightly: 'FORTNIGHTLY',
    Monthly: 'MONTHLY',
    Quarterly: 'QUARTERLY'
} as const;

export type RequestLegalEntityLoanOriginationPaymentFrequencyEnum = typeof RequestLegalEntityLoanOriginationPaymentFrequencyEnum[keyof typeof RequestLegalEntityLoanOriginationPaymentFrequencyEnum];

/**
 * The loan application is used to create a loan
 */
export interface RequestLoanManagement {
    /**
     * Loan amount to disburse
     */
    'amountApproved': number;
    'borrower': RequestLoanManagementBorrower;
    /**
     * Date when payment(s) has to be performed. Value is allowed only for \'Annuity instalment\' and \'Linear principal repayment instalment\' calculation types
     */
    'firstPaymentDate'?: string;
    /**
     * Interest rate measured as a percentage
     */
    'interestRateApprovedPct': number;
    /**
     * Interest rate type that the loan applied for
     */
    'interestRateType': RequestLoanManagementInterestRateTypeEnum;
    /**
     * Date when the loan has been issued
     */
    'loanIssueDate'?: string;
    /**
     * Loan product that the loan applied for
     */
    'loanProduct': LoanProductLoanManagement;
    /**
     * Unique loan application number
     */
    'number': string;
    /**
     * Date and time when the application has been applied
     */
    'requestedAt': string;
    /**
     * Approved loan term
     */
    'termApproved': number;
    /**
     * Used prime rate measured as a percentage
     */
    'usedPrimeRatePct'?: number;
}

export const RequestLoanManagementInterestRateTypeEnum = {
    Fixed: 'FIXED',
    Floating: 'FLOATING'
} as const;

export type RequestLoanManagementInterestRateTypeEnum = typeof RequestLoanManagementInterestRateTypeEnum[keyof typeof RequestLoanManagementInterestRateTypeEnum];

/**
 * @type RequestLoanManagementBorrower
 * Borrower details
 */
export type RequestLoanManagementBorrower = LegalEntityLoanManagement | PersonLoanManagement;

/**
 * The loan application is used to make a decision on originating a loan
 */
export interface RequestPersonLoanOrigination {
    /**
     * The amount for which the loan is requested
     */
    'amountRequested': number;
    /**
     * Borrower details
     */
    'borrower': PersonLoanOrigination;
    /**
     * Code of the campaign (product group) that exists in the system for which the loan application is applied
     */
    'campaignId': number;
    /**
     * Required for campaigns with collateral
     */
    'collateralValue'?: number;
    /**
     * Date when payment(s) has to be performed. Value is allowed only for \'Annuity instalment\' and \'Linear principal repayment instalment\' calculation types
     */
    'firstPaymentDate'?: string;
    /**
     * The desired repayment period for which the loan is requested
     */
    'paymentFrequency'?: RequestPersonLoanOriginationPaymentFrequencyEnum;
    /**
     * Date and time when the application has been applied
     */
    'requestedAt': string;
    /**
     * The term for which the loan is requested
     */
    'termRequested': number;
}

export const RequestPersonLoanOriginationPaymentFrequencyEnum = {
    Weekly: 'WEEKLY',
    Fortnightly: 'FORTNIGHTLY',
    Monthly: 'MONTHLY',
    Quarterly: 'QUARTERLY'
} as const;

export type RequestPersonLoanOriginationPaymentFrequencyEnum = typeof RequestPersonLoanOriginationPaymentFrequencyEnum[keyof typeof RequestPersonLoanOriginationPaymentFrequencyEnum];

export interface RestructuringOptionDto {
    'isAvailable'?: boolean;
    'reason'?: string;
    'restructuringOption'?: string;
}
export interface Scoring {
    'response'?: { [key: string]: any; };
    'resultScore'?: string;
}
export interface ScoringDto {
    'response'?: { [key: string]: any; };
    'resultScore'?: string;
}
export interface ScoringModelSettingsDto {
    'decisionDefinitionKey'?: string;
    'id'?: number;
    'key'?: string;
    'name'?: string;
}
export interface ScoringModelSettingsResponse {
    'scoringModelSettingsList'?: Array<ScoringModelSettingsDto>;
}
export interface ScoringModelVersionContentResponse {
    'scoringModelVersionContent'?: string;
}
export interface ScoringModelVersionSettingsDto {
    'activeFrom'?: string;
    'activeTo'?: string;
    'content'?: string;
    'id'?: number;
    'scoringModelId'?: number;
    'status'?: ScoringModelVersionSettingsDtoStatusEnum;
    'updatedAt'?: string;
    'updatedBy'?: string;
}

export const ScoringModelVersionSettingsDtoStatusEnum = {
    Draft: 'DRAFT',
    Approved: 'APPROVED',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Failed: 'FAILED'
} as const;

export type ScoringModelVersionSettingsDtoStatusEnum = typeof ScoringModelVersionSettingsDtoStatusEnum[keyof typeof ScoringModelVersionSettingsDtoStatusEnum];

export interface SortObjectBrief {
    'empty'?: boolean;
    'sorted'?: boolean;
    'unsorted'?: boolean;
}
export interface TaskRepresentation {
    'assignee'?: string;
    'caseDefinitionId'?: string;
    'caseExecutionId'?: string;
    'caseInstanceId'?: string;
    'createTime': string;
    'delegationState'?: string;
    'deploymentId': string;
    'description'?: string;
    'dueDate'?: string;
    'executionId': string;
    'extensions'?: { [key: string]: any; };
    'followUpDate'?: string;
    'formKey'?: string;
    'id': string;
    'name'?: string;
    'owner'?: string;
    'parentTaskId'?: string;
    'priority'?: number;
    'processDefinitionId': string;
    'processInstanceId': string;
    'suspended': boolean;
    'taskDefinitionKey': string;
    'taskInfo'?: any;
    'tenantId'?: string;
}
export interface TemplateDescription {
    'name'?: string;
    'path'?: string;
}
export interface TermOption {
    'length'?: number;
}
export interface TransactionDto {
    'accountNumber'?: string;
    'amount'?: number;
    'createdAt'?: string;
    'direction'?: TransactionDtoDirectionEnum;
    'documentNumber'?: string;
    'errorMessage'?: string;
    'externalPaymentService'?: string;
    'externalTransactionId'?: string;
    'id'?: number;
    'initiator'?: string;
    'loanId'?: number;
    'method'?: string;
    'processed'?: boolean;
    'processedAt'?: string;
    'status'?: string;
    'type'?: string;
}

export const TransactionDtoDirectionEnum = {
    Inbound: 'INBOUND',
    Outbound: 'OUTBOUND'
} as const;

export type TransactionDtoDirectionEnum = typeof TransactionDtoDirectionEnum[keyof typeof TransactionDtoDirectionEnum];

export interface TransactionDtoBrief {
    'accountNumber'?: string;
    'amount'?: number;
    'createdAt'?: string;
    'direction'?: TransactionDtoBriefDirectionEnum;
    'documentNumber'?: string;
    'errorMessage'?: string;
    'externalPaymentService'?: string;
    'externalTransactionId'?: string;
    'id'?: number;
    'initiator'?: string;
    'loanId'?: number;
    'method'?: string;
    'processed'?: boolean;
    'processedAt'?: string;
    'status'?: string;
    'type'?: string;
}

export const TransactionDtoBriefDirectionEnum = {
    Inbound: 'INBOUND',
    Outbound: 'OUTBOUND'
} as const;

export type TransactionDtoBriefDirectionEnum = typeof TransactionDtoBriefDirectionEnum[keyof typeof TransactionDtoBriefDirectionEnum];

export interface UiConfigurations {
    'appName'?: string;
    'authClientId'?: string;
    'authRealm'?: string;
    'authServerUrl'?: string;
    'borrowerType'?: string;
    'defaultLocale'?: string;
    'defaultProcessKey'?: string;
    'env'?: { [key: string]: string; };
    'supportedLocales'?: Array<string>;
}
export interface UpdateAgentRequest {
    'address'?: AddressDto;
    'bankAccount'?: BankAccountDto;
    'contactDetails'?: { [key: string]: any; };
    'email': string;
    'extensions'?: { [key: string]: any; };
    'id'?: number;
    'legalName': string;
    'logo'?: Array<any>;
    'phone': string;
    'taxNumber': string;
    'website'?: string;
}
export interface UpdateBorrowerRequest {
    'type': string;
}
export interface UpdateBorrowerSettingsRequest {
    'language'?: string;
}
export interface UpdateCampaignRequest {
    'active'?: boolean;
    'agents'?: Array<Agent>;
    'agreementTemplate'?: DocumentTemplateDto;
    'applicationForm'?: ApplicationForm;
    'calculationType'?: string;
    'collectionStrategy': string;
    'configurableFirstPaymentDate'?: boolean;
    'contractTemplate': DocumentTemplateDto;
    'creditBureauProvider'?: string;
    'daysOverdue'?: number;
    'disbursementOption': string;
    'drawdownFreeze'?: number;
    'giniMachineScoringModel'?: string;
    'interestRateType': UpdateCampaignRequestInterestRateTypeEnum;
    'loanType'?: string;
    'name'?: string;
    'parameters'?: CampaignParameters;
    'paymentFrequency'?: Array<string>;
    'rangeOfDaysForFirstPaymentDate'?: number;
    'scoringModel'?: string;
    'scoringProviders'?: Array<string>;
    'signingOption'?: string;
    'termPeriodType'?: string;
    'underwritingDecisionMaking': string;
    'verificationDecisionMaking': string;
}

export const UpdateCampaignRequestInterestRateTypeEnum = {
    Fixed: 'FIXED',
    Floating: 'FLOATING'
} as const;

export type UpdateCampaignRequestInterestRateTypeEnum = typeof UpdateCampaignRequestInterestRateTypeEnum[keyof typeof UpdateCampaignRequestInterestRateTypeEnum];

export interface UpdateLeadRequest {
    'agentId'?: number;
    'email': string;
    'firstName': string;
    'lastName': string;
    'phone': string;
}
export interface UpdateLegalEntityRequest extends UpdateBorrowerRequest {
    'address'?: AddressDto;
    'bankAccount'?: BankAccountDto;
    'blacklisted': boolean;
    'corporateType'?: string;
    'email'?: string;
    'extensions'?: { [key: string]: any; };
    'financialInformation'?: { [key: string]: any; };
    'fullName'?: string;
    'industry'?: string;
    'legalName'?: string;
    'monthsInOperation'?: number;
    'phone'?: string;
    'registrationDate'?: string;
    'registrationNumber'?: string;
    'representative'?: RepresentativeDto;
    'taxNumber'?: string;
    'website'?: string;
}
export interface UpdateLoanProductRequest {
    'active': boolean;
    'campaign': CampaignDto;
    'code': string;
    'defaultInterestRatePct': number;
    'description'?: string;
    'earlyRepaymentFeeRatePct': number;
    'establishmentFee'?: number;
    'graceInterestRatePct': number;
    'gracePeriodDays'?: number;
    'maxAmount': number;
    'maxInterestRatePct': number;
    'maxMarginPct'?: number;
    'maxTerm'?: number;
    'minAmount': number;
    'minInterestRatePct': number;
    'minMarginPct'?: number;
    'minTerm'?: number;
    'overduePenalty': number;
    'paymentFrequency'?: string;
    'serviceFeeRatePct'?: number;
}
export interface UpdatePersonRequest {
    'address'?: AddressDto;
    'bankAccount'?: BankAccountDto;
    'birthDate'?: string;
    'blacklisted': boolean;
    'citizenship'?: string;
    'currentAge'?: number;
    'details'?: { [key: string]: any; };
    'email'?: string;
    'extensions'?: { [key: string]: any; };
    'firstName'?: string;
    'fullName'?: string;
    'gender'?: string;
    'idDocument'?: IdDocumentDto;
    'kycResults'?: KycResultsDto;
    'lastName'?: string;
    'middleName'?: string;
    'nationalId'?: string;
    'numberOfDependents'?: number;
    'phone'?: string;
    'taxNumber'?: string;
    'title'?: string;
}
export interface User {
    'firstName'?: string;
    'lastName'?: string;
    'userId'?: string;
    'username'?: string;
}
export interface UtmParam {
    'name': string;
    'value'?: string;
}

/**
 * ActuatorApi - axios parameter creator
 */
export const ActuatorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Actuator web endpoint \'env\'
         * @param {string} [pattern] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        environment: async (pattern?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/env`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (pattern !== undefined) {
                localVarQueryParameter['pattern'] = pattern;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'env-toMatch\'
         * @param {string} toMatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        environmentEntry: async (toMatch: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toMatch' is not null or undefined
            assertParamExists('environmentEntry', 'toMatch', toMatch)
            const localVarPath = `/actuator/env/{toMatch}`
                .replace(`{${"toMatch"}}`, encodeURIComponent(String(toMatch)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'health\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'info\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator root web endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        links: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNames: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics-requiredMetricName\'
         * @param {string} requiredMetricName 
         * @param {string} [tag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metric: async (requiredMetricName: string, tag?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requiredMetricName' is not null or undefined
            assertParamExists('metric', 'requiredMetricName', requiredMetricName)
            const localVarPath = `/actuator/metrics/{requiredMetricName}`
                .replace(`{${"requiredMetricName"}}`, encodeURIComponent(String(requiredMetricName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'prometheus\'
         * @param {ScrapeFormatEnum} [format] 
         * @param {string} [includedNames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scrape: async (format?: ScrapeFormatEnum, includedNames?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/prometheus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (includedNames !== undefined) {
                localVarQueryParameter['includedNames'] = includedNames;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActuatorApi - functional programming interface
 */
export const ActuatorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActuatorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Actuator web endpoint \'env\'
         * @param {string} [pattern] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async environment(pattern?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.environment(pattern, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActuatorApi.environment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Actuator web endpoint \'env-toMatch\'
         * @param {string} toMatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async environmentEntry(toMatch: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.environmentEntry(toMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActuatorApi.environmentEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Actuator web endpoint \'health\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async health(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.health(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActuatorApi.health']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Actuator web endpoint \'info\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async info(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.info(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActuatorApi.info']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Actuator root web endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async links(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: { [key: string]: Link; }; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.links(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActuatorApi.links']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNames(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNames(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActuatorApi.listNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics-requiredMetricName\'
         * @param {string} requiredMetricName 
         * @param {string} [tag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metric(requiredMetricName: string, tag?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metric(requiredMetricName, tag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActuatorApi.metric']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Actuator web endpoint \'prometheus\'
         * @param {ScrapeFormatEnum} [format] 
         * @param {string} [includedNames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scrape(format?: ScrapeFormatEnum, includedNames?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scrape(format, includedNames, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActuatorApi.scrape']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActuatorApi - factory interface
 */
export const ActuatorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActuatorApiFp(configuration)
    return {
        /**
         * 
         * @summary Actuator web endpoint \'env\'
         * @param {ActuatorApiEnvironmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        environment(requestParameters: ActuatorApiEnvironmentRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.environment(requestParameters.pattern, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'env-toMatch\'
         * @param {ActuatorApiEnvironmentEntryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        environmentEntry(requestParameters: ActuatorApiEnvironmentEntryRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.environmentEntry(requestParameters.toMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'health\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.health(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'info\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.info(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator root web endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        links(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: { [key: string]: Link; }; }> {
            return localVarFp.links(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNames(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.listNames(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics-requiredMetricName\'
         * @param {ActuatorApiMetricRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metric(requestParameters: ActuatorApiMetricRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.metric(requestParameters.requiredMetricName, requestParameters.tag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'prometheus\'
         * @param {ActuatorApiScrapeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scrape(requestParameters: ActuatorApiScrapeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.scrape(requestParameters.format, requestParameters.includedNames, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for environment operation in ActuatorApi.
 */
export interface ActuatorApiEnvironmentRequest {
    readonly pattern?: string
}

/**
 * Request parameters for environmentEntry operation in ActuatorApi.
 */
export interface ActuatorApiEnvironmentEntryRequest {
    readonly toMatch: string
}

/**
 * Request parameters for metric operation in ActuatorApi.
 */
export interface ActuatorApiMetricRequest {
    readonly requiredMetricName: string

    readonly tag?: string
}

/**
 * Request parameters for scrape operation in ActuatorApi.
 */
export interface ActuatorApiScrapeRequest {
    readonly format?: ScrapeFormatEnum

    readonly includedNames?: string
}

/**
 * ActuatorApi - object-oriented interface
 */
export class ActuatorApi extends BaseAPI {
    /**
     * 
     * @summary Actuator web endpoint \'env\'
     * @param {ActuatorApiEnvironmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public environment(requestParameters: ActuatorApiEnvironmentRequest = {}, options?: RawAxiosRequestConfig) {
        return ActuatorApiFp(this.configuration).environment(requestParameters.pattern, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'env-toMatch\'
     * @param {ActuatorApiEnvironmentEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public environmentEntry(requestParameters: ActuatorApiEnvironmentEntryRequest, options?: RawAxiosRequestConfig) {
        return ActuatorApiFp(this.configuration).environmentEntry(requestParameters.toMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'health\'
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public health(options?: RawAxiosRequestConfig) {
        return ActuatorApiFp(this.configuration).health(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'info\'
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public info(options?: RawAxiosRequestConfig) {
        return ActuatorApiFp(this.configuration).info(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator root web endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public links(options?: RawAxiosRequestConfig) {
        return ActuatorApiFp(this.configuration).links(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'metrics\'
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listNames(options?: RawAxiosRequestConfig) {
        return ActuatorApiFp(this.configuration).listNames(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'metrics-requiredMetricName\'
     * @param {ActuatorApiMetricRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public metric(requestParameters: ActuatorApiMetricRequest, options?: RawAxiosRequestConfig) {
        return ActuatorApiFp(this.configuration).metric(requestParameters.requiredMetricName, requestParameters.tag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'prometheus\'
     * @param {ActuatorApiScrapeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public scrape(requestParameters: ActuatorApiScrapeRequest = {}, options?: RawAxiosRequestConfig) {
        return ActuatorApiFp(this.configuration).scrape(requestParameters.format, requestParameters.includedNames, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ScrapeFormatEnum = {
    ContentType004: 'CONTENT_TYPE_004',
    ContentTypeOpenmetrics100: 'CONTENT_TYPE_OPENMETRICS_100',
    ContentTypeProtobuf: 'CONTENT_TYPE_PROTOBUF'
} as const;
export type ScrapeFormatEnum = typeof ScrapeFormatEnum[keyof typeof ScrapeFormatEnum];


/**
 * AgentApi - axios parameter creator
 */
export const AgentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create agent
         * @param {CreateAgentRequest} createAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgent: async (createAgentRequest: CreateAgentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAgentRequest' is not null or undefined
            assertParamExists('createAgent', 'createAgentRequest', createAgentRequest)
            const localVarPath = `/api/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAgentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of agents
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterTaxNumber] Search by agent\&#39;s taxNumber
         * @param {string} [filterSearch] Search by agent\&#39;s legalName, phone, email
         * @param {string} [filterLegalName] Search by agent\&#39;s legalName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgents: async (page?: number, size?: number, sort?: Array<string>, filterTaxNumber?: string, filterSearch?: string, filterLegalName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterTaxNumber !== undefined) {
                localVarQueryParameter['filter.taxNumber'] = filterTaxNumber;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterLegalName !== undefined) {
                localVarQueryParameter['filter.legalName'] = filterLegalName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of agent\'s users
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllUsersByAgentId: async (id: number, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findAllUsersByAgentId', 'id', id)
            const localVarPath = `/api/agents/{id}/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single agent
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgent: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgent', 'id', id)
            const localVarPath = `/api/agents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update agent
         * @param {number} id 
         * @param {UpdateAgentRequest} updateAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent: async (id: number, updateAgentRequest: UpdateAgentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAgent', 'id', id)
            // verify required parameter 'updateAgentRequest' is not null or undefined
            assertParamExists('updateAgent', 'updateAgentRequest', updateAgentRequest)
            const localVarPath = `/api/agents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAgentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentApi - functional programming interface
 */
export const AgentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create agent
         * @param {CreateAgentRequest} createAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgent(createAgentRequest: CreateAgentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgent(createAgentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.createAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of agents
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterTaxNumber] Search by agent\&#39;s taxNumber
         * @param {string} [filterSearch] Search by agent\&#39;s legalName, phone, email
         * @param {string} [filterLegalName] Search by agent\&#39;s legalName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllAgents(page?: number, size?: number, sort?: Array<string>, filterTaxNumber?: string, filterSearch?: string, filterLegalName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAgentSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllAgents(page, size, sort, filterTaxNumber, filterSearch, filterLegalName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.findAllAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of agent\'s users
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllUsersByAgentId(id: number, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllUsersByAgentId(id, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.findAllUsersByAgentId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return single agent
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgent(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.getAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update agent
         * @param {number} id 
         * @param {UpdateAgentRequest} updateAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgent(id: number, updateAgentRequest: UpdateAgentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgent(id, updateAgentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.updateAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentApi - factory interface
 */
export const AgentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentApiFp(configuration)
    return {
        /**
         * 
         * @summary Create agent
         * @param {AgentApiCreateAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgent(requestParameters: AgentApiCreateAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentDto> {
            return localVarFp.createAgent(requestParameters.createAgentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of agents
         * @param {AgentApiFindAllAgentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgents(requestParameters: AgentApiFindAllAgentsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageAgentSummaryDto> {
            return localVarFp.findAllAgents(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterTaxNumber, requestParameters.filterSearch, requestParameters.filterLegalName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of agent\'s users
         * @param {AgentApiFindAllUsersByAgentIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllUsersByAgentId(requestParameters: AgentApiFindAllUsersByAgentIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageUser> {
            return localVarFp.findAllUsersByAgentId(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single agent
         * @param {AgentApiGetAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgent(requestParameters: AgentApiGetAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentDto> {
            return localVarFp.getAgent(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update agent
         * @param {AgentApiUpdateAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent(requestParameters: AgentApiUpdateAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentDto> {
            return localVarFp.updateAgent(requestParameters.id, requestParameters.updateAgentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createAgent operation in AgentApi.
 */
export interface AgentApiCreateAgentRequest {
    readonly createAgentRequest: CreateAgentRequest
}

/**
 * Request parameters for findAllAgents operation in AgentApi.
 */
export interface AgentApiFindAllAgentsRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Search by agent\&#39;s taxNumber
     */
    readonly filterTaxNumber?: string

    /**
     * Search by agent\&#39;s legalName, phone, email
     */
    readonly filterSearch?: string

    /**
     * Search by agent\&#39;s legalName
     */
    readonly filterLegalName?: string
}

/**
 * Request parameters for findAllUsersByAgentId operation in AgentApi.
 */
export interface AgentApiFindAllUsersByAgentIdRequest {
    readonly id: number

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for getAgent operation in AgentApi.
 */
export interface AgentApiGetAgentRequest {
    readonly id: number
}

/**
 * Request parameters for updateAgent operation in AgentApi.
 */
export interface AgentApiUpdateAgentRequest {
    readonly id: number

    readonly updateAgentRequest: UpdateAgentRequest
}

/**
 * AgentApi - object-oriented interface
 */
export class AgentApi extends BaseAPI {
    /**
     * 
     * @summary Create agent
     * @param {AgentApiCreateAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAgent(requestParameters: AgentApiCreateAgentRequest, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).createAgent(requestParameters.createAgentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of agents
     * @param {AgentApiFindAllAgentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllAgents(requestParameters: AgentApiFindAllAgentsRequest = {}, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).findAllAgents(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterTaxNumber, requestParameters.filterSearch, requestParameters.filterLegalName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of agent\'s users
     * @param {AgentApiFindAllUsersByAgentIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllUsersByAgentId(requestParameters: AgentApiFindAllUsersByAgentIdRequest, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).findAllUsersByAgentId(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single agent
     * @param {AgentApiGetAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAgent(requestParameters: AgentApiGetAgentRequest, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).getAgent(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update agent
     * @param {AgentApiUpdateAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAgent(requestParameters: AgentApiUpdateAgentRequest, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).updateAgent(requestParameters.id, requestParameters.updateAgentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AgentLoanApi - axios parameter creator
 */
export const AgentLoanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loans for agent (all types)
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan statuses
         * @param {string} [filterIssueDateFrom] Search by loan issue date from
         * @param {string} [filterIssueDateTo] Search by loan issue date to
         * @param {string} [filterSearch] Search by loan number; borrower\&#39;s full name, phone, email; loan product code
         * @param {Array<string>} [filterLoanTypes] Filter by loan types (FIXED_TERM, CREDIT_LINE)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgentLoans: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterIssueDateFrom?: string, filterIssueDateTo?: string, filterSearch?: string, filterLoanTypes?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agent/loans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterIssueDateFrom !== undefined) {
                localVarQueryParameter['filter.issueDateFrom'] = (filterIssueDateFrom as any instanceof Date) ?
                    (filterIssueDateFrom as any).toISOString().substring(0,10) :
                    filterIssueDateFrom;
            }

            if (filterIssueDateTo !== undefined) {
                localVarQueryParameter['filter.issueDateTo'] = (filterIssueDateTo as any instanceof Date) ?
                    (filterIssueDateTo as any).toISOString().substring(0,10) :
                    filterIssueDateTo;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterLoanTypes) {
                localVarQueryParameter['filter.loanTypes'] = filterLoanTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loan\'s operations (FixedTermLoan only)
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllOperationsByLoanIdForAgent: async (id: number, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findAllOperationsByLoanIdForAgent', 'id', id)
            const localVarPath = `/api/agent/loans/{id}/operations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return loan operation by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOperationByIdForAgent: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOperationByIdForAgent', 'id', id)
            const localVarPath = `/api/agent/loans/operations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return agent\'s single loan (any type)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentLoan: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgentLoan', 'id', id)
            const localVarPath = `/api/agent/loans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentLoanApi - functional programming interface
 */
export const AgentLoanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentLoanApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of loans for agent (all types)
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan statuses
         * @param {string} [filterIssueDateFrom] Search by loan issue date from
         * @param {string} [filterIssueDateTo] Search by loan issue date to
         * @param {string} [filterSearch] Search by loan number; borrower\&#39;s full name, phone, email; loan product code
         * @param {Array<string>} [filterLoanTypes] Filter by loan types (FIXED_TERM, CREDIT_LINE)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllAgentLoans(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterIssueDateFrom?: string, filterIssueDateTo?: string, filterSearch?: string, filterLoanTypes?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanDtoBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllAgentLoans(page, size, sort, filterStatuses, filterIssueDateFrom, filterIssueDateTo, filterSearch, filterLoanTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentLoanApi.findAllAgentLoans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of loan\'s operations (FixedTermLoan only)
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllOperationsByLoanIdForAgent(id: number, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllOperationsByLoanIdForAgent(id, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentLoanApi.findAllOperationsByLoanIdForAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return loan operation by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOperationByIdForAgent(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOperationByIdForAgent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentLoanApi.findOperationByIdForAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return agent\'s single loan (any type)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentLoan(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAgentLoan200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentLoan(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentLoanApi.getAgentLoan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentLoanApi - factory interface
 */
export const AgentLoanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentLoanApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of loans for agent (all types)
         * @param {AgentLoanApiFindAllAgentLoansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgentLoans(requestParameters: AgentLoanApiFindAllAgentLoansRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanDtoBrief> {
            return localVarFp.findAllAgentLoans(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterIssueDateFrom, requestParameters.filterIssueDateTo, requestParameters.filterSearch, requestParameters.filterLoanTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loan\'s operations (FixedTermLoan only)
         * @param {AgentLoanApiFindAllOperationsByLoanIdForAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllOperationsByLoanIdForAgent(requestParameters: AgentLoanApiFindAllOperationsByLoanIdForAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanOperationDto> {
            return localVarFp.findAllOperationsByLoanIdForAgent(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return loan operation by id
         * @param {AgentLoanApiFindOperationByIdForAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOperationByIdForAgent(requestParameters: AgentLoanApiFindOperationByIdForAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanOperationDto> {
            return localVarFp.findOperationByIdForAgent(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return agent\'s single loan (any type)
         * @param {AgentLoanApiGetAgentLoanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentLoan(requestParameters: AgentLoanApiGetAgentLoanRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAgentLoan200Response> {
            return localVarFp.getAgentLoan(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAllAgentLoans operation in AgentLoanApi.
 */
export interface AgentLoanApiFindAllAgentLoansRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Search by loan statuses
     */
    readonly filterStatuses?: Array<string>

    /**
     * Search by loan issue date from
     */
    readonly filterIssueDateFrom?: string

    /**
     * Search by loan issue date to
     */
    readonly filterIssueDateTo?: string

    /**
     * Search by loan number; borrower\&#39;s full name, phone, email; loan product code
     */
    readonly filterSearch?: string

    /**
     * Filter by loan types (FIXED_TERM, CREDIT_LINE)
     */
    readonly filterLoanTypes?: Array<string>
}

/**
 * Request parameters for findAllOperationsByLoanIdForAgent operation in AgentLoanApi.
 */
export interface AgentLoanApiFindAllOperationsByLoanIdForAgentRequest {
    readonly id: number

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for findOperationByIdForAgent operation in AgentLoanApi.
 */
export interface AgentLoanApiFindOperationByIdForAgentRequest {
    readonly id: number
}

/**
 * Request parameters for getAgentLoan operation in AgentLoanApi.
 */
export interface AgentLoanApiGetAgentLoanRequest {
    readonly id: number
}

/**
 * AgentLoanApi - object-oriented interface
 */
export class AgentLoanApi extends BaseAPI {
    /**
     * 
     * @summary Return list of loans for agent (all types)
     * @param {AgentLoanApiFindAllAgentLoansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllAgentLoans(requestParameters: AgentLoanApiFindAllAgentLoansRequest = {}, options?: RawAxiosRequestConfig) {
        return AgentLoanApiFp(this.configuration).findAllAgentLoans(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterIssueDateFrom, requestParameters.filterIssueDateTo, requestParameters.filterSearch, requestParameters.filterLoanTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loan\'s operations (FixedTermLoan only)
     * @param {AgentLoanApiFindAllOperationsByLoanIdForAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllOperationsByLoanIdForAgent(requestParameters: AgentLoanApiFindAllOperationsByLoanIdForAgentRequest, options?: RawAxiosRequestConfig) {
        return AgentLoanApiFp(this.configuration).findAllOperationsByLoanIdForAgent(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return loan operation by id
     * @param {AgentLoanApiFindOperationByIdForAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findOperationByIdForAgent(requestParameters: AgentLoanApiFindOperationByIdForAgentRequest, options?: RawAxiosRequestConfig) {
        return AgentLoanApiFp(this.configuration).findOperationByIdForAgent(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return agent\'s single loan (any type)
     * @param {AgentLoanApiGetAgentLoanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAgentLoan(requestParameters: AgentLoanApiGetAgentLoanRequest, options?: RawAxiosRequestConfig) {
        return AgentLoanApiFp(this.configuration).getAgentLoan(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AgentLoanApplicationApi - axios parameter creator
 */
export const AgentLoanApplicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan applications for agent
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan application statuses
         * @param {string} [filterRequestedAtFrom] Search by loan application requested at from
         * @param {string} [filterRequestedAtTo] Search by loan application requested at to
         * @param {string} [filterSearch] Search by loan application number; borrower\&#39;s full name, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgentApplications: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterRequestedAtFrom?: string, filterRequestedAtTo?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agent/loan-applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterRequestedAtFrom !== undefined) {
                localVarQueryParameter['filter.requestedAtFrom'] = (filterRequestedAtFrom as any instanceof Date) ?
                    (filterRequestedAtFrom as any).toISOString() :
                    filterRequestedAtFrom;
            }

            if (filterRequestedAtTo !== undefined) {
                localVarQueryParameter['filter.requestedAtTo'] = (filterRequestedAtTo as any instanceof Date) ?
                    (filterRequestedAtTo as any).toISOString() :
                    filterRequestedAtTo;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return agent\'s single loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentApplication: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgentApplication', 'id', id)
            const localVarPath = `/api/agent/loan-applications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentLoanApplicationApi - functional programming interface
 */
export const AgentLoanApplicationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentLoanApplicationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of loan applications for agent
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan application statuses
         * @param {string} [filterRequestedAtFrom] Search by loan application requested at from
         * @param {string} [filterRequestedAtTo] Search by loan application requested at to
         * @param {string} [filterSearch] Search by loan application number; borrower\&#39;s full name, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllAgentApplications(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterRequestedAtFrom?: string, filterRequestedAtTo?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanApplicationDtoBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllAgentApplications(page, size, sort, filterStatuses, filterRequestedAtFrom, filterRequestedAtTo, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentLoanApplicationApi.findAllAgentApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return agent\'s single loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentApplication(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentApplication(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentLoanApplicationApi.getAgentApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentLoanApplicationApi - factory interface
 */
export const AgentLoanApplicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentLoanApplicationApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of loan applications for agent
         * @param {AgentLoanApplicationApiFindAllAgentApplicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgentApplications(requestParameters: AgentLoanApplicationApiFindAllAgentApplicationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanApplicationDtoBrief> {
            return localVarFp.findAllAgentApplications(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterRequestedAtFrom, requestParameters.filterRequestedAtTo, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return agent\'s single loan application
         * @param {AgentLoanApplicationApiGetAgentApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentApplication(requestParameters: AgentLoanApplicationApiGetAgentApplicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationDto> {
            return localVarFp.getAgentApplication(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAllAgentApplications operation in AgentLoanApplicationApi.
 */
export interface AgentLoanApplicationApiFindAllAgentApplicationsRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Search by loan application statuses
     */
    readonly filterStatuses?: Array<string>

    /**
     * Search by loan application requested at from
     */
    readonly filterRequestedAtFrom?: string

    /**
     * Search by loan application requested at to
     */
    readonly filterRequestedAtTo?: string

    /**
     * Search by loan application number; borrower\&#39;s full name, phone, email
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for getAgentApplication operation in AgentLoanApplicationApi.
 */
export interface AgentLoanApplicationApiGetAgentApplicationRequest {
    readonly id: number
}

/**
 * AgentLoanApplicationApi - object-oriented interface
 */
export class AgentLoanApplicationApi extends BaseAPI {
    /**
     * 
     * @summary Return list of loan applications for agent
     * @param {AgentLoanApplicationApiFindAllAgentApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllAgentApplications(requestParameters: AgentLoanApplicationApiFindAllAgentApplicationsRequest = {}, options?: RawAxiosRequestConfig) {
        return AgentLoanApplicationApiFp(this.configuration).findAllAgentApplications(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterRequestedAtFrom, requestParameters.filterRequestedAtTo, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return agent\'s single loan application
     * @param {AgentLoanApplicationApiGetAgentApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAgentApplication(requestParameters: AgentLoanApplicationApiGetAgentApplicationRequest, options?: RawAxiosRequestConfig) {
        return AgentLoanApplicationApiFp(this.configuration).getAgentApplication(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AgentPortalApi - axios parameter creator
 */
export const AgentPortalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return agent profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentProfile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update agent
         * @param {UpdateAgentRequest} updateAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent1: async (updateAgentRequest: UpdateAgentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAgentRequest' is not null or undefined
            assertParamExists('updateAgent1', 'updateAgentRequest', updateAgentRequest)
            const localVarPath = `/api/agent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAgentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentPortalApi - functional programming interface
 */
export const AgentPortalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentPortalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return agent profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentProfile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentPortalApi.getAgentProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update agent
         * @param {UpdateAgentRequest} updateAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgent1(updateAgentRequest: UpdateAgentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgent1(updateAgentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentPortalApi.updateAgent1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentPortalApi - factory interface
 */
export const AgentPortalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentPortalApiFp(configuration)
    return {
        /**
         * 
         * @summary Return agent profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentProfile(options?: RawAxiosRequestConfig): AxiosPromise<AgentDto> {
            return localVarFp.getAgentProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update agent
         * @param {AgentPortalApiUpdateAgent1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent1(requestParameters: AgentPortalApiUpdateAgent1Request, options?: RawAxiosRequestConfig): AxiosPromise<AgentDto> {
            return localVarFp.updateAgent1(requestParameters.updateAgentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for updateAgent1 operation in AgentPortalApi.
 */
export interface AgentPortalApiUpdateAgent1Request {
    readonly updateAgentRequest: UpdateAgentRequest
}

/**
 * AgentPortalApi - object-oriented interface
 */
export class AgentPortalApi extends BaseAPI {
    /**
     * 
     * @summary Return agent profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAgentProfile(options?: RawAxiosRequestConfig) {
        return AgentPortalApiFp(this.configuration).getAgentProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update agent
     * @param {AgentPortalApiUpdateAgent1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAgent1(requestParameters: AgentPortalApiUpdateAgent1Request, options?: RawAxiosRequestConfig) {
        return AgentPortalApiFp(this.configuration).updateAgent1(requestParameters.updateAgentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BPMSIncidentsManagementApi - axios parameter creator
 */
export const BPMSIncidentsManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Asynchronously increase retry count for all insidents in the system
         * @summary Bulk retry incidents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkRetryIncidents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/incident/bulk-retry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BPMSIncidentsManagementApi - functional programming interface
 */
export const BPMSIncidentsManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BPMSIncidentsManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Asynchronously increase retry count for all insidents in the system
         * @summary Bulk retry incidents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkRetryIncidents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkRetryIncidentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkRetryIncidents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BPMSIncidentsManagementApi.bulkRetryIncidents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BPMSIncidentsManagementApi - factory interface
 */
export const BPMSIncidentsManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BPMSIncidentsManagementApiFp(configuration)
    return {
        /**
         * Asynchronously increase retry count for all insidents in the system
         * @summary Bulk retry incidents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkRetryIncidents(options?: RawAxiosRequestConfig): AxiosPromise<BulkRetryIncidentsResponse> {
            return localVarFp.bulkRetryIncidents(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BPMSIncidentsManagementApi - object-oriented interface
 */
export class BPMSIncidentsManagementApi extends BaseAPI {
    /**
     * Asynchronously increase retry count for all insidents in the system
     * @summary Bulk retry incidents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkRetryIncidents(options?: RawAxiosRequestConfig) {
        return BPMSIncidentsManagementApiFp(this.configuration).bulkRetryIncidents(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BPMSResourcesManagementApi - axios parameter creator
 */
export const BPMSResourcesManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allowed to upload multiple resources and also packet to ZIP files. Process instances migration to new versions will be performed after deployment. All system insidents will be retried after the migration.
         * @summary Create a deployment with specified resources
         * @param {string} deploymentName Name for the deployment
         * @param {Array<File>} files Resources which the deployment will consist of
         * @param {boolean} [migrate] Migrate all process instances to new deployed versions. To perform perform migration process definitions has to comply conditions/rules explained at https://www.novatec-gmbh.de/blog/automating-process-instance-migration-with-camunda-bpm/ 
         * @param {boolean} [retryIncidents] Bulk retry all incidents in the system after deployment and migration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (deploymentName: string, files: Array<File>, migrate?: boolean, retryIncidents?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deploymentName' is not null or undefined
            assertParamExists('create', 'deploymentName', deploymentName)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('create', 'files', files)
            const localVarPath = `/api/deployment/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (deploymentName !== undefined) {
                localVarQueryParameter['deployment-name'] = deploymentName;
            }

            if (files) {
                localVarQueryParameter['files'] = files;
            }

            if (migrate !== undefined) {
                localVarQueryParameter['migrate'] = migrate;
            }

            if (retryIncidents !== undefined) {
                localVarQueryParameter['retry-incidents'] = retryIncidents;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a form by key from \'/public\' folder in deployment storage
         * @summary Retrieves a deployed form by key
         * @param {string} formKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForm: async (formKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formKey' is not null or undefined
            assertParamExists('getForm', 'formKey', formKey)
            const localVarPath = `/api/deployment/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (formKey !== undefined) {
                localVarQueryParameter['form-key'] = formKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves latest version of the resource by name from \'/public\' folder from deployment
         * @summary Retrieves a public resource by name
         * @param {string} [jsonFilter] Filters JSON response utilizing JSONPath syntax if response content type is application/json. See for details: https://github.com/json-path/JsonPath#readme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestResource: async (jsonFilter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/resource/**`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (jsonFilter !== undefined) {
                localVarQueryParameter['jsonFilter'] = jsonFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BPMSResourcesManagementApi - functional programming interface
 */
export const BPMSResourcesManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BPMSResourcesManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Allowed to upload multiple resources and also packet to ZIP files. Process instances migration to new versions will be performed after deployment. All system insidents will be retried after the migration.
         * @summary Create a deployment with specified resources
         * @param {string} deploymentName Name for the deployment
         * @param {Array<File>} files Resources which the deployment will consist of
         * @param {boolean} [migrate] Migrate all process instances to new deployed versions. To perform perform migration process definitions has to comply conditions/rules explained at https://www.novatec-gmbh.de/blog/automating-process-instance-migration-with-camunda-bpm/ 
         * @param {boolean} [retryIncidents] Bulk retry all incidents in the system after deployment and migration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(deploymentName: string, files: Array<File>, migrate?: boolean, retryIncidents?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeploymentRepresentation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(deploymentName, files, migrate, retryIncidents, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BPMSResourcesManagementApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a form by key from \'/public\' folder in deployment storage
         * @summary Retrieves a deployed form by key
         * @param {string} formKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForm(formKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForm(formKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BPMSResourcesManagementApi.getForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves latest version of the resource by name from \'/public\' folder from deployment
         * @summary Retrieves a public resource by name
         * @param {string} [jsonFilter] Filters JSON response utilizing JSONPath syntax if response content type is application/json. See for details: https://github.com/json-path/JsonPath#readme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestResource(jsonFilter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestResource(jsonFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BPMSResourcesManagementApi.getLatestResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BPMSResourcesManagementApi - factory interface
 */
export const BPMSResourcesManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BPMSResourcesManagementApiFp(configuration)
    return {
        /**
         * Allowed to upload multiple resources and also packet to ZIP files. Process instances migration to new versions will be performed after deployment. All system insidents will be retried after the migration.
         * @summary Create a deployment with specified resources
         * @param {BPMSResourcesManagementApiCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(requestParameters: BPMSResourcesManagementApiCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeploymentRepresentation> {
            return localVarFp.create(requestParameters.deploymentName, requestParameters.files, requestParameters.migrate, requestParameters.retryIncidents, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a form by key from \'/public\' folder in deployment storage
         * @summary Retrieves a deployed form by key
         * @param {BPMSResourcesManagementApiGetFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForm(requestParameters: BPMSResourcesManagementApiGetFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getForm(requestParameters.formKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves latest version of the resource by name from \'/public\' folder from deployment
         * @summary Retrieves a public resource by name
         * @param {BPMSResourcesManagementApiGetLatestResourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestResource(requestParameters: BPMSResourcesManagementApiGetLatestResourceRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getLatestResource(requestParameters.jsonFilter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for create operation in BPMSResourcesManagementApi.
 */
export interface BPMSResourcesManagementApiCreateRequest {
    /**
     * Name for the deployment
     */
    readonly deploymentName: string

    /**
     * Resources which the deployment will consist of
     */
    readonly files: Array<File>

    /**
     * Migrate all process instances to new deployed versions. To perform perform migration process definitions has to comply conditions/rules explained at https://www.novatec-gmbh.de/blog/automating-process-instance-migration-with-camunda-bpm/ 
     */
    readonly migrate?: boolean

    /**
     * Bulk retry all incidents in the system after deployment and migration
     */
    readonly retryIncidents?: boolean
}

/**
 * Request parameters for getForm operation in BPMSResourcesManagementApi.
 */
export interface BPMSResourcesManagementApiGetFormRequest {
    readonly formKey: string
}

/**
 * Request parameters for getLatestResource operation in BPMSResourcesManagementApi.
 */
export interface BPMSResourcesManagementApiGetLatestResourceRequest {
    /**
     * Filters JSON response utilizing JSONPath syntax if response content type is application/json. See for details: https://github.com/json-path/JsonPath#readme
     */
    readonly jsonFilter?: string
}

/**
 * BPMSResourcesManagementApi - object-oriented interface
 */
export class BPMSResourcesManagementApi extends BaseAPI {
    /**
     * Allowed to upload multiple resources and also packet to ZIP files. Process instances migration to new versions will be performed after deployment. All system insidents will be retried after the migration.
     * @summary Create a deployment with specified resources
     * @param {BPMSResourcesManagementApiCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public create(requestParameters: BPMSResourcesManagementApiCreateRequest, options?: RawAxiosRequestConfig) {
        return BPMSResourcesManagementApiFp(this.configuration).create(requestParameters.deploymentName, requestParameters.files, requestParameters.migrate, requestParameters.retryIncidents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a form by key from \'/public\' folder in deployment storage
     * @summary Retrieves a deployed form by key
     * @param {BPMSResourcesManagementApiGetFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getForm(requestParameters: BPMSResourcesManagementApiGetFormRequest, options?: RawAxiosRequestConfig) {
        return BPMSResourcesManagementApiFp(this.configuration).getForm(requestParameters.formKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves latest version of the resource by name from \'/public\' folder from deployment
     * @summary Retrieves a public resource by name
     * @param {BPMSResourcesManagementApiGetLatestResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLatestResource(requestParameters: BPMSResourcesManagementApiGetLatestResourceRequest = {}, options?: RawAxiosRequestConfig) {
        return BPMSResourcesManagementApiFp(this.configuration).getLatestResource(requestParameters.jsonFilter, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BorrowerApi - axios parameter creator
 */
export const BorrowerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of borrowers
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [filterBlacklisted] 
         * @param {string} [filterSearch] 
         * @param {boolean} [borrowerFilterRequestFilterBlacklisted] Search by borrower\&#39;s blacklisted flag
         * @param {string} [borrowerFilterRequestFilterSearch] Search by borrower\&#39;s full name, phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllBorrowers: async (page?: number, size?: number, sort?: Array<string>, filterBlacklisted?: boolean, filterSearch?: string, borrowerFilterRequestFilterBlacklisted?: boolean, borrowerFilterRequestFilterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/borrowers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterBlacklisted !== undefined) {
                localVarQueryParameter['filter.blacklisted'] = filterBlacklisted;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (borrowerFilterRequestFilterBlacklisted !== undefined) {
                localVarQueryParameter['borrowerFilterRequest.filter.blacklisted'] = borrowerFilterRequestFilterBlacklisted;
            }

            if (borrowerFilterRequestFilterSearch !== undefined) {
                localVarQueryParameter['borrowerFilterRequest.filter.search'] = borrowerFilterRequestFilterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return borrower\'s black list record if exists
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBlacklistEntry: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findBlacklistEntry', 'id', id)
            const localVarPath = `/api/borrowers/{id}/blacklist-entry`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single borrower
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrower: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBorrower', 'id', id)
            const localVarPath = `/api/borrowers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return borrower\'s history
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerHistory: async (id: number, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBorrowerHistory', 'id', id)
            const localVarPath = `/api/borrowers/{id}/history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update borrower
         * @param {number} id 
         * @param {UpdateLegalEntityRequest} updateLegalEntityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBorrower: async (id: number, updateLegalEntityRequest: UpdateLegalEntityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBorrower', 'id', id)
            // verify required parameter 'updateLegalEntityRequest' is not null or undefined
            assertParamExists('updateBorrower', 'updateLegalEntityRequest', updateLegalEntityRequest)
            const localVarPath = `/api/borrowers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLegalEntityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BorrowerApi - functional programming interface
 */
export const BorrowerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BorrowerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of borrowers
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [filterBlacklisted] 
         * @param {string} [filterSearch] 
         * @param {boolean} [borrowerFilterRequestFilterBlacklisted] Search by borrower\&#39;s blacklisted flag
         * @param {string} [borrowerFilterRequestFilterSearch] Search by borrower\&#39;s full name, phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllBorrowers(page?: number, size?: number, sort?: Array<string>, filterBlacklisted?: boolean, filterSearch?: string, borrowerFilterRequestFilterBlacklisted?: boolean, borrowerFilterRequestFilterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageBorrowerDtoBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllBorrowers(page, size, sort, filterBlacklisted, filterSearch, borrowerFilterRequestFilterBlacklisted, borrowerFilterRequestFilterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerApi.findAllBorrowers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return borrower\'s black list record if exists
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findBlacklistEntry(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findBlacklistEntry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerApi.findBlacklistEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return single borrower
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrower(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BorrowerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBorrower(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerApi.getBorrower']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return borrower\'s history
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrowerHistory(id: number, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageBorrowerRevisionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBorrowerHistory(id, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerApi.getBorrowerHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update borrower
         * @param {number} id 
         * @param {UpdateLegalEntityRequest} updateLegalEntityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBorrower(id: number, updateLegalEntityRequest: UpdateLegalEntityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BorrowerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBorrower(id, updateLegalEntityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerApi.updateBorrower']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BorrowerApi - factory interface
 */
export const BorrowerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BorrowerApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of borrowers
         * @param {BorrowerApiFindAllBorrowersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllBorrowers(requestParameters: BorrowerApiFindAllBorrowersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageBorrowerDtoBrief> {
            return localVarFp.findAllBorrowers(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterBlacklisted, requestParameters.filterSearch, requestParameters.borrowerFilterRequestFilterBlacklisted, requestParameters.borrowerFilterRequestFilterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return borrower\'s black list record if exists
         * @param {BorrowerApiFindBlacklistEntryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBlacklistEntry(requestParameters: BorrowerApiFindBlacklistEntryRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.findBlacklistEntry(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single borrower
         * @param {BorrowerApiGetBorrowerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrower(requestParameters: BorrowerApiGetBorrowerRequest, options?: RawAxiosRequestConfig): AxiosPromise<BorrowerDto> {
            return localVarFp.getBorrower(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return borrower\'s history
         * @param {BorrowerApiGetBorrowerHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerHistory(requestParameters: BorrowerApiGetBorrowerHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageBorrowerRevisionDto> {
            return localVarFp.getBorrowerHistory(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update borrower
         * @param {BorrowerApiUpdateBorrowerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBorrower(requestParameters: BorrowerApiUpdateBorrowerRequest, options?: RawAxiosRequestConfig): AxiosPromise<BorrowerDto> {
            return localVarFp.updateBorrower(requestParameters.id, requestParameters.updateLegalEntityRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAllBorrowers operation in BorrowerApi.
 */
export interface BorrowerApiFindAllBorrowersRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    readonly filterBlacklisted?: boolean

    readonly filterSearch?: string

    /**
     * Search by borrower\&#39;s blacklisted flag
     */
    readonly borrowerFilterRequestFilterBlacklisted?: boolean

    /**
     * Search by borrower\&#39;s full name, phone
     */
    readonly borrowerFilterRequestFilterSearch?: string
}

/**
 * Request parameters for findBlacklistEntry operation in BorrowerApi.
 */
export interface BorrowerApiFindBlacklistEntryRequest {
    readonly id: number
}

/**
 * Request parameters for getBorrower operation in BorrowerApi.
 */
export interface BorrowerApiGetBorrowerRequest {
    readonly id: number
}

/**
 * Request parameters for getBorrowerHistory operation in BorrowerApi.
 */
export interface BorrowerApiGetBorrowerHistoryRequest {
    readonly id: number

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for updateBorrower operation in BorrowerApi.
 */
export interface BorrowerApiUpdateBorrowerRequest {
    readonly id: number

    readonly updateLegalEntityRequest: UpdateLegalEntityRequest
}

/**
 * BorrowerApi - object-oriented interface
 */
export class BorrowerApi extends BaseAPI {
    /**
     * 
     * @summary Return list of borrowers
     * @param {BorrowerApiFindAllBorrowersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllBorrowers(requestParameters: BorrowerApiFindAllBorrowersRequest = {}, options?: RawAxiosRequestConfig) {
        return BorrowerApiFp(this.configuration).findAllBorrowers(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterBlacklisted, requestParameters.filterSearch, requestParameters.borrowerFilterRequestFilterBlacklisted, requestParameters.borrowerFilterRequestFilterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return borrower\'s black list record if exists
     * @param {BorrowerApiFindBlacklistEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findBlacklistEntry(requestParameters: BorrowerApiFindBlacklistEntryRequest, options?: RawAxiosRequestConfig) {
        return BorrowerApiFp(this.configuration).findBlacklistEntry(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single borrower
     * @param {BorrowerApiGetBorrowerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBorrower(requestParameters: BorrowerApiGetBorrowerRequest, options?: RawAxiosRequestConfig) {
        return BorrowerApiFp(this.configuration).getBorrower(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return borrower\'s history
     * @param {BorrowerApiGetBorrowerHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBorrowerHistory(requestParameters: BorrowerApiGetBorrowerHistoryRequest, options?: RawAxiosRequestConfig) {
        return BorrowerApiFp(this.configuration).getBorrowerHistory(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update borrower
     * @param {BorrowerApiUpdateBorrowerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBorrower(requestParameters: BorrowerApiUpdateBorrowerRequest, options?: RawAxiosRequestConfig) {
        return BorrowerApiFp(this.configuration).updateBorrower(requestParameters.id, requestParameters.updateLegalEntityRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BorrowerPortalApi - axios parameter creator
 */
export const BorrowerPortalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan\'s transactions for borrower
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTransactionsByLoanId: async (id: number, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findAllTransactionsByLoanId', 'id', id)
            const localVarPath = `/api/borrower/loan/{id}/transactions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return borrower\'s loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerApplication: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBorrowerApplication', 'id', id)
            const localVarPath = `/api/borrower/loanApplications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loan applications for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerApplications: async (page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/borrower/loanApplications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return borrower\'s loan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerLoan: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBorrowerLoan', 'id', id)
            const localVarPath = `/api/borrower/loans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loans for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerLoans: async (page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/borrower/loans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return borrower profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerProfile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/borrower/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get borrower settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/borrower/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return loan adjustments request for borrower
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAdjustmentsRequest: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLoanAdjustmentsRequest', 'id', id)
            const localVarPath = `/api/borrower/loan-adjustments-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loan adjustments requests  for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan adjustments request statuses
         * @param {Array<number>} [filterLoanId] Search by loan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAdjustmentsRequests: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterLoanId?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/borrower/loan-adjustments-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterLoanId) {
                localVarQueryParameter['filter.loanId'] = filterLoanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save borrower\'s UTM parameters
         * @param {Array<UtmParam>} utmParam Collection of UTM parameters that should be stored for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUtmParams: async (utmParam: Array<UtmParam>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'utmParam' is not null or undefined
            assertParamExists('saveUtmParams', 'utmParam', utmParam)
            const localVarPath = `/api/borrower/utmParams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(utmParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or update borrower settings
         * @param {UpdateBorrowerSettingsRequest} updateBorrowerSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBorrowerSettings: async (updateBorrowerSettingsRequest: UpdateBorrowerSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateBorrowerSettingsRequest' is not null or undefined
            assertParamExists('updateBorrowerSettings', 'updateBorrowerSettingsRequest', updateBorrowerSettingsRequest)
            const localVarPath = `/api/borrower/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBorrowerSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BorrowerPortalApi - functional programming interface
 */
export const BorrowerPortalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BorrowerPortalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of loan\'s transactions for borrower
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllTransactionsByLoanId(id: number, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTransactionDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllTransactionsByLoanId(id, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerPortalApi.findAllTransactionsByLoanId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return borrower\'s loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrowerApplication(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBorrowerApplication(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerPortalApi.getBorrowerApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of loan applications for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrowerApplications(page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanApplicationDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBorrowerApplications(page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerPortalApi.getBorrowerApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return borrower\'s loan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrowerLoan(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAgentLoan200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBorrowerLoan(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerPortalApi.getBorrowerLoan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of loans for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrowerLoans(page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBorrowerLoans(page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerPortalApi.getBorrowerLoans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return borrower profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrowerProfile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BorrowerDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBorrowerProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerPortalApi.getBorrowerProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get borrower settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrowerSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BorrowerSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBorrowerSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerPortalApi.getBorrowerSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return loan adjustments request for borrower
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoanAdjustmentsRequest(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanAdjustmentsRequestDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoanAdjustmentsRequest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerPortalApi.getLoanAdjustmentsRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of loan adjustments requests  for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan adjustments request statuses
         * @param {Array<number>} [filterLoanId] Search by loan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoanAdjustmentsRequests(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterLoanId?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanAdjustmentsRequestDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoanAdjustmentsRequests(page, size, sort, filterStatuses, filterLoanId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerPortalApi.getLoanAdjustmentsRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save borrower\'s UTM parameters
         * @param {Array<UtmParam>} utmParam Collection of UTM parameters that should be stored for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveUtmParams(utmParam: Array<UtmParam>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveUtmParams(utmParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerPortalApi.saveUtmParams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create or update borrower settings
         * @param {UpdateBorrowerSettingsRequest} updateBorrowerSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBorrowerSettings(updateBorrowerSettingsRequest: UpdateBorrowerSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BorrowerSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBorrowerSettings(updateBorrowerSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BorrowerPortalApi.updateBorrowerSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BorrowerPortalApi - factory interface
 */
export const BorrowerPortalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BorrowerPortalApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of loan\'s transactions for borrower
         * @param {BorrowerPortalApiFindAllTransactionsByLoanIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTransactionsByLoanId(requestParameters: BorrowerPortalApiFindAllTransactionsByLoanIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageTransactionDtoBorrowerAllowed> {
            return localVarFp.findAllTransactionsByLoanId(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return borrower\'s loan application
         * @param {BorrowerPortalApiGetBorrowerApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerApplication(requestParameters: BorrowerPortalApiGetBorrowerApplicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationDtoBorrowerAllowed> {
            return localVarFp.getBorrowerApplication(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loan applications for borrower
         * @param {BorrowerPortalApiGetBorrowerApplicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerApplications(requestParameters: BorrowerPortalApiGetBorrowerApplicationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanApplicationDtoBorrowerAllowed> {
            return localVarFp.getBorrowerApplications(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return borrower\'s loan
         * @param {BorrowerPortalApiGetBorrowerLoanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerLoan(requestParameters: BorrowerPortalApiGetBorrowerLoanRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAgentLoan200Response> {
            return localVarFp.getBorrowerLoan(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loans for borrower
         * @param {BorrowerPortalApiGetBorrowerLoansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerLoans(requestParameters: BorrowerPortalApiGetBorrowerLoansRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanDtoBorrowerAllowed> {
            return localVarFp.getBorrowerLoans(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return borrower profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerProfile(options?: RawAxiosRequestConfig): AxiosPromise<BorrowerDtoBorrowerAllowed> {
            return localVarFp.getBorrowerProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get borrower settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerSettings(options?: RawAxiosRequestConfig): AxiosPromise<BorrowerSettingsResponse> {
            return localVarFp.getBorrowerSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return loan adjustments request for borrower
         * @param {BorrowerPortalApiGetLoanAdjustmentsRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAdjustmentsRequest(requestParameters: BorrowerPortalApiGetLoanAdjustmentsRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanAdjustmentsRequestDtoBorrowerAllowed> {
            return localVarFp.getLoanAdjustmentsRequest(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loan adjustments requests  for borrower
         * @param {BorrowerPortalApiGetLoanAdjustmentsRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAdjustmentsRequests(requestParameters: BorrowerPortalApiGetLoanAdjustmentsRequestsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanAdjustmentsRequestDtoBorrowerAllowed> {
            return localVarFp.getLoanAdjustmentsRequests(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterLoanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save borrower\'s UTM parameters
         * @param {BorrowerPortalApiSaveUtmParamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUtmParams(requestParameters: BorrowerPortalApiSaveUtmParamsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveUtmParams(requestParameters.utmParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or update borrower settings
         * @param {BorrowerPortalApiUpdateBorrowerSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBorrowerSettings(requestParameters: BorrowerPortalApiUpdateBorrowerSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BorrowerSettingsResponse> {
            return localVarFp.updateBorrowerSettings(requestParameters.updateBorrowerSettingsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAllTransactionsByLoanId operation in BorrowerPortalApi.
 */
export interface BorrowerPortalApiFindAllTransactionsByLoanIdRequest {
    readonly id: number

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for getBorrowerApplication operation in BorrowerPortalApi.
 */
export interface BorrowerPortalApiGetBorrowerApplicationRequest {
    readonly id: number
}

/**
 * Request parameters for getBorrowerApplications operation in BorrowerPortalApi.
 */
export interface BorrowerPortalApiGetBorrowerApplicationsRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for getBorrowerLoan operation in BorrowerPortalApi.
 */
export interface BorrowerPortalApiGetBorrowerLoanRequest {
    readonly id: number
}

/**
 * Request parameters for getBorrowerLoans operation in BorrowerPortalApi.
 */
export interface BorrowerPortalApiGetBorrowerLoansRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for getLoanAdjustmentsRequest operation in BorrowerPortalApi.
 */
export interface BorrowerPortalApiGetLoanAdjustmentsRequestRequest {
    readonly id: string
}

/**
 * Request parameters for getLoanAdjustmentsRequests operation in BorrowerPortalApi.
 */
export interface BorrowerPortalApiGetLoanAdjustmentsRequestsRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Search by loan adjustments request statuses
     */
    readonly filterStatuses?: Array<string>

    /**
     * Search by loan id
     */
    readonly filterLoanId?: Array<number>
}

/**
 * Request parameters for saveUtmParams operation in BorrowerPortalApi.
 */
export interface BorrowerPortalApiSaveUtmParamsRequest {
    /**
     * Collection of UTM parameters that should be stored for the authenticated user
     */
    readonly utmParam: Array<UtmParam>
}

/**
 * Request parameters for updateBorrowerSettings operation in BorrowerPortalApi.
 */
export interface BorrowerPortalApiUpdateBorrowerSettingsRequest {
    readonly updateBorrowerSettingsRequest: UpdateBorrowerSettingsRequest
}

/**
 * BorrowerPortalApi - object-oriented interface
 */
export class BorrowerPortalApi extends BaseAPI {
    /**
     * 
     * @summary Return list of loan\'s transactions for borrower
     * @param {BorrowerPortalApiFindAllTransactionsByLoanIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllTransactionsByLoanId(requestParameters: BorrowerPortalApiFindAllTransactionsByLoanIdRequest, options?: RawAxiosRequestConfig) {
        return BorrowerPortalApiFp(this.configuration).findAllTransactionsByLoanId(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return borrower\'s loan application
     * @param {BorrowerPortalApiGetBorrowerApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBorrowerApplication(requestParameters: BorrowerPortalApiGetBorrowerApplicationRequest, options?: RawAxiosRequestConfig) {
        return BorrowerPortalApiFp(this.configuration).getBorrowerApplication(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loan applications for borrower
     * @param {BorrowerPortalApiGetBorrowerApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBorrowerApplications(requestParameters: BorrowerPortalApiGetBorrowerApplicationsRequest = {}, options?: RawAxiosRequestConfig) {
        return BorrowerPortalApiFp(this.configuration).getBorrowerApplications(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return borrower\'s loan
     * @param {BorrowerPortalApiGetBorrowerLoanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBorrowerLoan(requestParameters: BorrowerPortalApiGetBorrowerLoanRequest, options?: RawAxiosRequestConfig) {
        return BorrowerPortalApiFp(this.configuration).getBorrowerLoan(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loans for borrower
     * @param {BorrowerPortalApiGetBorrowerLoansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBorrowerLoans(requestParameters: BorrowerPortalApiGetBorrowerLoansRequest = {}, options?: RawAxiosRequestConfig) {
        return BorrowerPortalApiFp(this.configuration).getBorrowerLoans(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return borrower profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBorrowerProfile(options?: RawAxiosRequestConfig) {
        return BorrowerPortalApiFp(this.configuration).getBorrowerProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get borrower settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBorrowerSettings(options?: RawAxiosRequestConfig) {
        return BorrowerPortalApiFp(this.configuration).getBorrowerSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return loan adjustments request for borrower
     * @param {BorrowerPortalApiGetLoanAdjustmentsRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLoanAdjustmentsRequest(requestParameters: BorrowerPortalApiGetLoanAdjustmentsRequestRequest, options?: RawAxiosRequestConfig) {
        return BorrowerPortalApiFp(this.configuration).getLoanAdjustmentsRequest(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loan adjustments requests  for borrower
     * @param {BorrowerPortalApiGetLoanAdjustmentsRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLoanAdjustmentsRequests(requestParameters: BorrowerPortalApiGetLoanAdjustmentsRequestsRequest = {}, options?: RawAxiosRequestConfig) {
        return BorrowerPortalApiFp(this.configuration).getLoanAdjustmentsRequests(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterLoanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save borrower\'s UTM parameters
     * @param {BorrowerPortalApiSaveUtmParamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public saveUtmParams(requestParameters: BorrowerPortalApiSaveUtmParamsRequest, options?: RawAxiosRequestConfig) {
        return BorrowerPortalApiFp(this.configuration).saveUtmParams(requestParameters.utmParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or update borrower settings
     * @param {BorrowerPortalApiUpdateBorrowerSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBorrowerSettings(requestParameters: BorrowerPortalApiUpdateBorrowerSettingsRequest, options?: RawAxiosRequestConfig) {
        return BorrowerPortalApiFp(this.configuration).updateBorrowerSettings(requestParameters.updateBorrowerSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CampaignApi - axios parameter creator
 */
export const CampaignApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create campaign
         * @param {CreateCampaignRequest} createCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign: async (createCampaignRequest: CreateCampaignRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCampaignRequest' is not null or undefined
            assertParamExists('createCampaign', 'createCampaignRequest', createCampaignRequest)
            const localVarPath = `/api/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCampaignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of campaigns
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [filterMaxAmount] 
         * @param {number} [filterMaxTerm] 
         * @param {boolean} [filterActive] 
         * @param {string} [filterSearch] 
         * @param {number} [filterAgentId] 
         * @param {number} [campaignFilterRequestFilterMaxAmount] Search by campaign max amount
         * @param {number} [campaignFilterRequestFilterMaxTerm] Search by campaign max term
         * @param {boolean} [campaignFilterRequestFilterActive] Search by campaign active flag
         * @param {string} [campaignFilterRequestFilterSearch] Search by campaign name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllCampaigns: async (page?: number, size?: number, sort?: Array<string>, filterMaxAmount?: number, filterMaxTerm?: number, filterActive?: boolean, filterSearch?: string, filterAgentId?: number, campaignFilterRequestFilterMaxAmount?: number, campaignFilterRequestFilterMaxTerm?: number, campaignFilterRequestFilterActive?: boolean, campaignFilterRequestFilterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterMaxAmount !== undefined) {
                localVarQueryParameter['filter.maxAmount'] = filterMaxAmount;
            }

            if (filterMaxTerm !== undefined) {
                localVarQueryParameter['filter.maxTerm'] = filterMaxTerm;
            }

            if (filterActive !== undefined) {
                localVarQueryParameter['filter.active'] = filterActive;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterAgentId !== undefined) {
                localVarQueryParameter['filter.agentId'] = filterAgentId;
            }

            if (campaignFilterRequestFilterMaxAmount !== undefined) {
                localVarQueryParameter['campaignFilterRequest.filter.maxAmount'] = campaignFilterRequestFilterMaxAmount;
            }

            if (campaignFilterRequestFilterMaxTerm !== undefined) {
                localVarQueryParameter['campaignFilterRequest.filter.maxTerm'] = campaignFilterRequestFilterMaxTerm;
            }

            if (campaignFilterRequestFilterActive !== undefined) {
                localVarQueryParameter['campaignFilterRequest.filter.active'] = campaignFilterRequestFilterActive;
            }

            if (campaignFilterRequestFilterSearch !== undefined) {
                localVarQueryParameter['campaignFilterRequest.filter.search'] = campaignFilterRequestFilterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return campaign
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaign: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCampaign', 'id', id)
            const localVarPath = `/api/campaigns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return current internal scoring model
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentInternalScoringModel: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCurrentInternalScoringModel', 'id', id)
            const localVarPath = `/api/campaigns/{id}/scoring/internal/model`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of GiniMachine scoring models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiniMachineScoringModels: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/campaigns/scoring/ginimachine/model`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of internal scoring models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternalScoringModels: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/campaigns/scoring/internal/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update campaign
         * @param {number} id 
         * @param {UpdateCampaignRequest} updateCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaign: async (id: number, updateCampaignRequest: UpdateCampaignRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCampaign', 'id', id)
            // verify required parameter 'updateCampaignRequest' is not null or undefined
            assertParamExists('updateCampaign', 'updateCampaignRequest', updateCampaignRequest)
            const localVarPath = `/api/campaigns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCampaignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignApi - functional programming interface
 */
export const CampaignApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CampaignApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create campaign
         * @param {CreateCampaignRequest} createCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCampaign(createCampaignRequest: CreateCampaignRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCampaign(createCampaignRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.createCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of campaigns
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [filterMaxAmount] 
         * @param {number} [filterMaxTerm] 
         * @param {boolean} [filterActive] 
         * @param {string} [filterSearch] 
         * @param {number} [filterAgentId] 
         * @param {number} [campaignFilterRequestFilterMaxAmount] Search by campaign max amount
         * @param {number} [campaignFilterRequestFilterMaxTerm] Search by campaign max term
         * @param {boolean} [campaignFilterRequestFilterActive] Search by campaign active flag
         * @param {string} [campaignFilterRequestFilterSearch] Search by campaign name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllCampaigns(page?: number, size?: number, sort?: Array<string>, filterMaxAmount?: number, filterMaxTerm?: number, filterActive?: boolean, filterSearch?: string, filterAgentId?: number, campaignFilterRequestFilterMaxAmount?: number, campaignFilterRequestFilterMaxTerm?: number, campaignFilterRequestFilterActive?: boolean, campaignFilterRequestFilterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCampaignDtoBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllCampaigns(page, size, sort, filterMaxAmount, filterMaxTerm, filterActive, filterSearch, filterAgentId, campaignFilterRequestFilterMaxAmount, campaignFilterRequestFilterMaxTerm, campaignFilterRequestFilterActive, campaignFilterRequestFilterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.findAllCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return campaign
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaign(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaign(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.getCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return current internal scoring model
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentInternalScoringModel(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalScoringModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentInternalScoringModel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.getCurrentInternalScoringModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of GiniMachine scoring models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGiniMachineScoringModels(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GiniMachineScoringModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGiniMachineScoringModels(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.getGiniMachineScoringModels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of internal scoring models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInternalScoringModels(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InternalScoringModelDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInternalScoringModels(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.getInternalScoringModels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update campaign
         * @param {number} id 
         * @param {UpdateCampaignRequest} updateCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCampaign(id: number, updateCampaignRequest: UpdateCampaignRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCampaign(id, updateCampaignRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.updateCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CampaignApi - factory interface
 */
export const CampaignApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CampaignApiFp(configuration)
    return {
        /**
         * 
         * @summary Create campaign
         * @param {CampaignApiCreateCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign(requestParameters: CampaignApiCreateCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignDto> {
            return localVarFp.createCampaign(requestParameters.createCampaignRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of campaigns
         * @param {CampaignApiFindAllCampaignsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllCampaigns(requestParameters: CampaignApiFindAllCampaignsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageCampaignDtoBrief> {
            return localVarFp.findAllCampaigns(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterMaxAmount, requestParameters.filterMaxTerm, requestParameters.filterActive, requestParameters.filterSearch, requestParameters.filterAgentId, requestParameters.campaignFilterRequestFilterMaxAmount, requestParameters.campaignFilterRequestFilterMaxTerm, requestParameters.campaignFilterRequestFilterActive, requestParameters.campaignFilterRequestFilterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return campaign
         * @param {CampaignApiGetCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaign(requestParameters: CampaignApiGetCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignDto> {
            return localVarFp.getCampaign(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return current internal scoring model
         * @param {CampaignApiGetCurrentInternalScoringModelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentInternalScoringModel(requestParameters: CampaignApiGetCurrentInternalScoringModelRequest, options?: RawAxiosRequestConfig): AxiosPromise<InternalScoringModelDto> {
            return localVarFp.getCurrentInternalScoringModel(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of GiniMachine scoring models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiniMachineScoringModels(options?: RawAxiosRequestConfig): AxiosPromise<Array<GiniMachineScoringModel>> {
            return localVarFp.getGiniMachineScoringModels(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of internal scoring models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternalScoringModels(options?: RawAxiosRequestConfig): AxiosPromise<Array<InternalScoringModelDto>> {
            return localVarFp.getInternalScoringModels(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update campaign
         * @param {CampaignApiUpdateCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaign(requestParameters: CampaignApiUpdateCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignDto> {
            return localVarFp.updateCampaign(requestParameters.id, requestParameters.updateCampaignRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createCampaign operation in CampaignApi.
 */
export interface CampaignApiCreateCampaignRequest {
    readonly createCampaignRequest: CreateCampaignRequest
}

/**
 * Request parameters for findAllCampaigns operation in CampaignApi.
 */
export interface CampaignApiFindAllCampaignsRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    readonly filterMaxAmount?: number

    readonly filterMaxTerm?: number

    readonly filterActive?: boolean

    readonly filterSearch?: string

    readonly filterAgentId?: number

    /**
     * Search by campaign max amount
     */
    readonly campaignFilterRequestFilterMaxAmount?: number

    /**
     * Search by campaign max term
     */
    readonly campaignFilterRequestFilterMaxTerm?: number

    /**
     * Search by campaign active flag
     */
    readonly campaignFilterRequestFilterActive?: boolean

    /**
     * Search by campaign name
     */
    readonly campaignFilterRequestFilterSearch?: string
}

/**
 * Request parameters for getCampaign operation in CampaignApi.
 */
export interface CampaignApiGetCampaignRequest {
    readonly id: number
}

/**
 * Request parameters for getCurrentInternalScoringModel operation in CampaignApi.
 */
export interface CampaignApiGetCurrentInternalScoringModelRequest {
    readonly id: number
}

/**
 * Request parameters for updateCampaign operation in CampaignApi.
 */
export interface CampaignApiUpdateCampaignRequest {
    readonly id: number

    readonly updateCampaignRequest: UpdateCampaignRequest
}

/**
 * CampaignApi - object-oriented interface
 */
export class CampaignApi extends BaseAPI {
    /**
     * 
     * @summary Create campaign
     * @param {CampaignApiCreateCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCampaign(requestParameters: CampaignApiCreateCampaignRequest, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).createCampaign(requestParameters.createCampaignRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of campaigns
     * @param {CampaignApiFindAllCampaignsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllCampaigns(requestParameters: CampaignApiFindAllCampaignsRequest = {}, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).findAllCampaigns(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterMaxAmount, requestParameters.filterMaxTerm, requestParameters.filterActive, requestParameters.filterSearch, requestParameters.filterAgentId, requestParameters.campaignFilterRequestFilterMaxAmount, requestParameters.campaignFilterRequestFilterMaxTerm, requestParameters.campaignFilterRequestFilterActive, requestParameters.campaignFilterRequestFilterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return campaign
     * @param {CampaignApiGetCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCampaign(requestParameters: CampaignApiGetCampaignRequest, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).getCampaign(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return current internal scoring model
     * @param {CampaignApiGetCurrentInternalScoringModelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentInternalScoringModel(requestParameters: CampaignApiGetCurrentInternalScoringModelRequest, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).getCurrentInternalScoringModel(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of GiniMachine scoring models
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGiniMachineScoringModels(options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).getGiniMachineScoringModels(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of internal scoring models
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInternalScoringModels(options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).getInternalScoringModels(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update campaign
     * @param {CampaignApiUpdateCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCampaign(requestParameters: CampaignApiUpdateCampaignRequest, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).updateCampaign(requestParameters.id, requestParameters.updateCampaignRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CollateralApi - axios parameter creator
 */
export const CollateralApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of all collaterals
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterSearch] Search by loan id, collateral registrationNumber
         * @param {Array<string>} [filterCollateralTypes] Filter by collateral types (REAL_ESTATE, VEHICLES, EQUIPMENT_AND_MACHINERY, SECURITIES, OTHER)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllCollaterals: async (page?: number, size?: number, sort?: Array<string>, filterSearch?: string, filterCollateralTypes?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/collaterals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterCollateralTypes) {
                localVarQueryParameter['filter.collateralTypes'] = filterCollateralTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single collateral
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollateral: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCollateral', 'id', id)
            const localVarPath = `/api/collaterals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CollateralApi - functional programming interface
 */
export const CollateralApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CollateralApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of all collaterals
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterSearch] Search by loan id, collateral registrationNumber
         * @param {Array<string>} [filterCollateralTypes] Filter by collateral types (REAL_ESTATE, VEHICLES, EQUIPMENT_AND_MACHINERY, SECURITIES, OTHER)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllCollaterals(page?: number, size?: number, sort?: Array<string>, filterSearch?: string, filterCollateralTypes?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCollateralDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllCollaterals(page, size, sort, filterSearch, filterCollateralTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollateralApi.findAllCollaterals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return single collateral
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollateral(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollateralDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollateral(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollateralApi.getCollateral']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CollateralApi - factory interface
 */
export const CollateralApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CollateralApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of all collaterals
         * @param {CollateralApiFindAllCollateralsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllCollaterals(requestParameters: CollateralApiFindAllCollateralsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageCollateralDto> {
            return localVarFp.findAllCollaterals(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterSearch, requestParameters.filterCollateralTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single collateral
         * @param {CollateralApiGetCollateralRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollateral(requestParameters: CollateralApiGetCollateralRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollateralDto> {
            return localVarFp.getCollateral(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAllCollaterals operation in CollateralApi.
 */
export interface CollateralApiFindAllCollateralsRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Search by loan id, collateral registrationNumber
     */
    readonly filterSearch?: string

    /**
     * Filter by collateral types (REAL_ESTATE, VEHICLES, EQUIPMENT_AND_MACHINERY, SECURITIES, OTHER)
     */
    readonly filterCollateralTypes?: Array<string>
}

/**
 * Request parameters for getCollateral operation in CollateralApi.
 */
export interface CollateralApiGetCollateralRequest {
    readonly id: number
}

/**
 * CollateralApi - object-oriented interface
 */
export class CollateralApi extends BaseAPI {
    /**
     * 
     * @summary Return list of all collaterals
     * @param {CollateralApiFindAllCollateralsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllCollaterals(requestParameters: CollateralApiFindAllCollateralsRequest = {}, options?: RawAxiosRequestConfig) {
        return CollateralApiFp(this.configuration).findAllCollaterals(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterSearch, requestParameters.filterCollateralTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single collateral
     * @param {CollateralApiGetCollateralRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCollateral(requestParameters: CollateralApiGetCollateralRequest, options?: RawAxiosRequestConfig) {
        return CollateralApiFp(this.configuration).getCollateral(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CollectionApi - axios parameter creator
 */
export const CollectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of collections
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by collection statuses
         * @param {string} [filterSearch] Search by collection number; borrower\&#39;s full name, phone, email
         * @param {string} [filterStartedAtFrom] Search by collection started at from
         * @param {string} [filterStartedAtTo] Search by collection started at to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllCollections: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterSearch?: string, filterStartedAtFrom?: string, filterStartedAtTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterStartedAtFrom !== undefined) {
                localVarQueryParameter['filter.startedAtFrom'] = (filterStartedAtFrom as any instanceof Date) ?
                    (filterStartedAtFrom as any).toISOString() :
                    filterStartedAtFrom;
            }

            if (filterStartedAtTo !== undefined) {
                localVarQueryParameter['filter.startedAtTo'] = (filterStartedAtTo as any instanceof Date) ?
                    (filterStartedAtTo as any).toISOString() :
                    filterStartedAtTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single collection
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollection: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCollection', 'id', id)
            const localVarPath = `/api/collections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CollectionApi - functional programming interface
 */
export const CollectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CollectionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of collections
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by collection statuses
         * @param {string} [filterSearch] Search by collection number; borrower\&#39;s full name, phone, email
         * @param {string} [filterStartedAtFrom] Search by collection started at from
         * @param {string} [filterStartedAtTo] Search by collection started at to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllCollections(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterSearch?: string, filterStartedAtFrom?: string, filterStartedAtTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCollectionItemDtoBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllCollections(page, size, sort, filterStatuses, filterSearch, filterStartedAtFrom, filterStartedAtTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionApi.findAllCollections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return single collection
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollection(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollection(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionApi.getCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CollectionApi - factory interface
 */
export const CollectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CollectionApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of collections
         * @param {CollectionApiFindAllCollectionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllCollections(requestParameters: CollectionApiFindAllCollectionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageCollectionItemDtoBrief> {
            return localVarFp.findAllCollections(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterSearch, requestParameters.filterStartedAtFrom, requestParameters.filterStartedAtTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single collection
         * @param {CollectionApiGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollection(requestParameters: CollectionApiGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionDto> {
            return localVarFp.getCollection(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAllCollections operation in CollectionApi.
 */
export interface CollectionApiFindAllCollectionsRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Search by collection statuses
     */
    readonly filterStatuses?: Array<string>

    /**
     * Search by collection number; borrower\&#39;s full name, phone, email
     */
    readonly filterSearch?: string

    /**
     * Search by collection started at from
     */
    readonly filterStartedAtFrom?: string

    /**
     * Search by collection started at to
     */
    readonly filterStartedAtTo?: string
}

/**
 * Request parameters for getCollection operation in CollectionApi.
 */
export interface CollectionApiGetCollectionRequest {
    readonly id: number
}

/**
 * CollectionApi - object-oriented interface
 */
export class CollectionApi extends BaseAPI {
    /**
     * 
     * @summary Return list of collections
     * @param {CollectionApiFindAllCollectionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllCollections(requestParameters: CollectionApiFindAllCollectionsRequest = {}, options?: RawAxiosRequestConfig) {
        return CollectionApiFp(this.configuration).findAllCollections(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterSearch, requestParameters.filterStartedAtFrom, requestParameters.filterStartedAtTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single collection
     * @param {CollectionApiGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCollection(requestParameters: CollectionApiGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return CollectionApiFp(this.configuration).getCollection(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentTemplateApi - axios parameter creator
 */
export const DocumentTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete document template by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentTemplate: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDocumentTemplate', 'id', id)
            const localVarPath = `/api/settings/document-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of document templates
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterType] Filter by document template\&#39;s type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDocumentTemplates: async (page?: number, size?: number, sort?: Array<string>, filterType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/document-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterType !== undefined) {
                localVarQueryParameter['filter.type'] = filterType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate template placeholders
         * @param {string} fileUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTemplateByFileUuid: async (fileUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileUuid' is not null or undefined
            assertParamExists('validateTemplateByFileUuid', 'fileUuid', fileUuid)
            const localVarPath = `/api/settings/document-templates/{fileUuid}`
                .replace(`{${"fileUuid"}}`, encodeURIComponent(String(fileUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentTemplateApi - functional programming interface
 */
export const DocumentTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete document template by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentTemplate(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumentTemplate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTemplateApi.deleteDocumentTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of document templates
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterType] Filter by document template\&#39;s type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllDocumentTemplates(page?: number, size?: number, sort?: Array<string>, filterType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDocumentTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllDocumentTemplates(page, size, sort, filterType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTemplateApi.findAllDocumentTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate template placeholders
         * @param {string} fileUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateTemplateByFileUuid(fileUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateTemplateByFileUuid(fileUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTemplateApi.validateTemplateByFileUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentTemplateApi - factory interface
 */
export const DocumentTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentTemplateApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete document template by ID
         * @param {DocumentTemplateApiDeleteDocumentTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentTemplate(requestParameters: DocumentTemplateApiDeleteDocumentTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDocumentTemplate(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of document templates
         * @param {DocumentTemplateApiFindAllDocumentTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDocumentTemplates(requestParameters: DocumentTemplateApiFindAllDocumentTemplatesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageDocumentTemplateDto> {
            return localVarFp.findAllDocumentTemplates(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate template placeholders
         * @param {DocumentTemplateApiValidateTemplateByFileUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTemplateByFileUuid(requestParameters: DocumentTemplateApiValidateTemplateByFileUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.validateTemplateByFileUuid(requestParameters.fileUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteDocumentTemplate operation in DocumentTemplateApi.
 */
export interface DocumentTemplateApiDeleteDocumentTemplateRequest {
    readonly id: number
}

/**
 * Request parameters for findAllDocumentTemplates operation in DocumentTemplateApi.
 */
export interface DocumentTemplateApiFindAllDocumentTemplatesRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Filter by document template\&#39;s type
     */
    readonly filterType?: string
}

/**
 * Request parameters for validateTemplateByFileUuid operation in DocumentTemplateApi.
 */
export interface DocumentTemplateApiValidateTemplateByFileUuidRequest {
    readonly fileUuid: string
}

/**
 * DocumentTemplateApi - object-oriented interface
 */
export class DocumentTemplateApi extends BaseAPI {
    /**
     * 
     * @summary Delete document template by ID
     * @param {DocumentTemplateApiDeleteDocumentTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDocumentTemplate(requestParameters: DocumentTemplateApiDeleteDocumentTemplateRequest, options?: RawAxiosRequestConfig) {
        return DocumentTemplateApiFp(this.configuration).deleteDocumentTemplate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of document templates
     * @param {DocumentTemplateApiFindAllDocumentTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllDocumentTemplates(requestParameters: DocumentTemplateApiFindAllDocumentTemplatesRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentTemplateApiFp(this.configuration).findAllDocumentTemplates(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate template placeholders
     * @param {DocumentTemplateApiValidateTemplateByFileUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateTemplateByFileUuid(requestParameters: DocumentTemplateApiValidateTemplateByFileUuidRequest, options?: RawAxiosRequestConfig) {
        return DocumentTemplateApiFp(this.configuration).validateTemplateByFileUuid(requestParameters.fileUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentTemplatesApi - axios parameter creator
 */
export const DocumentTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of available templates in requested folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTemplates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-templates/**`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentTemplatesApi - functional programming interface
 */
export const DocumentTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of available templates in requested folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllTemplates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TemplateDescription>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllTemplates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTemplatesApi.findAllTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentTemplatesApi - factory interface
 */
export const DocumentTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of available templates in requested folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTemplates(options?: RawAxiosRequestConfig): AxiosPromise<Array<TemplateDescription>> {
            return localVarFp.findAllTemplates(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentTemplatesApi - object-oriented interface
 */
export class DocumentTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Return list of available templates in requested folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllTemplates(options?: RawAxiosRequestConfig) {
        return DocumentTemplatesApiFp(this.configuration).findAllTemplates(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FileStorageApi - axios parameter creator
 */
export const FileStorageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes a file from configured storage
         * @summary File deletion
         * @param {string} fileUuid The file name to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (fileUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileUuid' is not null or undefined
            assertParamExists('_delete', 'fileUuid', fileUuid)
            const localVarPath = `/api/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (fileUuid !== undefined) {
                localVarQueryParameter['fileUuid'] = fileUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a file from configured storage or pre-generated location
         * @summary File download
         * @param {string} fileUuid The file UUID to retrieve
         * @param {boolean} [asAttachment] The download file content disposition. True - \&#39;attachment\&#39;, false - \&#39;inline\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download: async (fileUuid: string, asAttachment?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileUuid' is not null or undefined
            assertParamExists('download', 'fileUuid', fileUuid)
            const localVarPath = `/api/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (fileUuid !== undefined) {
                localVarQueryParameter['fileUuid'] = fileUuid;
            }

            if (asAttachment !== undefined) {
                localVarQueryParameter['asAttachment'] = asAttachment;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Receives a file and stores it in configured storage
         * @summary File upload
         * @param {string} dir The directory to store file into
         * @param {File} file The file content to store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: async (dir: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dir' is not null or undefined
            assertParamExists('upload', 'dir', dir)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('upload', 'file', file)
            const localVarPath = `/api/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (dir !== undefined) {
                localVarQueryParameter['dir'] = dir;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileStorageApi - functional programming interface
 */
export const FileStorageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileStorageApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes a file from configured storage
         * @summary File deletion
         * @param {string} fileUuid The file name to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(fileUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(fileUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileStorageApi._delete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a file from configured storage or pre-generated location
         * @summary File download
         * @param {string} fileUuid The file UUID to retrieve
         * @param {boolean} [asAttachment] The download file content disposition. True - \&#39;attachment\&#39;, false - \&#39;inline\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async download(fileUuid: string, asAttachment?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.download(fileUuid, asAttachment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileStorageApi.download']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Receives a file and stores it in configured storage
         * @summary File upload
         * @param {string} dir The directory to store file into
         * @param {File} file The file content to store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upload(dir: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upload(dir, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileStorageApi.upload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileStorageApi - factory interface
 */
export const FileStorageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileStorageApiFp(configuration)
    return {
        /**
         * Deletes a file from configured storage
         * @summary File deletion
         * @param {FileStorageApiDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(requestParameters: FileStorageApiDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp._delete(requestParameters.fileUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a file from configured storage or pre-generated location
         * @summary File download
         * @param {FileStorageApiDownloadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download(requestParameters: FileStorageApiDownloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.download(requestParameters.fileUuid, requestParameters.asAttachment, options).then((request) => request(axios, basePath));
        },
        /**
         * Receives a file and stores it in configured storage
         * @summary File upload
         * @param {FileStorageApiUploadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(requestParameters: FileStorageApiUploadRequest, options?: RawAxiosRequestConfig): AxiosPromise<FileUploadResponse> {
            return localVarFp.upload(requestParameters.dir, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for _delete operation in FileStorageApi.
 */
export interface FileStorageApiDeleteRequest {
    /**
     * The file name to delete
     */
    readonly fileUuid: string
}

/**
 * Request parameters for download operation in FileStorageApi.
 */
export interface FileStorageApiDownloadRequest {
    /**
     * The file UUID to retrieve
     */
    readonly fileUuid: string

    /**
     * The download file content disposition. True - \&#39;attachment\&#39;, false - \&#39;inline\&#39;
     */
    readonly asAttachment?: boolean
}

/**
 * Request parameters for upload operation in FileStorageApi.
 */
export interface FileStorageApiUploadRequest {
    /**
     * The directory to store file into
     */
    readonly dir: string

    /**
     * The file content to store
     */
    readonly file: File
}

/**
 * FileStorageApi - object-oriented interface
 */
export class FileStorageApi extends BaseAPI {
    /**
     * Deletes a file from configured storage
     * @summary File deletion
     * @param {FileStorageApiDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public _delete(requestParameters: FileStorageApiDeleteRequest, options?: RawAxiosRequestConfig) {
        return FileStorageApiFp(this.configuration)._delete(requestParameters.fileUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a file from configured storage or pre-generated location
     * @summary File download
     * @param {FileStorageApiDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public download(requestParameters: FileStorageApiDownloadRequest, options?: RawAxiosRequestConfig) {
        return FileStorageApiFp(this.configuration).download(requestParameters.fileUuid, requestParameters.asAttachment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Receives a file and stores it in configured storage
     * @summary File upload
     * @param {FileStorageApiUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public upload(requestParameters: FileStorageApiUploadRequest, options?: RawAxiosRequestConfig) {
        return FileStorageApiFp(this.configuration).upload(requestParameters.dir, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IntegrationApi - axios parameter creator
 */
export const IntegrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a loan based on the loan application
         * @param {RequestLoanManagement} requestLoanManagement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageLoan: async (requestLoanManagement: RequestLoanManagement, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestLoanManagement' is not null or undefined
            assertParamExists('manageLoan', 'requestLoanManagement', requestLoanManagement)
            const localVarPath = `/api/integration/v1/manage-loan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestLoanManagement, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Originate and manage loan application with borrower as legal entity
         * @param {Array<any>} balanceSheet List of Balance sheet files
         * @param {Array<any>} idDocument List of files of the document identifying the representative of the legal entity
         * @param {Array<any>} pnlStatement List of Profit and loss statement files
         * @param {RequestLegalEntityLoanOrigination} request 
         * @param {string} [callbackUrl] URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateAndManageLoanLegalEntity: async (balanceSheet: Array<any>, idDocument: Array<any>, pnlStatement: Array<any>, request: RequestLegalEntityLoanOrigination, callbackUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'balanceSheet' is not null or undefined
            assertParamExists('originateAndManageLoanLegalEntity', 'balanceSheet', balanceSheet)
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('originateAndManageLoanLegalEntity', 'idDocument', idDocument)
            // verify required parameter 'pnlStatement' is not null or undefined
            assertParamExists('originateAndManageLoanLegalEntity', 'pnlStatement', pnlStatement)
            // verify required parameter 'request' is not null or undefined
            assertParamExists('originateAndManageLoanLegalEntity', 'request', request)
            const localVarPath = `/api/integration/v1/originate-and-manage-loan-legal-entity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (balanceSheet) {
                localVarFormParams.append('balanceSheet', balanceSheet.join(COLLECTION_FORMATS.csv));
            }

    
            if (callbackUrl !== undefined) { 
                localVarFormParams.append('callbackUrl', callbackUrl as any);
            }
                if (idDocument) {
                localVarFormParams.append('idDocument', idDocument.join(COLLECTION_FORMATS.csv));
            }

                if (pnlStatement) {
                localVarFormParams.append('pnlStatement', pnlStatement.join(COLLECTION_FORMATS.csv));
            }

    
            if (request !== undefined) { 
                localVarFormParams.append('request', new Blob([JSON.stringify(request)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Originate and manage loan application with borrower as person
         * @param {Array<any>} idDocument List of the identification document\\\&#39;s files
         * @param {RequestPersonLoanOrigination} request 
         * @param {string} [callbackUrl] URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateAndManageLoanPerson: async (idDocument: Array<any>, request: RequestPersonLoanOrigination, callbackUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('originateAndManageLoanPerson', 'idDocument', idDocument)
            // verify required parameter 'request' is not null or undefined
            assertParamExists('originateAndManageLoanPerson', 'request', request)
            const localVarPath = `/api/integration/v1/originate-and-manage-loan-person`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


            if (callbackUrl !== undefined) { 
                localVarFormParams.append('callbackUrl', callbackUrl as any);
            }
                if (idDocument) {
                localVarFormParams.append('idDocument', idDocument.join(COLLECTION_FORMATS.csv));
            }

    
            if (request !== undefined) { 
                localVarFormParams.append('request', new Blob([JSON.stringify(request)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Originate loan application with borrower as legal entity
         * @param {Array<any>} balanceSheet List of Balance sheet files
         * @param {string} callbackUrl URL for sending a callback with a processed loan application
         * @param {Array<any>} idDocument List of files of the document identifying the representative of the legal entity
         * @param {Array<any>} pnlStatement List of Profit and loss statement files
         * @param {RequestLegalEntityLoanOrigination} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateLoanLegalEntity: async (balanceSheet: Array<any>, callbackUrl: string, idDocument: Array<any>, pnlStatement: Array<any>, request: RequestLegalEntityLoanOrigination, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'balanceSheet' is not null or undefined
            assertParamExists('originateLoanLegalEntity', 'balanceSheet', balanceSheet)
            // verify required parameter 'callbackUrl' is not null or undefined
            assertParamExists('originateLoanLegalEntity', 'callbackUrl', callbackUrl)
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('originateLoanLegalEntity', 'idDocument', idDocument)
            // verify required parameter 'pnlStatement' is not null or undefined
            assertParamExists('originateLoanLegalEntity', 'pnlStatement', pnlStatement)
            // verify required parameter 'request' is not null or undefined
            assertParamExists('originateLoanLegalEntity', 'request', request)
            const localVarPath = `/api/integration/v1/originate-loan-legal-entity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (balanceSheet) {
                localVarFormParams.append('balanceSheet', balanceSheet.join(COLLECTION_FORMATS.csv));
            }

    
            if (callbackUrl !== undefined) { 
                localVarFormParams.append('callbackUrl', callbackUrl as any);
            }
                if (idDocument) {
                localVarFormParams.append('idDocument', idDocument.join(COLLECTION_FORMATS.csv));
            }

                if (pnlStatement) {
                localVarFormParams.append('pnlStatement', pnlStatement.join(COLLECTION_FORMATS.csv));
            }

    
            if (request !== undefined) { 
                localVarFormParams.append('request', new Blob([JSON.stringify(request)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Originate loan application with borrower as person
         * @param {string} callbackUrl URL for sending a callback with a processed loan application
         * @param {Array<any>} idDocument List of the identification document\\\&#39;s files
         * @param {RequestPersonLoanOrigination} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateLoanPerson: async (callbackUrl: string, idDocument: Array<any>, request: RequestPersonLoanOrigination, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callbackUrl' is not null or undefined
            assertParamExists('originateLoanPerson', 'callbackUrl', callbackUrl)
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('originateLoanPerson', 'idDocument', idDocument)
            // verify required parameter 'request' is not null or undefined
            assertParamExists('originateLoanPerson', 'request', request)
            const localVarPath = `/api/integration/v1/originate-loan-person`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


            if (callbackUrl !== undefined) { 
                localVarFormParams.append('callbackUrl', callbackUrl as any);
            }
                if (idDocument) {
                localVarFormParams.append('idDocument', idDocument.join(COLLECTION_FORMATS.csv));
            }

    
            if (request !== undefined) { 
                localVarFormParams.append('request', new Blob([JSON.stringify(request)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationApi - functional programming interface
 */
export const IntegrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a loan based on the loan application
         * @param {RequestLoanManagement} requestLoanManagement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageLoan(requestLoanManagement: RequestLoanManagement, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manageLoan(requestLoanManagement, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApi.manageLoan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Originate and manage loan application with borrower as legal entity
         * @param {Array<any>} balanceSheet List of Balance sheet files
         * @param {Array<any>} idDocument List of files of the document identifying the representative of the legal entity
         * @param {Array<any>} pnlStatement List of Profit and loss statement files
         * @param {RequestLegalEntityLoanOrigination} request 
         * @param {string} [callbackUrl] URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async originateAndManageLoanLegalEntity(balanceSheet: Array<any>, idDocument: Array<any>, pnlStatement: Array<any>, request: RequestLegalEntityLoanOrigination, callbackUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.originateAndManageLoanLegalEntity(balanceSheet, idDocument, pnlStatement, request, callbackUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApi.originateAndManageLoanLegalEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Originate and manage loan application with borrower as person
         * @param {Array<any>} idDocument List of the identification document\\\&#39;s files
         * @param {RequestPersonLoanOrigination} request 
         * @param {string} [callbackUrl] URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async originateAndManageLoanPerson(idDocument: Array<any>, request: RequestPersonLoanOrigination, callbackUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.originateAndManageLoanPerson(idDocument, request, callbackUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApi.originateAndManageLoanPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Originate loan application with borrower as legal entity
         * @param {Array<any>} balanceSheet List of Balance sheet files
         * @param {string} callbackUrl URL for sending a callback with a processed loan application
         * @param {Array<any>} idDocument List of files of the document identifying the representative of the legal entity
         * @param {Array<any>} pnlStatement List of Profit and loss statement files
         * @param {RequestLegalEntityLoanOrigination} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async originateLoanLegalEntity(balanceSheet: Array<any>, callbackUrl: string, idDocument: Array<any>, pnlStatement: Array<any>, request: RequestLegalEntityLoanOrigination, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.originateLoanLegalEntity(balanceSheet, callbackUrl, idDocument, pnlStatement, request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApi.originateLoanLegalEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Originate loan application with borrower as person
         * @param {string} callbackUrl URL for sending a callback with a processed loan application
         * @param {Array<any>} idDocument List of the identification document\\\&#39;s files
         * @param {RequestPersonLoanOrigination} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async originateLoanPerson(callbackUrl: string, idDocument: Array<any>, request: RequestPersonLoanOrigination, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.originateLoanPerson(callbackUrl, idDocument, request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApi.originateLoanPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IntegrationApi - factory interface
 */
export const IntegrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a loan based on the loan application
         * @param {IntegrationApiManageLoanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageLoan(requestParameters: IntegrationApiManageLoanRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationDto> {
            return localVarFp.manageLoan(requestParameters.requestLoanManagement, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Originate and manage loan application with borrower as legal entity
         * @param {IntegrationApiOriginateAndManageLoanLegalEntityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateAndManageLoanLegalEntity(requestParameters: IntegrationApiOriginateAndManageLoanLegalEntityRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.originateAndManageLoanLegalEntity(requestParameters.balanceSheet, requestParameters.idDocument, requestParameters.pnlStatement, requestParameters.request, requestParameters.callbackUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Originate and manage loan application with borrower as person
         * @param {IntegrationApiOriginateAndManageLoanPersonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateAndManageLoanPerson(requestParameters: IntegrationApiOriginateAndManageLoanPersonRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.originateAndManageLoanPerson(requestParameters.idDocument, requestParameters.request, requestParameters.callbackUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Originate loan application with borrower as legal entity
         * @param {IntegrationApiOriginateLoanLegalEntityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateLoanLegalEntity(requestParameters: IntegrationApiOriginateLoanLegalEntityRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.originateLoanLegalEntity(requestParameters.balanceSheet, requestParameters.callbackUrl, requestParameters.idDocument, requestParameters.pnlStatement, requestParameters.request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Originate loan application with borrower as person
         * @param {IntegrationApiOriginateLoanPersonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateLoanPerson(requestParameters: IntegrationApiOriginateLoanPersonRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.originateLoanPerson(requestParameters.callbackUrl, requestParameters.idDocument, requestParameters.request, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for manageLoan operation in IntegrationApi.
 */
export interface IntegrationApiManageLoanRequest {
    readonly requestLoanManagement: RequestLoanManagement
}

/**
 * Request parameters for originateAndManageLoanLegalEntity operation in IntegrationApi.
 */
export interface IntegrationApiOriginateAndManageLoanLegalEntityRequest {
    /**
     * List of Balance sheet files
     */
    readonly balanceSheet: Array<any>

    /**
     * List of files of the document identifying the representative of the legal entity
     */
    readonly idDocument: Array<any>

    /**
     * List of Profit and loss statement files
     */
    readonly pnlStatement: Array<any>

    readonly request: RequestLegalEntityLoanOrigination

    /**
     * URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
     */
    readonly callbackUrl?: string
}

/**
 * Request parameters for originateAndManageLoanPerson operation in IntegrationApi.
 */
export interface IntegrationApiOriginateAndManageLoanPersonRequest {
    /**
     * List of the identification document\\\&#39;s files
     */
    readonly idDocument: Array<any>

    readonly request: RequestPersonLoanOrigination

    /**
     * URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
     */
    readonly callbackUrl?: string
}

/**
 * Request parameters for originateLoanLegalEntity operation in IntegrationApi.
 */
export interface IntegrationApiOriginateLoanLegalEntityRequest {
    /**
     * List of Balance sheet files
     */
    readonly balanceSheet: Array<any>

    /**
     * URL for sending a callback with a processed loan application
     */
    readonly callbackUrl: string

    /**
     * List of files of the document identifying the representative of the legal entity
     */
    readonly idDocument: Array<any>

    /**
     * List of Profit and loss statement files
     */
    readonly pnlStatement: Array<any>

    readonly request: RequestLegalEntityLoanOrigination
}

/**
 * Request parameters for originateLoanPerson operation in IntegrationApi.
 */
export interface IntegrationApiOriginateLoanPersonRequest {
    /**
     * URL for sending a callback with a processed loan application
     */
    readonly callbackUrl: string

    /**
     * List of the identification document\\\&#39;s files
     */
    readonly idDocument: Array<any>

    readonly request: RequestPersonLoanOrigination
}

/**
 * IntegrationApi - object-oriented interface
 */
export class IntegrationApi extends BaseAPI {
    /**
     * 
     * @summary Create a loan based on the loan application
     * @param {IntegrationApiManageLoanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public manageLoan(requestParameters: IntegrationApiManageLoanRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).manageLoan(requestParameters.requestLoanManagement, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Originate and manage loan application with borrower as legal entity
     * @param {IntegrationApiOriginateAndManageLoanLegalEntityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public originateAndManageLoanLegalEntity(requestParameters: IntegrationApiOriginateAndManageLoanLegalEntityRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).originateAndManageLoanLegalEntity(requestParameters.balanceSheet, requestParameters.idDocument, requestParameters.pnlStatement, requestParameters.request, requestParameters.callbackUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Originate and manage loan application with borrower as person
     * @param {IntegrationApiOriginateAndManageLoanPersonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public originateAndManageLoanPerson(requestParameters: IntegrationApiOriginateAndManageLoanPersonRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).originateAndManageLoanPerson(requestParameters.idDocument, requestParameters.request, requestParameters.callbackUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Originate loan application with borrower as legal entity
     * @param {IntegrationApiOriginateLoanLegalEntityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public originateLoanLegalEntity(requestParameters: IntegrationApiOriginateLoanLegalEntityRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).originateLoanLegalEntity(requestParameters.balanceSheet, requestParameters.callbackUrl, requestParameters.idDocument, requestParameters.pnlStatement, requestParameters.request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Originate loan application with borrower as person
     * @param {IntegrationApiOriginateLoanPersonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public originateLoanPerson(requestParameters: IntegrationApiOriginateLoanPersonRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).originateLoanPerson(requestParameters.callbackUrl, requestParameters.idDocument, requestParameters.request, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InterestRateSettingsApi - axios parameter creator
 */
export const InterestRateSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return actual interest rate settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActualInterestRateSetting: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/interest-rate/actual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return latest interest rate settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestInterestRateSetting: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/interest-rate/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InterestRateSettingsApi - functional programming interface
 */
export const InterestRateSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InterestRateSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return actual interest rate settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActualInterestRateSetting(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterestRateSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActualInterestRateSetting(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterestRateSettingsApi.getActualInterestRateSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return latest interest rate settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestInterestRateSetting(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterestRateSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestInterestRateSetting(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterestRateSettingsApi.getLatestInterestRateSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InterestRateSettingsApi - factory interface
 */
export const InterestRateSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InterestRateSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Return actual interest rate settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActualInterestRateSetting(options?: RawAxiosRequestConfig): AxiosPromise<InterestRateSettingsResponse> {
            return localVarFp.getActualInterestRateSetting(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return latest interest rate settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestInterestRateSetting(options?: RawAxiosRequestConfig): AxiosPromise<InterestRateSettingsResponse> {
            return localVarFp.getLatestInterestRateSetting(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InterestRateSettingsApi - object-oriented interface
 */
export class InterestRateSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Return actual interest rate settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getActualInterestRateSetting(options?: RawAxiosRequestConfig) {
        return InterestRateSettingsApiFp(this.configuration).getActualInterestRateSetting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return latest interest rate settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLatestInterestRateSetting(options?: RawAxiosRequestConfig) {
        return InterestRateSettingsApiFp(this.configuration).getLatestInterestRateSetting(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LandingPageSettingsApi - axios parameter creator
 */
export const LandingPageSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return landing page settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandingPageSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/landing-page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update landing page settings
         * @param {LandingPageSettingsRequest} landingPageSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLandingPageSettings: async (landingPageSettingsRequest: LandingPageSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'landingPageSettingsRequest' is not null or undefined
            assertParamExists('updateLandingPageSettings', 'landingPageSettingsRequest', landingPageSettingsRequest)
            const localVarPath = `/api/settings/landing-page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(landingPageSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LandingPageSettingsApi - functional programming interface
 */
export const LandingPageSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LandingPageSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return landing page settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLandingPageSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandingPageSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLandingPageSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LandingPageSettingsApi.getLandingPageSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update landing page settings
         * @param {LandingPageSettingsRequest} landingPageSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLandingPageSettings(landingPageSettingsRequest: LandingPageSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandingPageSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLandingPageSettings(landingPageSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LandingPageSettingsApi.updateLandingPageSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LandingPageSettingsApi - factory interface
 */
export const LandingPageSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LandingPageSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Return landing page settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandingPageSettings(options?: RawAxiosRequestConfig): AxiosPromise<LandingPageSettingsResponse> {
            return localVarFp.getLandingPageSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update landing page settings
         * @param {LandingPageSettingsApiUpdateLandingPageSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLandingPageSettings(requestParameters: LandingPageSettingsApiUpdateLandingPageSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<LandingPageSettingsResponse> {
            return localVarFp.updateLandingPageSettings(requestParameters.landingPageSettingsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for updateLandingPageSettings operation in LandingPageSettingsApi.
 */
export interface LandingPageSettingsApiUpdateLandingPageSettingsRequest {
    readonly landingPageSettingsRequest: LandingPageSettingsRequest
}

/**
 * LandingPageSettingsApi - object-oriented interface
 */
export class LandingPageSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Return landing page settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLandingPageSettings(options?: RawAxiosRequestConfig) {
        return LandingPageSettingsApiFp(this.configuration).getLandingPageSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update landing page settings
     * @param {LandingPageSettingsApiUpdateLandingPageSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateLandingPageSettings(requestParameters: LandingPageSettingsApiUpdateLandingPageSettingsRequest, options?: RawAxiosRequestConfig) {
        return LandingPageSettingsApiFp(this.configuration).updateLandingPageSettings(requestParameters.landingPageSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LandingRequestsApi - axios parameter creator
 */
export const LandingRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate loan preconditions for landing calculator
         * @param {number} amount 
         * @param {number} term 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateLoanPreconditions: async (amount: number, term: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('calculateLoanPreconditions', 'amount', amount)
            // verify required parameter 'term' is not null or undefined
            assertParamExists('calculateLoanPreconditions', 'term', term)
            const localVarPath = `/api/landing/calculate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return landing calculator settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandingCalculatorSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/landing/calculator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LandingRequestsApi - functional programming interface
 */
export const LandingRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LandingRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Calculate loan preconditions for landing calculator
         * @param {number} amount 
         * @param {number} term 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateLoanPreconditions(amount: number, term: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanPreconditionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateLoanPreconditions(amount, term, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LandingRequestsApi.calculateLoanPreconditions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return landing calculator settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLandingCalculatorSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandingCalculatorSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLandingCalculatorSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LandingRequestsApi.getLandingCalculatorSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LandingRequestsApi - factory interface
 */
export const LandingRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LandingRequestsApiFp(configuration)
    return {
        /**
         * 
         * @summary Calculate loan preconditions for landing calculator
         * @param {LandingRequestsApiCalculateLoanPreconditionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateLoanPreconditions(requestParameters: LandingRequestsApiCalculateLoanPreconditionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanPreconditionsResponse> {
            return localVarFp.calculateLoanPreconditions(requestParameters.amount, requestParameters.term, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return landing calculator settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandingCalculatorSettings(options?: RawAxiosRequestConfig): AxiosPromise<LandingCalculatorSettingsResponse> {
            return localVarFp.getLandingCalculatorSettings(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for calculateLoanPreconditions operation in LandingRequestsApi.
 */
export interface LandingRequestsApiCalculateLoanPreconditionsRequest {
    readonly amount: number

    readonly term: number
}

/**
 * LandingRequestsApi - object-oriented interface
 */
export class LandingRequestsApi extends BaseAPI {
    /**
     * 
     * @summary Calculate loan preconditions for landing calculator
     * @param {LandingRequestsApiCalculateLoanPreconditionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public calculateLoanPreconditions(requestParameters: LandingRequestsApiCalculateLoanPreconditionsRequest, options?: RawAxiosRequestConfig) {
        return LandingRequestsApiFp(this.configuration).calculateLoanPreconditions(requestParameters.amount, requestParameters.term, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return landing calculator settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLandingCalculatorSettings(options?: RawAxiosRequestConfig) {
        return LandingRequestsApiFp(this.configuration).getLandingCalculatorSettings(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LeadApi - axios parameter creator
 */
export const LeadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create lead
         * @param {CreateLeadRequest} createLeadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLead: async (createLeadRequest: CreateLeadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLeadRequest' is not null or undefined
            assertParamExists('createLead', 'createLeadRequest', createLeadRequest)
            const localVarPath = `/api/leads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLeadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of leads
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterSearch] Search by lead\&#39;s fullName, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLeads: async (page?: number, size?: number, sort?: Array<string>, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/leads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single lead
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLead', 'id', id)
            const localVarPath = `/api/leads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update lead
         * @param {number} id 
         * @param {UpdateLeadRequest} updateLeadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLead: async (id: number, updateLeadRequest: UpdateLeadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLead', 'id', id)
            // verify required parameter 'updateLeadRequest' is not null or undefined
            assertParamExists('updateLead', 'updateLeadRequest', updateLeadRequest)
            const localVarPath = `/api/leads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLeadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeadApi - functional programming interface
 */
export const LeadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeadApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create lead
         * @param {CreateLeadRequest} createLeadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLead(createLeadRequest: CreateLeadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLead(createLeadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadApi.createLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of leads
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterSearch] Search by lead\&#39;s fullName, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllLeads(page?: number, size?: number, sort?: Array<string>, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLeadDtoBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllLeads(page, size, sort, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadApi.findAllLeads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return single lead
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLead(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLead(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadApi.getLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update lead
         * @param {number} id 
         * @param {UpdateLeadRequest} updateLeadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLead(id: number, updateLeadRequest: UpdateLeadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLead(id, updateLeadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadApi.updateLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LeadApi - factory interface
 */
export const LeadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeadApiFp(configuration)
    return {
        /**
         * 
         * @summary Create lead
         * @param {LeadApiCreateLeadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLead(requestParameters: LeadApiCreateLeadRequest, options?: RawAxiosRequestConfig): AxiosPromise<LeadDto> {
            return localVarFp.createLead(requestParameters.createLeadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of leads
         * @param {LeadApiFindAllLeadsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLeads(requestParameters: LeadApiFindAllLeadsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageLeadDtoBrief> {
            return localVarFp.findAllLeads(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single lead
         * @param {LeadApiGetLeadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead(requestParameters: LeadApiGetLeadRequest, options?: RawAxiosRequestConfig): AxiosPromise<LeadDto> {
            return localVarFp.getLead(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update lead
         * @param {LeadApiUpdateLeadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLead(requestParameters: LeadApiUpdateLeadRequest, options?: RawAxiosRequestConfig): AxiosPromise<LeadDto> {
            return localVarFp.updateLead(requestParameters.id, requestParameters.updateLeadRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createLead operation in LeadApi.
 */
export interface LeadApiCreateLeadRequest {
    readonly createLeadRequest: CreateLeadRequest
}

/**
 * Request parameters for findAllLeads operation in LeadApi.
 */
export interface LeadApiFindAllLeadsRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Search by lead\&#39;s fullName, phone, email
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for getLead operation in LeadApi.
 */
export interface LeadApiGetLeadRequest {
    readonly id: number
}

/**
 * Request parameters for updateLead operation in LeadApi.
 */
export interface LeadApiUpdateLeadRequest {
    readonly id: number

    readonly updateLeadRequest: UpdateLeadRequest
}

/**
 * LeadApi - object-oriented interface
 */
export class LeadApi extends BaseAPI {
    /**
     * 
     * @summary Create lead
     * @param {LeadApiCreateLeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createLead(requestParameters: LeadApiCreateLeadRequest, options?: RawAxiosRequestConfig) {
        return LeadApiFp(this.configuration).createLead(requestParameters.createLeadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of leads
     * @param {LeadApiFindAllLeadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllLeads(requestParameters: LeadApiFindAllLeadsRequest = {}, options?: RawAxiosRequestConfig) {
        return LeadApiFp(this.configuration).findAllLeads(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single lead
     * @param {LeadApiGetLeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLead(requestParameters: LeadApiGetLeadRequest, options?: RawAxiosRequestConfig) {
        return LeadApiFp(this.configuration).getLead(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update lead
     * @param {LeadApiUpdateLeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateLead(requestParameters: LeadApiUpdateLeadRequest, options?: RawAxiosRequestConfig) {
        return LeadApiFp(this.configuration).updateLead(requestParameters.id, requestParameters.updateLeadRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LicenseApi - axios parameter creator
 */
export const LicenseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate license
         * @param {LicenseActivationRequest} licenseActivationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateLicense: async (licenseActivationRequest: LicenseActivationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'licenseActivationRequest' is not null or undefined
            assertParamExists('activateLicense', 'licenseActivationRequest', licenseActivationRequest)
            const localVarPath = `/api/license`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(licenseActivationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return license info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLicenseInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/license`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LicenseApi - functional programming interface
 */
export const LicenseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LicenseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Activate license
         * @param {LicenseActivationRequest} licenseActivationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateLicense(licenseActivationRequest: LicenseActivationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateLicense(licenseActivationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicenseApi.activateLicense']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return license info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLicenseInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLicenseInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicenseApi.getLicenseInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LicenseApi - factory interface
 */
export const LicenseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LicenseApiFp(configuration)
    return {
        /**
         * 
         * @summary Activate license
         * @param {LicenseApiActivateLicenseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateLicense(requestParameters: LicenseApiActivateLicenseRequest, options?: RawAxiosRequestConfig): AxiosPromise<LicenseResponse> {
            return localVarFp.activateLicense(requestParameters.licenseActivationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return license info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLicenseInfo(options?: RawAxiosRequestConfig): AxiosPromise<LicenseResponse> {
            return localVarFp.getLicenseInfo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activateLicense operation in LicenseApi.
 */
export interface LicenseApiActivateLicenseRequest {
    readonly licenseActivationRequest: LicenseActivationRequest
}

/**
 * LicenseApi - object-oriented interface
 */
export class LicenseApi extends BaseAPI {
    /**
     * 
     * @summary Activate license
     * @param {LicenseApiActivateLicenseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public activateLicense(requestParameters: LicenseApiActivateLicenseRequest, options?: RawAxiosRequestConfig) {
        return LicenseApiFp(this.configuration).activateLicense(requestParameters.licenseActivationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return license info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLicenseInfo(options?: RawAxiosRequestConfig) {
        return LicenseApiFp(this.configuration).getLicenseInfo(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoanApi - axios parameter creator
 */
export const LoanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of agent\'s loans (all types)
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByAgentId: async (id: number, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findAllByAgentId', 'id', id)
            const localVarPath = `/api/loans/agent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of borrower\'s loans (all types)
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByBorrowerId: async (id: number, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findAllByBorrowerId', 'id', id)
            const localVarPath = `/api/loans/borrower/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of all loans (FixedTermLoan and CreditLine)
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan statuses
         * @param {string} [filterIssueDateFrom] Search by loan issue date from
         * @param {string} [filterIssueDateTo] Search by loan issue date to
         * @param {string} [filterSearch] Search by loan number; borrower\&#39;s full name, phone, email; loan product code
         * @param {Array<string>} [filterLoanTypes] Filter by loan types (FIXED_TERM, CREDIT_LINE)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLoans: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterIssueDateFrom?: string, filterIssueDateTo?: string, filterSearch?: string, filterLoanTypes?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterIssueDateFrom !== undefined) {
                localVarQueryParameter['filter.issueDateFrom'] = (filterIssueDateFrom as any instanceof Date) ?
                    (filterIssueDateFrom as any).toISOString().substring(0,10) :
                    filterIssueDateFrom;
            }

            if (filterIssueDateTo !== undefined) {
                localVarQueryParameter['filter.issueDateTo'] = (filterIssueDateTo as any instanceof Date) ?
                    (filterIssueDateTo as any).toISOString().substring(0,10) :
                    filterIssueDateTo;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterLoanTypes) {
                localVarQueryParameter['filter.loanTypes'] = filterLoanTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loan\'s operations
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllOperationsByLoanId: async (id: number, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findAllOperationsByLoanId', 'id', id)
            const localVarPath = `/api/loans/{id}/operations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return loan operation by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOperationById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOperationById', 'id', id)
            const localVarPath = `/api/loans/loan/operations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single loan (any type)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoan: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLoan', 'id', id)
            const localVarPath = `/api/loans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return loan restructuring options
         * @param {number} id 
         * @param {boolean} [isAvailable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRestructuringOptions: async (id: number, isAvailable?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRestructuringOptions', 'id', id)
            const localVarPath = `/api/loans/{id}/restructuring-options`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (isAvailable !== undefined) {
                localVarQueryParameter['isAvailable'] = isAvailable;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send loan to debt collection
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendLoanToDebtCollection: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendLoanToDebtCollection', 'id', id)
            const localVarPath = `/api/loans/{id}/debt-collection`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanApi - functional programming interface
 */
export const LoanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoanApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of agent\'s loans (all types)
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByAgentId(id: number, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanDtoBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllByAgentId(id, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.findAllByAgentId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of borrower\'s loans (all types)
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByBorrowerId(id: number, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanDtoBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllByBorrowerId(id, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.findAllByBorrowerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of all loans (FixedTermLoan and CreditLine)
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan statuses
         * @param {string} [filterIssueDateFrom] Search by loan issue date from
         * @param {string} [filterIssueDateTo] Search by loan issue date to
         * @param {string} [filterSearch] Search by loan number; borrower\&#39;s full name, phone, email; loan product code
         * @param {Array<string>} [filterLoanTypes] Filter by loan types (FIXED_TERM, CREDIT_LINE)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllLoans(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterIssueDateFrom?: string, filterIssueDateTo?: string, filterSearch?: string, filterLoanTypes?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanDtoBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllLoans(page, size, sort, filterStatuses, filterIssueDateFrom, filterIssueDateTo, filterSearch, filterLoanTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.findAllLoans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of loan\'s operations
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllOperationsByLoanId(id: number, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllOperationsByLoanId(id, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.findAllOperationsByLoanId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return loan operation by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOperationById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOperationById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.findOperationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return single loan (any type)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoan(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAgentLoan200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoan(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.getLoan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return loan restructuring options
         * @param {number} id 
         * @param {boolean} [isAvailable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRestructuringOptions(id: number, isAvailable?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RestructuringOptionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRestructuringOptions(id, isAvailable, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.getRestructuringOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send loan to debt collection
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendLoanToDebtCollection(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendLoanToDebtCollection(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.sendLoanToDebtCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoanApi - factory interface
 */
export const LoanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoanApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of agent\'s loans (all types)
         * @param {LoanApiFindAllByAgentIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByAgentId(requestParameters: LoanApiFindAllByAgentIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanDtoBrief> {
            return localVarFp.findAllByAgentId(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of borrower\'s loans (all types)
         * @param {LoanApiFindAllByBorrowerIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByBorrowerId(requestParameters: LoanApiFindAllByBorrowerIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanDtoBrief> {
            return localVarFp.findAllByBorrowerId(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of all loans (FixedTermLoan and CreditLine)
         * @param {LoanApiFindAllLoansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLoans(requestParameters: LoanApiFindAllLoansRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanDtoBrief> {
            return localVarFp.findAllLoans(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterIssueDateFrom, requestParameters.filterIssueDateTo, requestParameters.filterSearch, requestParameters.filterLoanTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loan\'s operations
         * @param {LoanApiFindAllOperationsByLoanIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllOperationsByLoanId(requestParameters: LoanApiFindAllOperationsByLoanIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanOperationDto> {
            return localVarFp.findAllOperationsByLoanId(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return loan operation by id
         * @param {LoanApiFindOperationByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOperationById(requestParameters: LoanApiFindOperationByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanOperationDto> {
            return localVarFp.findOperationById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single loan (any type)
         * @param {LoanApiGetLoanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoan(requestParameters: LoanApiGetLoanRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAgentLoan200Response> {
            return localVarFp.getLoan(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return loan restructuring options
         * @param {LoanApiGetRestructuringOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRestructuringOptions(requestParameters: LoanApiGetRestructuringOptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RestructuringOptionDto>> {
            return localVarFp.getRestructuringOptions(requestParameters.id, requestParameters.isAvailable, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send loan to debt collection
         * @param {LoanApiSendLoanToDebtCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendLoanToDebtCollection(requestParameters: LoanApiSendLoanToDebtCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendLoanToDebtCollection(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAllByAgentId operation in LoanApi.
 */
export interface LoanApiFindAllByAgentIdRequest {
    readonly id: number

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for findAllByBorrowerId operation in LoanApi.
 */
export interface LoanApiFindAllByBorrowerIdRequest {
    readonly id: number

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for findAllLoans operation in LoanApi.
 */
export interface LoanApiFindAllLoansRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Search by loan statuses
     */
    readonly filterStatuses?: Array<string>

    /**
     * Search by loan issue date from
     */
    readonly filterIssueDateFrom?: string

    /**
     * Search by loan issue date to
     */
    readonly filterIssueDateTo?: string

    /**
     * Search by loan number; borrower\&#39;s full name, phone, email; loan product code
     */
    readonly filterSearch?: string

    /**
     * Filter by loan types (FIXED_TERM, CREDIT_LINE)
     */
    readonly filterLoanTypes?: Array<string>
}

/**
 * Request parameters for findAllOperationsByLoanId operation in LoanApi.
 */
export interface LoanApiFindAllOperationsByLoanIdRequest {
    readonly id: number

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for findOperationById operation in LoanApi.
 */
export interface LoanApiFindOperationByIdRequest {
    readonly id: number
}

/**
 * Request parameters for getLoan operation in LoanApi.
 */
export interface LoanApiGetLoanRequest {
    readonly id: number
}

/**
 * Request parameters for getRestructuringOptions operation in LoanApi.
 */
export interface LoanApiGetRestructuringOptionsRequest {
    readonly id: number

    readonly isAvailable?: boolean
}

/**
 * Request parameters for sendLoanToDebtCollection operation in LoanApi.
 */
export interface LoanApiSendLoanToDebtCollectionRequest {
    readonly id: number
}

/**
 * LoanApi - object-oriented interface
 */
export class LoanApi extends BaseAPI {
    /**
     * 
     * @summary Return list of agent\'s loans (all types)
     * @param {LoanApiFindAllByAgentIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllByAgentId(requestParameters: LoanApiFindAllByAgentIdRequest, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).findAllByAgentId(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of borrower\'s loans (all types)
     * @param {LoanApiFindAllByBorrowerIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllByBorrowerId(requestParameters: LoanApiFindAllByBorrowerIdRequest, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).findAllByBorrowerId(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of all loans (FixedTermLoan and CreditLine)
     * @param {LoanApiFindAllLoansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllLoans(requestParameters: LoanApiFindAllLoansRequest = {}, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).findAllLoans(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterIssueDateFrom, requestParameters.filterIssueDateTo, requestParameters.filterSearch, requestParameters.filterLoanTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loan\'s operations
     * @param {LoanApiFindAllOperationsByLoanIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllOperationsByLoanId(requestParameters: LoanApiFindAllOperationsByLoanIdRequest, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).findAllOperationsByLoanId(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return loan operation by id
     * @param {LoanApiFindOperationByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findOperationById(requestParameters: LoanApiFindOperationByIdRequest, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).findOperationById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single loan (any type)
     * @param {LoanApiGetLoanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLoan(requestParameters: LoanApiGetLoanRequest, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).getLoan(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return loan restructuring options
     * @param {LoanApiGetRestructuringOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRestructuringOptions(requestParameters: LoanApiGetRestructuringOptionsRequest, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).getRestructuringOptions(requestParameters.id, requestParameters.isAvailable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send loan to debt collection
     * @param {LoanApiSendLoanToDebtCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendLoanToDebtCollection(requestParameters: LoanApiSendLoanToDebtCollectionRequest, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).sendLoanToDebtCollection(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoanAdjustmentsApi - axios parameter creator
 */
export const LoanAdjustmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan\'s agreements
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgreementsByLoanId: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findAllAgreementsByLoanId', 'id', id)
            const localVarPath = `/api/loan-adjustments/loan/{id}/agreements`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanAdjustmentsApi - functional programming interface
 */
export const LoanAdjustmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoanAdjustmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of loan\'s agreements
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllAgreementsByLoanId(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LoanAgreementDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllAgreementsByLoanId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanAdjustmentsApi.findAllAgreementsByLoanId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoanAdjustmentsApi - factory interface
 */
export const LoanAdjustmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoanAdjustmentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of loan\'s agreements
         * @param {LoanAdjustmentsApiFindAllAgreementsByLoanIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgreementsByLoanId(requestParameters: LoanAdjustmentsApiFindAllAgreementsByLoanIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<LoanAgreementDto>> {
            return localVarFp.findAllAgreementsByLoanId(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAllAgreementsByLoanId operation in LoanAdjustmentsApi.
 */
export interface LoanAdjustmentsApiFindAllAgreementsByLoanIdRequest {
    readonly id: number
}

/**
 * LoanAdjustmentsApi - object-oriented interface
 */
export class LoanAdjustmentsApi extends BaseAPI {
    /**
     * 
     * @summary Return list of loan\'s agreements
     * @param {LoanAdjustmentsApiFindAllAgreementsByLoanIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllAgreementsByLoanId(requestParameters: LoanAdjustmentsApiFindAllAgreementsByLoanIdRequest, options?: RawAxiosRequestConfig) {
        return LoanAdjustmentsApiFp(this.configuration).findAllAgreementsByLoanId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoanApplicationApi - axios parameter creator
 */
export const LoanApplicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan applications
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan application statuses
         * @param {string} [filterRequestedAtFrom] Search by loan application requested at (by a borrower) from
         * @param {string} [filterRequestedAtTo] Search by loan application requested at (by a borrower) to
         * @param {string} [filterSearch] Search by loan application number; borrower\&#39;s full name, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllApplications: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterRequestedAtFrom?: string, filterRequestedAtTo?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loan-applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterRequestedAtFrom !== undefined) {
                localVarQueryParameter['filter.requestedAtFrom'] = (filterRequestedAtFrom as any instanceof Date) ?
                    (filterRequestedAtFrom as any).toISOString() :
                    filterRequestedAtFrom;
            }

            if (filterRequestedAtTo !== undefined) {
                localVarQueryParameter['filter.requestedAtTo'] = (filterRequestedAtTo as any instanceof Date) ?
                    (filterRequestedAtTo as any).toISOString() :
                    filterRequestedAtTo;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of agent\'s loan applications
         * @param {number} id Agent id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByAgentId1: async (id: number, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findAllByAgentId1', 'id', id)
            const localVarPath = `/api/loan-applications/agent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of borrower\'s loan applications
         * @param {number} id Borrower id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByBorrowerId1: async (id: number, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findAllByBorrowerId1', 'id', id)
            const localVarPath = `/api/loan-applications/borrower/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplication: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApplication', 'id', id)
            const localVarPath = `/api/loan-applications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return audit trail for the loan application
         * @param {string} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrail: async (id: string, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAuditTrail', 'id', id)
            const localVarPath = `/api/loan-applications/{id}/audit-trail`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanApplicationApi - functional programming interface
 */
export const LoanApplicationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoanApplicationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of loan applications
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan application statuses
         * @param {string} [filterRequestedAtFrom] Search by loan application requested at (by a borrower) from
         * @param {string} [filterRequestedAtTo] Search by loan application requested at (by a borrower) to
         * @param {string} [filterSearch] Search by loan application number; borrower\&#39;s full name, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllApplications(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterRequestedAtFrom?: string, filterRequestedAtTo?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanApplicationDtoBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllApplications(page, size, sort, filterStatuses, filterRequestedAtFrom, filterRequestedAtTo, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationApi.findAllApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of agent\'s loan applications
         * @param {number} id Agent id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByAgentId1(id: number, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanApplicationDtoBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllByAgentId1(id, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationApi.findAllByAgentId1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of borrower\'s loan applications
         * @param {number} id Borrower id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByBorrowerId1(id: number, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanApplicationDtoBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllByBorrowerId1(id, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationApi.findAllByBorrowerId1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return single loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApplication(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApplication(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationApi.getApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return audit trail for the loan application
         * @param {string} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditTrail(id: string, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageActivityAuditTrailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditTrail(id, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationApi.getAuditTrail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoanApplicationApi - factory interface
 */
export const LoanApplicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoanApplicationApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of loan applications
         * @param {LoanApplicationApiFindAllApplicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllApplications(requestParameters: LoanApplicationApiFindAllApplicationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanApplicationDtoBrief> {
            return localVarFp.findAllApplications(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterRequestedAtFrom, requestParameters.filterRequestedAtTo, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of agent\'s loan applications
         * @param {LoanApplicationApiFindAllByAgentId1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByAgentId1(requestParameters: LoanApplicationApiFindAllByAgentId1Request, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanApplicationDtoBrief> {
            return localVarFp.findAllByAgentId1(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of borrower\'s loan applications
         * @param {LoanApplicationApiFindAllByBorrowerId1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByBorrowerId1(requestParameters: LoanApplicationApiFindAllByBorrowerId1Request, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanApplicationDtoBrief> {
            return localVarFp.findAllByBorrowerId1(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single loan application
         * @param {LoanApplicationApiGetApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplication(requestParameters: LoanApplicationApiGetApplicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationDto> {
            return localVarFp.getApplication(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return audit trail for the loan application
         * @param {LoanApplicationApiGetAuditTrailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrail(requestParameters: LoanApplicationApiGetAuditTrailRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageActivityAuditTrailDto> {
            return localVarFp.getAuditTrail(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAllApplications operation in LoanApplicationApi.
 */
export interface LoanApplicationApiFindAllApplicationsRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Search by loan application statuses
     */
    readonly filterStatuses?: Array<string>

    /**
     * Search by loan application requested at (by a borrower) from
     */
    readonly filterRequestedAtFrom?: string

    /**
     * Search by loan application requested at (by a borrower) to
     */
    readonly filterRequestedAtTo?: string

    /**
     * Search by loan application number; borrower\&#39;s full name, phone, email
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for findAllByAgentId1 operation in LoanApplicationApi.
 */
export interface LoanApplicationApiFindAllByAgentId1Request {
    /**
     * Agent id
     */
    readonly id: number

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for findAllByBorrowerId1 operation in LoanApplicationApi.
 */
export interface LoanApplicationApiFindAllByBorrowerId1Request {
    /**
     * Borrower id
     */
    readonly id: number

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for getApplication operation in LoanApplicationApi.
 */
export interface LoanApplicationApiGetApplicationRequest {
    readonly id: number
}

/**
 * Request parameters for getAuditTrail operation in LoanApplicationApi.
 */
export interface LoanApplicationApiGetAuditTrailRequest {
    readonly id: string

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * LoanApplicationApi - object-oriented interface
 */
export class LoanApplicationApi extends BaseAPI {
    /**
     * 
     * @summary Return list of loan applications
     * @param {LoanApplicationApiFindAllApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllApplications(requestParameters: LoanApplicationApiFindAllApplicationsRequest = {}, options?: RawAxiosRequestConfig) {
        return LoanApplicationApiFp(this.configuration).findAllApplications(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterRequestedAtFrom, requestParameters.filterRequestedAtTo, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of agent\'s loan applications
     * @param {LoanApplicationApiFindAllByAgentId1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllByAgentId1(requestParameters: LoanApplicationApiFindAllByAgentId1Request, options?: RawAxiosRequestConfig) {
        return LoanApplicationApiFp(this.configuration).findAllByAgentId1(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of borrower\'s loan applications
     * @param {LoanApplicationApiFindAllByBorrowerId1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllByBorrowerId1(requestParameters: LoanApplicationApiFindAllByBorrowerId1Request, options?: RawAxiosRequestConfig) {
        return LoanApplicationApiFp(this.configuration).findAllByBorrowerId1(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single loan application
     * @param {LoanApplicationApiGetApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApplication(requestParameters: LoanApplicationApiGetApplicationRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationApiFp(this.configuration).getApplication(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return audit trail for the loan application
     * @param {LoanApplicationApiGetAuditTrailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAuditTrail(requestParameters: LoanApplicationApiGetAuditTrailRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationApiFp(this.configuration).getAuditTrail(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoanProductApi - axios parameter creator
 */
export const LoanProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create loan product
         * @param {CreateLoanProductRequest} createLoanProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: async (createLoanProductRequest: CreateLoanProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLoanProductRequest' is not null or undefined
            assertParamExists('createProduct', 'createLoanProductRequest', createLoanProductRequest)
            const localVarPath = `/api/loan-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLoanProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of campaign\'s loan products
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByCampaignId: async (id: number, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findAllByCampaignId', 'id', id)
            const localVarPath = `/api/loan-products/campaign/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loan products
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [filterAmount] Search by loan product amount
         * @param {number} [filterTerm] Search by loan product term
         * @param {boolean} [filterActive] Search by loan product active flag
         * @param {string} [filterCampaignId] Search by loan product group id
         * @param {number} [filterInterestRate] 
         * @param {string} [filterSearch] Search by loan product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllProducts: async (page?: number, size?: number, sort?: Array<string>, filterAmount?: number, filterTerm?: number, filterActive?: boolean, filterCampaignId?: string, filterInterestRate?: number, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loan-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterAmount !== undefined) {
                localVarQueryParameter['filter.amount'] = filterAmount;
            }

            if (filterTerm !== undefined) {
                localVarQueryParameter['filter.term'] = filterTerm;
            }

            if (filterActive !== undefined) {
                localVarQueryParameter['filter.active'] = filterActive;
            }

            if (filterCampaignId !== undefined) {
                localVarQueryParameter['filter.campaignId'] = filterCampaignId;
            }

            if (filterInterestRate !== undefined) {
                localVarQueryParameter['filter.interestRate'] = filterInterestRate;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return loan product\'s history
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory: async (id: number, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHistory', 'id', id)
            const localVarPath = `/api/loan-products/{id}/history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single loan product
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProduct', 'id', id)
            const localVarPath = `/api/loan-products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update loan product
         * @param {number} id 
         * @param {UpdateLoanProductRequest} updateLoanProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: async (id: number, updateLoanProductRequest: UpdateLoanProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProduct', 'id', id)
            // verify required parameter 'updateLoanProductRequest' is not null or undefined
            assertParamExists('updateProduct', 'updateLoanProductRequest', updateLoanProductRequest)
            const localVarPath = `/api/loan-products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLoanProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanProductApi - functional programming interface
 */
export const LoanProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoanProductApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create loan product
         * @param {CreateLoanProductRequest} createLoanProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProduct(createLoanProductRequest: CreateLoanProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProduct(createLoanProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanProductApi.createProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of campaign\'s loan products
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByCampaignId(id: number, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllByCampaignId(id, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanProductApi.findAllByCampaignId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of loan products
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [filterAmount] Search by loan product amount
         * @param {number} [filterTerm] Search by loan product term
         * @param {boolean} [filterActive] Search by loan product active flag
         * @param {string} [filterCampaignId] Search by loan product group id
         * @param {number} [filterInterestRate] 
         * @param {string} [filterSearch] Search by loan product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllProducts(page?: number, size?: number, sort?: Array<string>, filterAmount?: number, filterTerm?: number, filterActive?: boolean, filterCampaignId?: string, filterInterestRate?: number, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllProducts(page, size, sort, filterAmount, filterTerm, filterActive, filterCampaignId, filterInterestRate, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanProductApi.findAllProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return loan product\'s history
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistory(id: number, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanProductRevisionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistory(id, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanProductApi.getHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return single loan product
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProduct(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProduct(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanProductApi.getProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update loan product
         * @param {number} id 
         * @param {UpdateLoanProductRequest} updateLoanProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProduct(id: number, updateLoanProductRequest: UpdateLoanProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProduct(id, updateLoanProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanProductApi.updateProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoanProductApi - factory interface
 */
export const LoanProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoanProductApiFp(configuration)
    return {
        /**
         * 
         * @summary Create loan product
         * @param {LoanProductApiCreateProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct(requestParameters: LoanProductApiCreateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanProductDto> {
            return localVarFp.createProduct(requestParameters.createLoanProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of campaign\'s loan products
         * @param {LoanProductApiFindAllByCampaignIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByCampaignId(requestParameters: LoanProductApiFindAllByCampaignIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanProductDto> {
            return localVarFp.findAllByCampaignId(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loan products
         * @param {LoanProductApiFindAllProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllProducts(requestParameters: LoanProductApiFindAllProductsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanProductDto> {
            return localVarFp.findAllProducts(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterAmount, requestParameters.filterTerm, requestParameters.filterActive, requestParameters.filterCampaignId, requestParameters.filterInterestRate, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return loan product\'s history
         * @param {LoanProductApiGetHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory(requestParameters: LoanProductApiGetHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanProductRevisionDto> {
            return localVarFp.getHistory(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single loan product
         * @param {LoanProductApiGetProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct(requestParameters: LoanProductApiGetProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanProductDto> {
            return localVarFp.getProduct(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update loan product
         * @param {LoanProductApiUpdateProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(requestParameters: LoanProductApiUpdateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanProductDto> {
            return localVarFp.updateProduct(requestParameters.id, requestParameters.updateLoanProductRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createProduct operation in LoanProductApi.
 */
export interface LoanProductApiCreateProductRequest {
    readonly createLoanProductRequest: CreateLoanProductRequest
}

/**
 * Request parameters for findAllByCampaignId operation in LoanProductApi.
 */
export interface LoanProductApiFindAllByCampaignIdRequest {
    readonly id: number

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for findAllProducts operation in LoanProductApi.
 */
export interface LoanProductApiFindAllProductsRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Search by loan product amount
     */
    readonly filterAmount?: number

    /**
     * Search by loan product term
     */
    readonly filterTerm?: number

    /**
     * Search by loan product active flag
     */
    readonly filterActive?: boolean

    /**
     * Search by loan product group id
     */
    readonly filterCampaignId?: string

    readonly filterInterestRate?: number

    /**
     * Search by loan product code
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for getHistory operation in LoanProductApi.
 */
export interface LoanProductApiGetHistoryRequest {
    readonly id: number

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for getProduct operation in LoanProductApi.
 */
export interface LoanProductApiGetProductRequest {
    readonly id: number
}

/**
 * Request parameters for updateProduct operation in LoanProductApi.
 */
export interface LoanProductApiUpdateProductRequest {
    readonly id: number

    readonly updateLoanProductRequest: UpdateLoanProductRequest
}

/**
 * LoanProductApi - object-oriented interface
 */
export class LoanProductApi extends BaseAPI {
    /**
     * 
     * @summary Create loan product
     * @param {LoanProductApiCreateProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProduct(requestParameters: LoanProductApiCreateProductRequest, options?: RawAxiosRequestConfig) {
        return LoanProductApiFp(this.configuration).createProduct(requestParameters.createLoanProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of campaign\'s loan products
     * @param {LoanProductApiFindAllByCampaignIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllByCampaignId(requestParameters: LoanProductApiFindAllByCampaignIdRequest, options?: RawAxiosRequestConfig) {
        return LoanProductApiFp(this.configuration).findAllByCampaignId(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loan products
     * @param {LoanProductApiFindAllProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllProducts(requestParameters: LoanProductApiFindAllProductsRequest = {}, options?: RawAxiosRequestConfig) {
        return LoanProductApiFp(this.configuration).findAllProducts(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterAmount, requestParameters.filterTerm, requestParameters.filterActive, requestParameters.filterCampaignId, requestParameters.filterInterestRate, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return loan product\'s history
     * @param {LoanProductApiGetHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getHistory(requestParameters: LoanProductApiGetHistoryRequest, options?: RawAxiosRequestConfig) {
        return LoanProductApiFp(this.configuration).getHistory(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single loan product
     * @param {LoanProductApiGetProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProduct(requestParameters: LoanProductApiGetProductRequest, options?: RawAxiosRequestConfig) {
        return LoanProductApiFp(this.configuration).getProduct(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update loan product
     * @param {LoanProductApiUpdateProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProduct(requestParameters: LoanProductApiUpdateProductRequest, options?: RawAxiosRequestConfig) {
        return LoanProductApiFp(this.configuration).updateProduct(requestParameters.id, requestParameters.updateLoanProductRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MetabaseApi - axios parameter creator
 */
export const MetabaseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboards: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/metabase/dashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedDashboard: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEmbedDashboard', 'id', id)
            const localVarPath = `/api/metabase/dashboard/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetabaseApi - functional programming interface
 */
export const MetabaseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetabaseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboards(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboards(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseApi.getDashboards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmbedDashboard(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedDashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmbedDashboard(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseApi.getEmbedDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MetabaseApi - factory interface
 */
export const MetabaseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetabaseApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboards(options?: RawAxiosRequestConfig): AxiosPromise<DashboardsResponse> {
            return localVarFp.getDashboards(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MetabaseApiGetEmbedDashboardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedDashboard(requestParameters: MetabaseApiGetEmbedDashboardRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmbedDashboardResponse> {
            return localVarFp.getEmbedDashboard(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getEmbedDashboard operation in MetabaseApi.
 */
export interface MetabaseApiGetEmbedDashboardRequest {
    readonly id: number
}

/**
 * MetabaseApi - object-oriented interface
 */
export class MetabaseApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDashboards(options?: RawAxiosRequestConfig) {
        return MetabaseApiFp(this.configuration).getDashboards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MetabaseApiGetEmbedDashboardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEmbedDashboard(requestParameters: MetabaseApiGetEmbedDashboardRequest, options?: RawAxiosRequestConfig) {
        return MetabaseApiFp(this.configuration).getEmbedDashboard(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationTemplateApi - axios parameter creator
 */
export const NotificationTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of notification templates
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllNotificationTemplates: async (page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/notification-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return notification template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTemplate: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getNotificationTemplate', 'id', id)
            const localVarPath = `/api/settings/notification-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update notification template
         * @param {number} id 
         * @param {NotificationTemplateRequest} notificationTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationTemplate: async (id: number, notificationTemplateRequest: NotificationTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateNotificationTemplate', 'id', id)
            // verify required parameter 'notificationTemplateRequest' is not null or undefined
            assertParamExists('updateNotificationTemplate', 'notificationTemplateRequest', notificationTemplateRequest)
            const localVarPath = `/api/settings/notification-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationTemplateApi - functional programming interface
 */
export const NotificationTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of notification templates
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllNotificationTemplates(page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageNotificationTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllNotificationTemplates(page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationTemplateApi.findAllNotificationTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return notification template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationTemplate(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationTemplate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationTemplateApi.getNotificationTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update notification template
         * @param {number} id 
         * @param {NotificationTemplateRequest} notificationTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationTemplate(id: number, notificationTemplateRequest: NotificationTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotificationTemplate(id, notificationTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationTemplateApi.updateNotificationTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationTemplateApi - factory interface
 */
export const NotificationTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationTemplateApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of notification templates
         * @param {NotificationTemplateApiFindAllNotificationTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllNotificationTemplates(requestParameters: NotificationTemplateApiFindAllNotificationTemplatesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageNotificationTemplateDto> {
            return localVarFp.findAllNotificationTemplates(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return notification template
         * @param {NotificationTemplateApiGetNotificationTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTemplate(requestParameters: NotificationTemplateApiGetNotificationTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotificationTemplateDto> {
            return localVarFp.getNotificationTemplate(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update notification template
         * @param {NotificationTemplateApiUpdateNotificationTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationTemplate(requestParameters: NotificationTemplateApiUpdateNotificationTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotificationTemplateDto> {
            return localVarFp.updateNotificationTemplate(requestParameters.id, requestParameters.notificationTemplateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAllNotificationTemplates operation in NotificationTemplateApi.
 */
export interface NotificationTemplateApiFindAllNotificationTemplatesRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for getNotificationTemplate operation in NotificationTemplateApi.
 */
export interface NotificationTemplateApiGetNotificationTemplateRequest {
    readonly id: number
}

/**
 * Request parameters for updateNotificationTemplate operation in NotificationTemplateApi.
 */
export interface NotificationTemplateApiUpdateNotificationTemplateRequest {
    readonly id: number

    readonly notificationTemplateRequest: NotificationTemplateRequest
}

/**
 * NotificationTemplateApi - object-oriented interface
 */
export class NotificationTemplateApi extends BaseAPI {
    /**
     * 
     * @summary Return list of notification templates
     * @param {NotificationTemplateApiFindAllNotificationTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllNotificationTemplates(requestParameters: NotificationTemplateApiFindAllNotificationTemplatesRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationTemplateApiFp(this.configuration).findAllNotificationTemplates(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return notification template
     * @param {NotificationTemplateApiGetNotificationTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotificationTemplate(requestParameters: NotificationTemplateApiGetNotificationTemplateRequest, options?: RawAxiosRequestConfig) {
        return NotificationTemplateApiFp(this.configuration).getNotificationTemplate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update notification template
     * @param {NotificationTemplateApiUpdateNotificationTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateNotificationTemplate(requestParameters: NotificationTemplateApiUpdateNotificationTemplateRequest, options?: RawAxiosRequestConfig) {
        return NotificationTemplateApiFp(this.configuration).updateNotificationTemplate(requestParameters.id, requestParameters.notificationTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProcessDefinitionManagerApi - axios parameter creator
 */
export const ProcessDefinitionManagerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {string} key Process definition key
         * @param {{ [key: string]: any; }} variables Input variables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateGet: async (key: string, variables: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('calculateGet', 'key', key)
            // verify required parameter 'variables' is not null or undefined
            assertParamExists('calculateGet', 'variables', variables)
            const localVarPath = `/api/process-definition/key/{key}/calculate`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (variables !== undefined) {
                for (const [key, value] of Object.entries(variables)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {string} key Process definition key
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePost: async (key: string, requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('calculatePost', 'key', key)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('calculatePost', 'requestBody', requestBody)
            const localVarPath = `/api/process-definition/key/{key}/calculate`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessDefinition: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getProcessDefinition', 'key', key)
            const localVarPath = `/api/process-definition/key/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve start form for the process
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartForm: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getStartForm', 'key', key)
            const localVarPath = `/api/process-definition/key/{key}/start-form`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of start form variables of a latest process definition if allowed to access.
         * @summary Retrieve start form variables
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartFormVariables: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getStartFormVariables', 'key', key)
            const localVarPath = `/api/process-definition/key/{key}/form-variables`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve start form for the process with form variables included
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartFormWithData: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getStartFormWithData', 'key', key)
            const localVarPath = `/api/process-definition/key/{key}/start-form-with-data`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStartableByUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/process-definition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts a process instance of latest definition by form submission if allowed to access.
         * @summary Start a process instance by form submission
         * @param {string} key Process definition key
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStartFrom: async (key: string, requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('submitStartFrom', 'key', key)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('submitStartFrom', 'requestBody', requestBody)
            const localVarPath = `/api/process-definition/key/{key}/submit-form`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessDefinitionManagerApi - functional programming interface
 */
export const ProcessDefinitionManagerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessDefinitionManagerApiAxiosParamCreator(configuration)
    return {
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {string} key Process definition key
         * @param {{ [key: string]: any; }} variables Input variables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateGet(key: string, variables: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateGet(key, variables, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.calculateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {string} key Process definition key
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculatePost(key: string, requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculatePost(key, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.calculatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessDefinition(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessDefinitionRepresentation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessDefinition(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.getProcessDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve start form for the process
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStartForm(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStartForm(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.getStartForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List of start form variables of a latest process definition if allowed to access.
         * @summary Retrieve start form variables
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStartFormVariables(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStartFormVariables(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.getStartFormVariables']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve start form for the process with form variables included
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStartFormWithData(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStartFormWithData(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.getStartFormWithData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStartableByUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessDefinitionRepresentation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStartableByUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.listStartableByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Starts a process instance of latest definition by form submission if allowed to access.
         * @summary Start a process instance by form submission
         * @param {string} key Process definition key
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitStartFrom(key: string, requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskRepresentation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitStartFrom(key, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.submitStartFrom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessDefinitionManagerApi - factory interface
 */
export const ProcessDefinitionManagerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessDefinitionManagerApiFp(configuration)
    return {
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {ProcessDefinitionManagerApiCalculateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateGet(requestParameters: ProcessDefinitionManagerApiCalculateGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.calculateGet(requestParameters.key, requestParameters.variables, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {ProcessDefinitionManagerApiCalculatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePost(requestParameters: ProcessDefinitionManagerApiCalculatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.calculatePost(requestParameters.key, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {ProcessDefinitionManagerApiGetProcessDefinitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessDefinition(requestParameters: ProcessDefinitionManagerApiGetProcessDefinitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProcessDefinitionRepresentation> {
            return localVarFp.getProcessDefinition(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve start form for the process
         * @param {ProcessDefinitionManagerApiGetStartFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartForm(requestParameters: ProcessDefinitionManagerApiGetStartFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getStartForm(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * List of start form variables of a latest process definition if allowed to access.
         * @summary Retrieve start form variables
         * @param {ProcessDefinitionManagerApiGetStartFormVariablesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartFormVariables(requestParameters: ProcessDefinitionManagerApiGetStartFormVariablesRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getStartFormVariables(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve start form for the process with form variables included
         * @param {ProcessDefinitionManagerApiGetStartFormWithDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartFormWithData(requestParameters: ProcessDefinitionManagerApiGetStartFormWithDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getStartFormWithData(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStartableByUser(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessDefinitionRepresentation>> {
            return localVarFp.listStartableByUser(options).then((request) => request(axios, basePath));
        },
        /**
         * Starts a process instance of latest definition by form submission if allowed to access.
         * @summary Start a process instance by form submission
         * @param {ProcessDefinitionManagerApiSubmitStartFromRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStartFrom(requestParameters: ProcessDefinitionManagerApiSubmitStartFromRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskRepresentation>> {
            return localVarFp.submitStartFrom(requestParameters.key, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for calculateGet operation in ProcessDefinitionManagerApi.
 */
export interface ProcessDefinitionManagerApiCalculateGetRequest {
    /**
     * Process definition key
     */
    readonly key: string

    /**
     * Input variables
     */
    readonly variables: { [key: string]: any; }
}

/**
 * Request parameters for calculatePost operation in ProcessDefinitionManagerApi.
 */
export interface ProcessDefinitionManagerApiCalculatePostRequest {
    /**
     * Process definition key
     */
    readonly key: string

    readonly requestBody: { [key: string]: any; }
}

/**
 * Request parameters for getProcessDefinition operation in ProcessDefinitionManagerApi.
 */
export interface ProcessDefinitionManagerApiGetProcessDefinitionRequest {
    /**
     * Process definition key
     */
    readonly key: string
}

/**
 * Request parameters for getStartForm operation in ProcessDefinitionManagerApi.
 */
export interface ProcessDefinitionManagerApiGetStartFormRequest {
    /**
     * Process definition key
     */
    readonly key: string
}

/**
 * Request parameters for getStartFormVariables operation in ProcessDefinitionManagerApi.
 */
export interface ProcessDefinitionManagerApiGetStartFormVariablesRequest {
    /**
     * Process definition key
     */
    readonly key: string
}

/**
 * Request parameters for getStartFormWithData operation in ProcessDefinitionManagerApi.
 */
export interface ProcessDefinitionManagerApiGetStartFormWithDataRequest {
    /**
     * Process definition key
     */
    readonly key: string
}

/**
 * Request parameters for submitStartFrom operation in ProcessDefinitionManagerApi.
 */
export interface ProcessDefinitionManagerApiSubmitStartFromRequest {
    /**
     * Process definition key
     */
    readonly key: string

    readonly requestBody: { [key: string]: any; }
}

/**
 * ProcessDefinitionManagerApi - object-oriented interface
 */
export class ProcessDefinitionManagerApi extends BaseAPI {
    /**
     * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
     * @summary Start a process instance with result in return
     * @param {ProcessDefinitionManagerApiCalculateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public calculateGet(requestParameters: ProcessDefinitionManagerApiCalculateGetRequest, options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).calculateGet(requestParameters.key, requestParameters.variables, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
     * @summary Start a process instance with result in return
     * @param {ProcessDefinitionManagerApiCalculatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public calculatePost(requestParameters: ProcessDefinitionManagerApiCalculatePostRequest, options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).calculatePost(requestParameters.key, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List process definitions allowed to start by the user performed the request
     * @summary List process definitions allowed to start
     * @param {ProcessDefinitionManagerApiGetProcessDefinitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessDefinition(requestParameters: ProcessDefinitionManagerApiGetProcessDefinitionRequest, options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).getProcessDefinition(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form.
     * @summary Retrieve start form for the process
     * @param {ProcessDefinitionManagerApiGetStartFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStartForm(requestParameters: ProcessDefinitionManagerApiGetStartFormRequest, options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).getStartForm(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of start form variables of a latest process definition if allowed to access.
     * @summary Retrieve start form variables
     * @param {ProcessDefinitionManagerApiGetStartFormVariablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStartFormVariables(requestParameters: ProcessDefinitionManagerApiGetStartFormVariablesRequest, options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).getStartFormVariables(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
     * @summary Retrieve start form for the process with form variables included
     * @param {ProcessDefinitionManagerApiGetStartFormWithDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStartFormWithData(requestParameters: ProcessDefinitionManagerApiGetStartFormWithDataRequest, options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).getStartFormWithData(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List process definitions allowed to start by the user performed the request
     * @summary List process definitions allowed to start
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listStartableByUser(options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).listStartableByUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts a process instance of latest definition by form submission if allowed to access.
     * @summary Start a process instance by form submission
     * @param {ProcessDefinitionManagerApiSubmitStartFromRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitStartFrom(requestParameters: ProcessDefinitionManagerApiSubmitStartFromRequest, options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).submitStartFrom(requestParameters.key, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScoringModelSettingsApi - axios parameter creator
 */
export const ScoringModelSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add new version
         * @param {number} id 
         * @param {number} versionId 
         * @param {AddNewVersionRequest} addNewVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewVersion: async (id: number, versionId: number, addNewVersionRequest: AddNewVersionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addNewVersion', 'id', id)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('addNewVersion', 'versionId', versionId)
            // verify required parameter 'addNewVersionRequest' is not null or undefined
            assertParamExists('addNewVersion', 'addNewVersionRequest', addNewVersionRequest)
            const localVarPath = `/api/settings/scoring-models/{id}/versions/{versionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addNewVersionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return internal scoring model by key
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternalScoringModelByKey: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getInternalScoringModelByKey', 'key', key)
            const localVarPath = `/api/settings/scoring-models/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return scoring model settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/scoring-models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return scoring model version content by modelId
         * @param {number} id 
         * @param {number} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionContent: async (id: number, versionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getScoringModelVersionContent', 'id', id)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('getScoringModelVersionContent', 'versionId', versionId)
            const localVarPath = `/api/settings/scoring-models/{id}/versions/{versionId}/content`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return scoring model version settings by modelId
         * @param {number} id 
         * @param {number} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionSettings: async (id: number, versionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getScoringModelVersionSettings', 'id', id)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('getScoringModelVersionSettings', 'versionId', versionId)
            const localVarPath = `/api/settings/scoring-models/{id}/versions/{versionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return scoring model versions settings by modelId
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionsSettings: async (id: number, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getScoringModelVersionsSettings', 'id', id)
            const localVarPath = `/api/settings/scoring-models/{id}/versions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return active scoring model version id
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionsSettingsId: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getScoringModelVersionsSettingsId', 'key', key)
            const localVarPath = `/api/settings/scoring-models/{key}/versions/active/id`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScoringModelSettingsApi - functional programming interface
 */
export const ScoringModelSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScoringModelSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add new version
         * @param {number} id 
         * @param {number} versionId 
         * @param {AddNewVersionRequest} addNewVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNewVersion(id: number, versionId: number, addNewVersionRequest: AddNewVersionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddNewVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNewVersion(id, versionId, addNewVersionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoringModelSettingsApi.addNewVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return internal scoring model by key
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInternalScoringModelByKey(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalScoringModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInternalScoringModelByKey(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoringModelSettingsApi.getInternalScoringModelByKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return scoring model settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoringModelSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoringModelSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScoringModelSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoringModelSettingsApi.getScoringModelSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return scoring model version content by modelId
         * @param {number} id 
         * @param {number} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoringModelVersionContent(id: number, versionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoringModelVersionContentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScoringModelVersionContent(id, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoringModelSettingsApi.getScoringModelVersionContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return scoring model version settings by modelId
         * @param {number} id 
         * @param {number} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoringModelVersionSettings(id: number, versionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoringModelVersionSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScoringModelVersionSettings(id, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoringModelSettingsApi.getScoringModelVersionSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return scoring model versions settings by modelId
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoringModelVersionsSettings(id: number, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageScoringModelVersionSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScoringModelVersionsSettings(id, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoringModelSettingsApi.getScoringModelVersionsSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return active scoring model version id
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoringModelVersionsSettingsId(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScoringModelVersionsSettingsId(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoringModelSettingsApi.getScoringModelVersionsSettingsId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScoringModelSettingsApi - factory interface
 */
export const ScoringModelSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScoringModelSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add new version
         * @param {ScoringModelSettingsApiAddNewVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewVersion(requestParameters: ScoringModelSettingsApiAddNewVersionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddNewVersionResponse> {
            return localVarFp.addNewVersion(requestParameters.id, requestParameters.versionId, requestParameters.addNewVersionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return internal scoring model by key
         * @param {ScoringModelSettingsApiGetInternalScoringModelByKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternalScoringModelByKey(requestParameters: ScoringModelSettingsApiGetInternalScoringModelByKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<InternalScoringModelDto> {
            return localVarFp.getInternalScoringModelByKey(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return scoring model settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelSettings(options?: RawAxiosRequestConfig): AxiosPromise<ScoringModelSettingsResponse> {
            return localVarFp.getScoringModelSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return scoring model version content by modelId
         * @param {ScoringModelSettingsApiGetScoringModelVersionContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionContent(requestParameters: ScoringModelSettingsApiGetScoringModelVersionContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScoringModelVersionContentResponse> {
            return localVarFp.getScoringModelVersionContent(requestParameters.id, requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return scoring model version settings by modelId
         * @param {ScoringModelSettingsApiGetScoringModelVersionSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionSettings(requestParameters: ScoringModelSettingsApiGetScoringModelVersionSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScoringModelVersionSettingsDto> {
            return localVarFp.getScoringModelVersionSettings(requestParameters.id, requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return scoring model versions settings by modelId
         * @param {ScoringModelSettingsApiGetScoringModelVersionsSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionsSettings(requestParameters: ScoringModelSettingsApiGetScoringModelVersionsSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageScoringModelVersionSettingsDto> {
            return localVarFp.getScoringModelVersionsSettings(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return active scoring model version id
         * @param {ScoringModelSettingsApiGetScoringModelVersionsSettingsIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionsSettingsId(requestParameters: ScoringModelSettingsApiGetScoringModelVersionsSettingsIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getScoringModelVersionsSettingsId(requestParameters.key, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addNewVersion operation in ScoringModelSettingsApi.
 */
export interface ScoringModelSettingsApiAddNewVersionRequest {
    readonly id: number

    readonly versionId: number

    readonly addNewVersionRequest: AddNewVersionRequest
}

/**
 * Request parameters for getInternalScoringModelByKey operation in ScoringModelSettingsApi.
 */
export interface ScoringModelSettingsApiGetInternalScoringModelByKeyRequest {
    readonly key: string
}

/**
 * Request parameters for getScoringModelVersionContent operation in ScoringModelSettingsApi.
 */
export interface ScoringModelSettingsApiGetScoringModelVersionContentRequest {
    readonly id: number

    readonly versionId: number
}

/**
 * Request parameters for getScoringModelVersionSettings operation in ScoringModelSettingsApi.
 */
export interface ScoringModelSettingsApiGetScoringModelVersionSettingsRequest {
    readonly id: number

    readonly versionId: number
}

/**
 * Request parameters for getScoringModelVersionsSettings operation in ScoringModelSettingsApi.
 */
export interface ScoringModelSettingsApiGetScoringModelVersionsSettingsRequest {
    readonly id: number

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for getScoringModelVersionsSettingsId operation in ScoringModelSettingsApi.
 */
export interface ScoringModelSettingsApiGetScoringModelVersionsSettingsIdRequest {
    readonly key: string
}

/**
 * ScoringModelSettingsApi - object-oriented interface
 */
export class ScoringModelSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Add new version
     * @param {ScoringModelSettingsApiAddNewVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addNewVersion(requestParameters: ScoringModelSettingsApiAddNewVersionRequest, options?: RawAxiosRequestConfig) {
        return ScoringModelSettingsApiFp(this.configuration).addNewVersion(requestParameters.id, requestParameters.versionId, requestParameters.addNewVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return internal scoring model by key
     * @param {ScoringModelSettingsApiGetInternalScoringModelByKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInternalScoringModelByKey(requestParameters: ScoringModelSettingsApiGetInternalScoringModelByKeyRequest, options?: RawAxiosRequestConfig) {
        return ScoringModelSettingsApiFp(this.configuration).getInternalScoringModelByKey(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return scoring model settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getScoringModelSettings(options?: RawAxiosRequestConfig) {
        return ScoringModelSettingsApiFp(this.configuration).getScoringModelSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return scoring model version content by modelId
     * @param {ScoringModelSettingsApiGetScoringModelVersionContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getScoringModelVersionContent(requestParameters: ScoringModelSettingsApiGetScoringModelVersionContentRequest, options?: RawAxiosRequestConfig) {
        return ScoringModelSettingsApiFp(this.configuration).getScoringModelVersionContent(requestParameters.id, requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return scoring model version settings by modelId
     * @param {ScoringModelSettingsApiGetScoringModelVersionSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getScoringModelVersionSettings(requestParameters: ScoringModelSettingsApiGetScoringModelVersionSettingsRequest, options?: RawAxiosRequestConfig) {
        return ScoringModelSettingsApiFp(this.configuration).getScoringModelVersionSettings(requestParameters.id, requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return scoring model versions settings by modelId
     * @param {ScoringModelSettingsApiGetScoringModelVersionsSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getScoringModelVersionsSettings(requestParameters: ScoringModelSettingsApiGetScoringModelVersionsSettingsRequest, options?: RawAxiosRequestConfig) {
        return ScoringModelSettingsApiFp(this.configuration).getScoringModelVersionsSettings(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return active scoring model version id
     * @param {ScoringModelSettingsApiGetScoringModelVersionsSettingsIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getScoringModelVersionsSettingsId(requestParameters: ScoringModelSettingsApiGetScoringModelVersionsSettingsIdRequest, options?: RawAxiosRequestConfig) {
        return ScoringModelSettingsApiFp(this.configuration).getScoringModelVersionsSettingsId(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TaskManagerApi - axios parameter creator
 */
export const TaskManagerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assign the task to current user if available.
         * @summary Claim a task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claim: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('claim', 'id', id)
            const localVarPath = `/api/task/{id}/claim`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the task form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve form for the task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskForm: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTaskForm', 'id', id)
            const localVarPath = `/api/task/{id}/form`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of task form variables of a latest process definition if allowed to access.
         * @summary Retrieve task form variables
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskFormVariables: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTaskFormVariables', 'id', id)
            const localVarPath = `/api/task/{id}/form-variables`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the task form JSON description in FormIO format with form variales as submission/data. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve form with data for the task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskFormWithData: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTaskFormWithData', 'id', id)
            const localVarPath = `/api/task/{id}/form-with-data`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve brief info for a single task if available.
         * @summary Get task info
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskInfo: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTaskInfo', 'id', id)
            const localVarPath = `/api/task/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List tasks assigned to a user performed the request
         * @summary List assigned tasks
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssigned: async (page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/task/assigned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List unassigned tasks where the user is a candidate for execution according to their keycloak roles. 
         * @summary List tasks available for claim
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailable: async (page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/task/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Complete the task by form submission if the user is assignee.
         * @summary Complete a task by form submission
         * @param {string} id Task id
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitForm: async (id: string, requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('submitForm', 'id', id)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('submitForm', 'requestBody', requestBody)
            const localVarPath = `/api/task/{id}/submit-form`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unassign the task from current user.
         * @summary Unclaim a task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unclaim: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unclaim', 'id', id)
            const localVarPath = `/api/task/{id}/unclaim`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskManagerApi - functional programming interface
 */
export const TaskManagerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskManagerApiAxiosParamCreator(configuration)
    return {
        /**
         * Assign the task to current user if available.
         * @summary Claim a task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claim(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claim(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.claim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the task form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve form for the task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskForm(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskForm(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.getTaskForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List of task form variables of a latest process definition if allowed to access.
         * @summary Retrieve task form variables
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskFormVariables(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskFormVariables(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.getTaskFormVariables']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the task form JSON description in FormIO format with form variales as submission/data. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve form with data for the task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskFormWithData(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskFormWithData(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.getTaskFormWithData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve brief info for a single task if available.
         * @summary Get task info
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskInfo(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskRepresentation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskInfo(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.getTaskInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List tasks assigned to a user performed the request
         * @summary List assigned tasks
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAssigned(page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTaskRepresentation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAssigned(page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.listAssigned']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List unassigned tasks where the user is a candidate for execution according to their keycloak roles. 
         * @summary List tasks available for claim
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAvailable(page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTaskRepresentation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAvailable(page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.listAvailable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Complete the task by form submission if the user is assignee.
         * @summary Complete a task by form submission
         * @param {string} id Task id
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitForm(id: string, requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskRepresentation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitForm(id, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.submitForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unassign the task from current user.
         * @summary Unclaim a task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unclaim(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unclaim(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.unclaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TaskManagerApi - factory interface
 */
export const TaskManagerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskManagerApiFp(configuration)
    return {
        /**
         * Assign the task to current user if available.
         * @summary Claim a task
         * @param {TaskManagerApiClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claim(requestParameters: TaskManagerApiClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.claim(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the task form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve form for the task
         * @param {TaskManagerApiGetTaskFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskForm(requestParameters: TaskManagerApiGetTaskFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getTaskForm(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * List of task form variables of a latest process definition if allowed to access.
         * @summary Retrieve task form variables
         * @param {TaskManagerApiGetTaskFormVariablesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskFormVariables(requestParameters: TaskManagerApiGetTaskFormVariablesRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getTaskFormVariables(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the task form JSON description in FormIO format with form variales as submission/data. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve form with data for the task
         * @param {TaskManagerApiGetTaskFormWithDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskFormWithData(requestParameters: TaskManagerApiGetTaskFormWithDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getTaskFormWithData(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve brief info for a single task if available.
         * @summary Get task info
         * @param {TaskManagerApiGetTaskInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskInfo(requestParameters: TaskManagerApiGetTaskInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskRepresentation> {
            return localVarFp.getTaskInfo(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * List tasks assigned to a user performed the request
         * @summary List assigned tasks
         * @param {TaskManagerApiListAssignedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssigned(requestParameters: TaskManagerApiListAssignedRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageTaskRepresentation> {
            return localVarFp.listAssigned(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * List unassigned tasks where the user is a candidate for execution according to their keycloak roles. 
         * @summary List tasks available for claim
         * @param {TaskManagerApiListAvailableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailable(requestParameters: TaskManagerApiListAvailableRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageTaskRepresentation> {
            return localVarFp.listAvailable(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Complete the task by form submission if the user is assignee.
         * @summary Complete a task by form submission
         * @param {TaskManagerApiSubmitFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitForm(requestParameters: TaskManagerApiSubmitFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskRepresentation>> {
            return localVarFp.submitForm(requestParameters.id, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Unassign the task from current user.
         * @summary Unclaim a task
         * @param {TaskManagerApiUnclaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unclaim(requestParameters: TaskManagerApiUnclaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unclaim(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for claim operation in TaskManagerApi.
 */
export interface TaskManagerApiClaimRequest {
    /**
     * Task id
     */
    readonly id: string
}

/**
 * Request parameters for getTaskForm operation in TaskManagerApi.
 */
export interface TaskManagerApiGetTaskFormRequest {
    /**
     * Task id
     */
    readonly id: string
}

/**
 * Request parameters for getTaskFormVariables operation in TaskManagerApi.
 */
export interface TaskManagerApiGetTaskFormVariablesRequest {
    /**
     * Task id
     */
    readonly id: string
}

/**
 * Request parameters for getTaskFormWithData operation in TaskManagerApi.
 */
export interface TaskManagerApiGetTaskFormWithDataRequest {
    /**
     * Task id
     */
    readonly id: string
}

/**
 * Request parameters for getTaskInfo operation in TaskManagerApi.
 */
export interface TaskManagerApiGetTaskInfoRequest {
    /**
     * Task id
     */
    readonly id: string
}

/**
 * Request parameters for listAssigned operation in TaskManagerApi.
 */
export interface TaskManagerApiListAssignedRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for listAvailable operation in TaskManagerApi.
 */
export interface TaskManagerApiListAvailableRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for submitForm operation in TaskManagerApi.
 */
export interface TaskManagerApiSubmitFormRequest {
    /**
     * Task id
     */
    readonly id: string

    readonly requestBody: { [key: string]: any; }
}

/**
 * Request parameters for unclaim operation in TaskManagerApi.
 */
export interface TaskManagerApiUnclaimRequest {
    /**
     * Task id
     */
    readonly id: string
}

/**
 * TaskManagerApi - object-oriented interface
 */
export class TaskManagerApi extends BaseAPI {
    /**
     * Assign the task to current user if available.
     * @summary Claim a task
     * @param {TaskManagerApiClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public claim(requestParameters: TaskManagerApiClaimRequest, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).claim(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the task form JSON description in FormIO format. Embedded forms are expanded in single form.
     * @summary Retrieve form for the task
     * @param {TaskManagerApiGetTaskFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTaskForm(requestParameters: TaskManagerApiGetTaskFormRequest, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).getTaskForm(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of task form variables of a latest process definition if allowed to access.
     * @summary Retrieve task form variables
     * @param {TaskManagerApiGetTaskFormVariablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTaskFormVariables(requestParameters: TaskManagerApiGetTaskFormVariablesRequest, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).getTaskFormVariables(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the task form JSON description in FormIO format with form variales as submission/data. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
     * @summary Retrieve form with data for the task
     * @param {TaskManagerApiGetTaskFormWithDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTaskFormWithData(requestParameters: TaskManagerApiGetTaskFormWithDataRequest, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).getTaskFormWithData(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve brief info for a single task if available.
     * @summary Get task info
     * @param {TaskManagerApiGetTaskInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTaskInfo(requestParameters: TaskManagerApiGetTaskInfoRequest, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).getTaskInfo(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List tasks assigned to a user performed the request
     * @summary List assigned tasks
     * @param {TaskManagerApiListAssignedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAssigned(requestParameters: TaskManagerApiListAssignedRequest = {}, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).listAssigned(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List unassigned tasks where the user is a candidate for execution according to their keycloak roles. 
     * @summary List tasks available for claim
     * @param {TaskManagerApiListAvailableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAvailable(requestParameters: TaskManagerApiListAvailableRequest = {}, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).listAvailable(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Complete the task by form submission if the user is assignee.
     * @summary Complete a task by form submission
     * @param {TaskManagerApiSubmitFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitForm(requestParameters: TaskManagerApiSubmitFormRequest, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).submitForm(requestParameters.id, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unassign the task from current user.
     * @summary Unclaim a task
     * @param {TaskManagerApiUnclaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unclaim(requestParameters: TaskManagerApiUnclaimRequest, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).unclaim(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TransactionApi - axios parameter creator
 */
export const TransactionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan\'s transactions
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByLoanId: async (id: number, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findAllByLoanId', 'id', id)
            const localVarPath = `/api/transactions/loan/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns list of transactions
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterTypes] Search by transaction types
         * @param {Array<string>} [filterStatuses] Search by transaction statuses
         * @param {string} [filterCreatedAtFrom] Search by transaction created at from
         * @param {string} [filterCreatedAtTo] Search by transaction created at to
         * @param {string} [filterProcessedAtFrom] Search by transaction processed at from
         * @param {string} [filterProcessedAtTo] Search by transaction processed at to
         * @param {string} [filterSearch] Search by transaction id, external transaction id; loan number; borrower\&#39;s full name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTransactions: async (page?: number, size?: number, sort?: Array<string>, filterTypes?: Array<string>, filterStatuses?: Array<string>, filterCreatedAtFrom?: string, filterCreatedAtTo?: string, filterProcessedAtFrom?: string, filterProcessedAtTo?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterTypes) {
                localVarQueryParameter['filter.types'] = filterTypes;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterCreatedAtFrom !== undefined) {
                localVarQueryParameter['filter.createdAtFrom'] = (filterCreatedAtFrom as any instanceof Date) ?
                    (filterCreatedAtFrom as any).toISOString() :
                    filterCreatedAtFrom;
            }

            if (filterCreatedAtTo !== undefined) {
                localVarQueryParameter['filter.createdAtTo'] = (filterCreatedAtTo as any instanceof Date) ?
                    (filterCreatedAtTo as any).toISOString() :
                    filterCreatedAtTo;
            }

            if (filterProcessedAtFrom !== undefined) {
                localVarQueryParameter['filter.processedAtFrom'] = (filterProcessedAtFrom as any instanceof Date) ?
                    (filterProcessedAtFrom as any).toISOString() :
                    filterProcessedAtFrom;
            }

            if (filterProcessedAtTo !== undefined) {
                localVarQueryParameter['filter.processedAtTo'] = (filterProcessedAtTo as any instanceof Date) ?
                    (filterProcessedAtTo as any).toISOString() :
                    filterProcessedAtTo;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single transaction
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaction: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTransaction', 'id', id)
            const localVarPath = `/api/transactions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionApi - functional programming interface
 */
export const TransactionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of loan\'s transactions
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByLoanId(id: number, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTransactionDtoBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllByLoanId(id, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionApi.findAllByLoanId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns list of transactions
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterTypes] Search by transaction types
         * @param {Array<string>} [filterStatuses] Search by transaction statuses
         * @param {string} [filterCreatedAtFrom] Search by transaction created at from
         * @param {string} [filterCreatedAtTo] Search by transaction created at to
         * @param {string} [filterProcessedAtFrom] Search by transaction processed at from
         * @param {string} [filterProcessedAtTo] Search by transaction processed at to
         * @param {string} [filterSearch] Search by transaction id, external transaction id; loan number; borrower\&#39;s full name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllTransactions(page?: number, size?: number, sort?: Array<string>, filterTypes?: Array<string>, filterStatuses?: Array<string>, filterCreatedAtFrom?: string, filterCreatedAtTo?: string, filterProcessedAtFrom?: string, filterProcessedAtTo?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTransactionDtoBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllTransactions(page, size, sort, filterTypes, filterStatuses, filterCreatedAtFrom, filterCreatedAtTo, filterProcessedAtFrom, filterProcessedAtTo, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionApi.findAllTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return single transaction
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransaction(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransaction(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionApi.getTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransactionApi - factory interface
 */
export const TransactionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of loan\'s transactions
         * @param {TransactionApiFindAllByLoanIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByLoanId(requestParameters: TransactionApiFindAllByLoanIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageTransactionDtoBrief> {
            return localVarFp.findAllByLoanId(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns list of transactions
         * @param {TransactionApiFindAllTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTransactions(requestParameters: TransactionApiFindAllTransactionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageTransactionDtoBrief> {
            return localVarFp.findAllTransactions(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterTypes, requestParameters.filterStatuses, requestParameters.filterCreatedAtFrom, requestParameters.filterCreatedAtTo, requestParameters.filterProcessedAtFrom, requestParameters.filterProcessedAtTo, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single transaction
         * @param {TransactionApiGetTransactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaction(requestParameters: TransactionApiGetTransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<TransactionDto> {
            return localVarFp.getTransaction(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAllByLoanId operation in TransactionApi.
 */
export interface TransactionApiFindAllByLoanIdRequest {
    readonly id: number

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for findAllTransactions operation in TransactionApi.
 */
export interface TransactionApiFindAllTransactionsRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Search by transaction types
     */
    readonly filterTypes?: Array<string>

    /**
     * Search by transaction statuses
     */
    readonly filterStatuses?: Array<string>

    /**
     * Search by transaction created at from
     */
    readonly filterCreatedAtFrom?: string

    /**
     * Search by transaction created at to
     */
    readonly filterCreatedAtTo?: string

    /**
     * Search by transaction processed at from
     */
    readonly filterProcessedAtFrom?: string

    /**
     * Search by transaction processed at to
     */
    readonly filterProcessedAtTo?: string

    /**
     * Search by transaction id, external transaction id; loan number; borrower\&#39;s full name
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for getTransaction operation in TransactionApi.
 */
export interface TransactionApiGetTransactionRequest {
    readonly id: number
}

/**
 * TransactionApi - object-oriented interface
 */
export class TransactionApi extends BaseAPI {
    /**
     * 
     * @summary Return list of loan\'s transactions
     * @param {TransactionApiFindAllByLoanIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllByLoanId(requestParameters: TransactionApiFindAllByLoanIdRequest, options?: RawAxiosRequestConfig) {
        return TransactionApiFp(this.configuration).findAllByLoanId(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns list of transactions
     * @param {TransactionApiFindAllTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllTransactions(requestParameters: TransactionApiFindAllTransactionsRequest = {}, options?: RawAxiosRequestConfig) {
        return TransactionApiFp(this.configuration).findAllTransactions(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterTypes, requestParameters.filterStatuses, requestParameters.filterCreatedAtFrom, requestParameters.filterCreatedAtTo, requestParameters.filterProcessedAtFrom, requestParameters.filterProcessedAtTo, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single transaction
     * @param {TransactionApiGetTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTransaction(requestParameters: TransactionApiGetTransactionRequest, options?: RawAxiosRequestConfig) {
        return TransactionApiFp(this.configuration).getTransaction(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UISettingsApi - axios parameter creator
 */
export const UISettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ui-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication ondato required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ondato", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication jumio required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "jumio", [], configuration)

            // authentication equifax required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "equifax", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            // authentication debt-collection-system required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "debt-collection-system", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UISettingsApi - functional programming interface
 */
export const UISettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UISettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UiConfigurations>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UISettingsApi.getSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UISettingsApi - factory interface
 */
export const UISettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UISettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(options?: RawAxiosRequestConfig): AxiosPromise<Array<UiConfigurations>> {
            return localVarFp.getSettings(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UISettingsApi - object-oriented interface
 */
export class UISettingsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSettings(options?: RawAxiosRequestConfig) {
        return UISettingsApiFp(this.configuration).getSettings(options).then((request) => request(this.axios, this.basePath));
    }
}



